/* eslint-disable */
/*eslint-disable*/
import * as $protobuf from "protobufjs/minimal";

// Common aliases
const $Reader = $protobuf.Reader, $Writer = $protobuf.Writer, $util = $protobuf.util;

// Exported root namespace
const $root = $protobuf.roots.wallet || ($protobuf.roots.wallet = {});

export const walletpb = $root.walletpb = (() => {

    /**
     * Namespace walletpb.
     * @exports walletpb
     * @namespace
     */
    const walletpb = {};

    walletpb.PaymentMethod = (function() {

        /**
         * Properties of a PaymentMethod.
         * @memberof walletpb
         * @interface IPaymentMethod
         * @property {boolean|null} ["default"] PaymentMethod default
         * @property {walletpb.IPaymentMethodDetails|null} [details] PaymentMethod details
         * @property {Array.<walletpb.IDataStore>|null} [dataStore] PaymentMethod dataStore
         * @property {string|null} [starID] PaymentMethod starID
         * @property {string|null} [paymentsMsID] PaymentMethod paymentsMsID
         * @property {string|null} [paymentMethodsMsID] PaymentMethod paymentMethodsMsID
         * @property {boolean|null} [selectable] PaymentMethod selectable
         */

        /**
         * Constructs a new PaymentMethod.
         * @memberof walletpb
         * @classdesc Represents a PaymentMethod.
         * @implements IPaymentMethod
         * @constructor
         * @param {walletpb.IPaymentMethod=} [p] Properties to set
         */
        function PaymentMethod(p) {
            this.dataStore = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * PaymentMethod default.
         * @member {boolean} default
         * @memberof walletpb.PaymentMethod
         * @instance
         */
        PaymentMethod.prototype["default"] = false;

        /**
         * PaymentMethod details.
         * @member {walletpb.IPaymentMethodDetails|null|undefined} details
         * @memberof walletpb.PaymentMethod
         * @instance
         */
        PaymentMethod.prototype.details = null;

        /**
         * PaymentMethod dataStore.
         * @member {Array.<walletpb.IDataStore>} dataStore
         * @memberof walletpb.PaymentMethod
         * @instance
         */
        PaymentMethod.prototype.dataStore = $util.emptyArray;

        /**
         * PaymentMethod starID.
         * @member {string} starID
         * @memberof walletpb.PaymentMethod
         * @instance
         */
        PaymentMethod.prototype.starID = "";

        /**
         * PaymentMethod paymentsMsID.
         * @member {string} paymentsMsID
         * @memberof walletpb.PaymentMethod
         * @instance
         */
        PaymentMethod.prototype.paymentsMsID = "";

        /**
         * PaymentMethod paymentMethodsMsID.
         * @member {string} paymentMethodsMsID
         * @memberof walletpb.PaymentMethod
         * @instance
         */
        PaymentMethod.prototype.paymentMethodsMsID = "";

        /**
         * PaymentMethod selectable.
         * @member {boolean} selectable
         * @memberof walletpb.PaymentMethod
         * @instance
         */
        PaymentMethod.prototype.selectable = false;

        /**
         * Creates a new PaymentMethod instance using the specified properties.
         * @function create
         * @memberof walletpb.PaymentMethod
         * @static
         * @param {walletpb.IPaymentMethod=} [properties] Properties to set
         * @returns {walletpb.PaymentMethod} PaymentMethod instance
         */
        PaymentMethod.create = function create(properties) {
            return new PaymentMethod(properties);
        };

        /**
         * Encodes the specified PaymentMethod message. Does not implicitly {@link walletpb.PaymentMethod.verify|verify} messages.
         * @function encode
         * @memberof walletpb.PaymentMethod
         * @static
         * @param {walletpb.IPaymentMethod} m PaymentMethod message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        PaymentMethod.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m["default"] != null && Object.hasOwnProperty.call(m, "default"))
                w.uint32(8).bool(m["default"]);
            if (m.details != null && Object.hasOwnProperty.call(m, "details"))
                $root.walletpb.PaymentMethodDetails.encode(m.details, w.uint32(18).fork()).ldelim();
            if (m.dataStore != null && m.dataStore.length) {
                for (var i = 0; i < m.dataStore.length; ++i)
                    $root.walletpb.DataStore.encode(m.dataStore[i], w.uint32(26).fork()).ldelim();
            }
            if (m.starID != null && Object.hasOwnProperty.call(m, "starID"))
                w.uint32(34).string(m.starID);
            if (m.paymentsMsID != null && Object.hasOwnProperty.call(m, "paymentsMsID"))
                w.uint32(42).string(m.paymentsMsID);
            if (m.paymentMethodsMsID != null && Object.hasOwnProperty.call(m, "paymentMethodsMsID"))
                w.uint32(50).string(m.paymentMethodsMsID);
            if (m.selectable != null && Object.hasOwnProperty.call(m, "selectable"))
                w.uint32(56).bool(m.selectable);
            return w;
        };

        /**
         * Decodes a PaymentMethod message from the specified reader or buffer.
         * @function decode
         * @memberof walletpb.PaymentMethod
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {walletpb.PaymentMethod} PaymentMethod
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        PaymentMethod.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.walletpb.PaymentMethod();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m["default"] = r.bool();
                    break;
                case 2:
                    m.details = $root.walletpb.PaymentMethodDetails.decode(r, r.uint32());
                    break;
                case 3:
                    if (!(m.dataStore && m.dataStore.length))
                        m.dataStore = [];
                    m.dataStore.push($root.walletpb.DataStore.decode(r, r.uint32()));
                    break;
                case 4:
                    m.starID = r.string();
                    break;
                case 5:
                    m.paymentsMsID = r.string();
                    break;
                case 6:
                    m.paymentMethodsMsID = r.string();
                    break;
                case 7:
                    m.selectable = r.bool();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return PaymentMethod;
    })();

    walletpb.PaymentMethodDetails = (function() {

        /**
         * Properties of a PaymentMethodDetails.
         * @memberof walletpb
         * @interface IPaymentMethodDetails
         * @property {walletpb.PaymentMethodType|null} [type] PaymentMethodDetails type
         * @property {walletpb.ICreditCardDetails|null} [cc] PaymentMethodDetails cc
         * @property {walletpb.IACHDetails|null} [ach] PaymentMethodDetails ach
         * @property {walletpb.IPaypalDetails|null} [pp] PaymentMethodDetails pp
         */

        /**
         * Constructs a new PaymentMethodDetails.
         * @memberof walletpb
         * @classdesc Represents a PaymentMethodDetails.
         * @implements IPaymentMethodDetails
         * @constructor
         * @param {walletpb.IPaymentMethodDetails=} [p] Properties to set
         */
        function PaymentMethodDetails(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * PaymentMethodDetails type.
         * @member {walletpb.PaymentMethodType} type
         * @memberof walletpb.PaymentMethodDetails
         * @instance
         */
        PaymentMethodDetails.prototype.type = 0;

        /**
         * PaymentMethodDetails cc.
         * @member {walletpb.ICreditCardDetails|null|undefined} cc
         * @memberof walletpb.PaymentMethodDetails
         * @instance
         */
        PaymentMethodDetails.prototype.cc = null;

        /**
         * PaymentMethodDetails ach.
         * @member {walletpb.IACHDetails|null|undefined} ach
         * @memberof walletpb.PaymentMethodDetails
         * @instance
         */
        PaymentMethodDetails.prototype.ach = null;

        /**
         * PaymentMethodDetails pp.
         * @member {walletpb.IPaypalDetails|null|undefined} pp
         * @memberof walletpb.PaymentMethodDetails
         * @instance
         */
        PaymentMethodDetails.prototype.pp = null;

        // OneOf field names bound to virtual getters and setters
        let $oneOfFields;

        /**
         * PaymentMethodDetails details.
         * @member {"cc"|"ach"|"pp"|undefined} details
         * @memberof walletpb.PaymentMethodDetails
         * @instance
         */
        Object.defineProperty(PaymentMethodDetails.prototype, "details", {
            get: $util.oneOfGetter($oneOfFields = ["cc", "ach", "pp"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Creates a new PaymentMethodDetails instance using the specified properties.
         * @function create
         * @memberof walletpb.PaymentMethodDetails
         * @static
         * @param {walletpb.IPaymentMethodDetails=} [properties] Properties to set
         * @returns {walletpb.PaymentMethodDetails} PaymentMethodDetails instance
         */
        PaymentMethodDetails.create = function create(properties) {
            return new PaymentMethodDetails(properties);
        };

        /**
         * Encodes the specified PaymentMethodDetails message. Does not implicitly {@link walletpb.PaymentMethodDetails.verify|verify} messages.
         * @function encode
         * @memberof walletpb.PaymentMethodDetails
         * @static
         * @param {walletpb.IPaymentMethodDetails} m PaymentMethodDetails message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        PaymentMethodDetails.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.type != null && Object.hasOwnProperty.call(m, "type"))
                w.uint32(800).int32(m.type);
            if (m.cc != null && Object.hasOwnProperty.call(m, "cc"))
                $root.walletpb.CreditCardDetails.encode(m.cc, w.uint32(810).fork()).ldelim();
            if (m.ach != null && Object.hasOwnProperty.call(m, "ach"))
                $root.walletpb.ACHDetails.encode(m.ach, w.uint32(818).fork()).ldelim();
            if (m.pp != null && Object.hasOwnProperty.call(m, "pp"))
                $root.walletpb.PaypalDetails.encode(m.pp, w.uint32(826).fork()).ldelim();
            return w;
        };

        /**
         * Decodes a PaymentMethodDetails message from the specified reader or buffer.
         * @function decode
         * @memberof walletpb.PaymentMethodDetails
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {walletpb.PaymentMethodDetails} PaymentMethodDetails
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        PaymentMethodDetails.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.walletpb.PaymentMethodDetails();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 100:
                    m.type = r.int32();
                    break;
                case 101:
                    m.cc = $root.walletpb.CreditCardDetails.decode(r, r.uint32());
                    break;
                case 102:
                    m.ach = $root.walletpb.ACHDetails.decode(r, r.uint32());
                    break;
                case 103:
                    m.pp = $root.walletpb.PaypalDetails.decode(r, r.uint32());
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return PaymentMethodDetails;
    })();

    /**
     * PaymentMethodType enum.
     * @name walletpb.PaymentMethodType
     * @enum {number}
     * @property {number} Undefined_PaymentMethodType=0 Undefined_PaymentMethodType value
     * @property {number} CreditCard=1 CreditCard value
     * @property {number} ACH=2 ACH value
     * @property {number} Paypal=3 Paypal value
     */
    walletpb.PaymentMethodType = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "Undefined_PaymentMethodType"] = 0;
        values[valuesById[1] = "CreditCard"] = 1;
        values[valuesById[2] = "ACH"] = 2;
        values[valuesById[3] = "Paypal"] = 3;
        return values;
    })();

    walletpb.CreditCardDetails = (function() {

        /**
         * Properties of a CreditCardDetails.
         * @memberof walletpb
         * @interface ICreditCardDetails
         * @property {string|null} [last4] CreditCardDetails last4
         * @property {common.IDate|null} [expirationDate] CreditCardDetails expirationDate
         * @property {walletpb.CreditCardBrand|null} [brand] CreditCardDetails brand
         * @property {string|null} [country] CreditCardDetails country
         * @property {walletpb.TokenType|null} [tokenType] CreditCardDetails tokenType
         */

        /**
         * Constructs a new CreditCardDetails.
         * @memberof walletpb
         * @classdesc Represents a CreditCardDetails.
         * @implements ICreditCardDetails
         * @constructor
         * @param {walletpb.ICreditCardDetails=} [p] Properties to set
         */
        function CreditCardDetails(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * CreditCardDetails last4.
         * @member {string} last4
         * @memberof walletpb.CreditCardDetails
         * @instance
         */
        CreditCardDetails.prototype.last4 = "";

        /**
         * CreditCardDetails expirationDate.
         * @member {common.IDate|null|undefined} expirationDate
         * @memberof walletpb.CreditCardDetails
         * @instance
         */
        CreditCardDetails.prototype.expirationDate = null;

        /**
         * CreditCardDetails brand.
         * @member {walletpb.CreditCardBrand} brand
         * @memberof walletpb.CreditCardDetails
         * @instance
         */
        CreditCardDetails.prototype.brand = 0;

        /**
         * CreditCardDetails country.
         * @member {string} country
         * @memberof walletpb.CreditCardDetails
         * @instance
         */
        CreditCardDetails.prototype.country = "";

        /**
         * CreditCardDetails tokenType.
         * @member {walletpb.TokenType} tokenType
         * @memberof walletpb.CreditCardDetails
         * @instance
         */
        CreditCardDetails.prototype.tokenType = 0;

        /**
         * Creates a new CreditCardDetails instance using the specified properties.
         * @function create
         * @memberof walletpb.CreditCardDetails
         * @static
         * @param {walletpb.ICreditCardDetails=} [properties] Properties to set
         * @returns {walletpb.CreditCardDetails} CreditCardDetails instance
         */
        CreditCardDetails.create = function create(properties) {
            return new CreditCardDetails(properties);
        };

        /**
         * Encodes the specified CreditCardDetails message. Does not implicitly {@link walletpb.CreditCardDetails.verify|verify} messages.
         * @function encode
         * @memberof walletpb.CreditCardDetails
         * @static
         * @param {walletpb.ICreditCardDetails} m CreditCardDetails message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CreditCardDetails.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.last4 != null && Object.hasOwnProperty.call(m, "last4"))
                w.uint32(10).string(m.last4);
            if (m.expirationDate != null && Object.hasOwnProperty.call(m, "expirationDate"))
                $root.common.Date.encode(m.expirationDate, w.uint32(18).fork()).ldelim();
            if (m.brand != null && Object.hasOwnProperty.call(m, "brand"))
                w.uint32(24).int32(m.brand);
            if (m.country != null && Object.hasOwnProperty.call(m, "country"))
                w.uint32(34).string(m.country);
            if (m.tokenType != null && Object.hasOwnProperty.call(m, "tokenType"))
                w.uint32(40).int32(m.tokenType);
            return w;
        };

        /**
         * Decodes a CreditCardDetails message from the specified reader or buffer.
         * @function decode
         * @memberof walletpb.CreditCardDetails
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {walletpb.CreditCardDetails} CreditCardDetails
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CreditCardDetails.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.walletpb.CreditCardDetails();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.last4 = r.string();
                    break;
                case 2:
                    m.expirationDate = $root.common.Date.decode(r, r.uint32());
                    break;
                case 3:
                    m.brand = r.int32();
                    break;
                case 4:
                    m.country = r.string();
                    break;
                case 5:
                    m.tokenType = r.int32();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return CreditCardDetails;
    })();

    walletpb.ACHDetails = (function() {

        /**
         * Properties of a ACHDetails.
         * @memberof walletpb
         * @interface IACHDetails
         * @property {string|null} [accountNumber] ACHDetails accountNumber
         * @property {string|null} [routingNumber] ACHDetails routingNumber
         * @property {walletpb.TokenType|null} [tokenType] ACHDetails tokenType
         */

        /**
         * Constructs a new ACHDetails.
         * @memberof walletpb
         * @classdesc Represents a ACHDetails.
         * @implements IACHDetails
         * @constructor
         * @param {walletpb.IACHDetails=} [p] Properties to set
         */
        function ACHDetails(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * ACHDetails accountNumber.
         * @member {string} accountNumber
         * @memberof walletpb.ACHDetails
         * @instance
         */
        ACHDetails.prototype.accountNumber = "";

        /**
         * ACHDetails routingNumber.
         * @member {string} routingNumber
         * @memberof walletpb.ACHDetails
         * @instance
         */
        ACHDetails.prototype.routingNumber = "";

        /**
         * ACHDetails tokenType.
         * @member {walletpb.TokenType} tokenType
         * @memberof walletpb.ACHDetails
         * @instance
         */
        ACHDetails.prototype.tokenType = 0;

        /**
         * Creates a new ACHDetails instance using the specified properties.
         * @function create
         * @memberof walletpb.ACHDetails
         * @static
         * @param {walletpb.IACHDetails=} [properties] Properties to set
         * @returns {walletpb.ACHDetails} ACHDetails instance
         */
        ACHDetails.create = function create(properties) {
            return new ACHDetails(properties);
        };

        /**
         * Encodes the specified ACHDetails message. Does not implicitly {@link walletpb.ACHDetails.verify|verify} messages.
         * @function encode
         * @memberof walletpb.ACHDetails
         * @static
         * @param {walletpb.IACHDetails} m ACHDetails message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ACHDetails.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.accountNumber != null && Object.hasOwnProperty.call(m, "accountNumber"))
                w.uint32(10).string(m.accountNumber);
            if (m.routingNumber != null && Object.hasOwnProperty.call(m, "routingNumber"))
                w.uint32(18).string(m.routingNumber);
            if (m.tokenType != null && Object.hasOwnProperty.call(m, "tokenType"))
                w.uint32(24).int32(m.tokenType);
            return w;
        };

        /**
         * Decodes a ACHDetails message from the specified reader or buffer.
         * @function decode
         * @memberof walletpb.ACHDetails
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {walletpb.ACHDetails} ACHDetails
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ACHDetails.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.walletpb.ACHDetails();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.accountNumber = r.string();
                    break;
                case 2:
                    m.routingNumber = r.string();
                    break;
                case 3:
                    m.tokenType = r.int32();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return ACHDetails;
    })();

    walletpb.PaypalDetails = (function() {

        /**
         * Properties of a PaypalDetails.
         * @memberof walletpb
         * @interface IPaypalDetails
         * @property {string|null} [email] PaypalDetails email
         * @property {walletpb.TokenType|null} [tokenType] PaypalDetails tokenType
         */

        /**
         * Constructs a new PaypalDetails.
         * @memberof walletpb
         * @classdesc Represents a PaypalDetails.
         * @implements IPaypalDetails
         * @constructor
         * @param {walletpb.IPaypalDetails=} [p] Properties to set
         */
        function PaypalDetails(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * PaypalDetails email.
         * @member {string} email
         * @memberof walletpb.PaypalDetails
         * @instance
         */
        PaypalDetails.prototype.email = "";

        /**
         * PaypalDetails tokenType.
         * @member {walletpb.TokenType} tokenType
         * @memberof walletpb.PaypalDetails
         * @instance
         */
        PaypalDetails.prototype.tokenType = 0;

        /**
         * Creates a new PaypalDetails instance using the specified properties.
         * @function create
         * @memberof walletpb.PaypalDetails
         * @static
         * @param {walletpb.IPaypalDetails=} [properties] Properties to set
         * @returns {walletpb.PaypalDetails} PaypalDetails instance
         */
        PaypalDetails.create = function create(properties) {
            return new PaypalDetails(properties);
        };

        /**
         * Encodes the specified PaypalDetails message. Does not implicitly {@link walletpb.PaypalDetails.verify|verify} messages.
         * @function encode
         * @memberof walletpb.PaypalDetails
         * @static
         * @param {walletpb.IPaypalDetails} m PaypalDetails message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        PaypalDetails.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.email != null && Object.hasOwnProperty.call(m, "email"))
                w.uint32(10).string(m.email);
            if (m.tokenType != null && Object.hasOwnProperty.call(m, "tokenType"))
                w.uint32(16).int32(m.tokenType);
            return w;
        };

        /**
         * Decodes a PaypalDetails message from the specified reader or buffer.
         * @function decode
         * @memberof walletpb.PaypalDetails
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {walletpb.PaypalDetails} PaypalDetails
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        PaypalDetails.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.walletpb.PaypalDetails();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.email = r.string();
                    break;
                case 2:
                    m.tokenType = r.int32();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return PaypalDetails;
    })();

    /**
     * CreditCardBrand enum.
     * @name walletpb.CreditCardBrand
     * @enum {number}
     * @property {number} Undefined_Brand=0 Undefined_Brand value
     * @property {number} AmericanExpress=10 AmericanExpress value
     * @property {number} DinersClub=20 DinersClub value
     * @property {number} Discover=30 Discover value
     * @property {number} JCB=40 JCB value
     * @property {number} MasterCard=50 MasterCard value
     * @property {number} UnionPay=60 UnionPay value
     * @property {number} Visa=70 Visa value
     */
    walletpb.CreditCardBrand = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "Undefined_Brand"] = 0;
        values[valuesById[10] = "AmericanExpress"] = 10;
        values[valuesById[20] = "DinersClub"] = 20;
        values[valuesById[30] = "Discover"] = 30;
        values[valuesById[40] = "JCB"] = 40;
        values[valuesById[50] = "MasterCard"] = 50;
        values[valuesById[60] = "UnionPay"] = 60;
        values[valuesById[70] = "Visa"] = 70;
        return values;
    })();

    /**
     * TokenType enum.
     * @name walletpb.TokenType
     * @enum {number}
     * @property {number} Undefined_Token=0 Undefined_Token value
     * @property {number} Vantiv=1 Vantiv value
     * @property {number} Stripe=2 Stripe value
     * @property {number} Paymentus=3 Paymentus value
     * @property {number} Braintree=4 Braintree value
     */
    walletpb.TokenType = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "Undefined_Token"] = 0;
        values[valuesById[1] = "Vantiv"] = 1;
        values[valuesById[2] = "Stripe"] = 2;
        values[valuesById[3] = "Paymentus"] = 3;
        values[valuesById[4] = "Braintree"] = 4;
        return values;
    })();

    walletpb.DataStore = (function() {

        /**
         * Properties of a DataStore.
         * @memberof walletpb
         * @interface IDataStore
         * @property {walletpb.DataLocation|null} [dataLocation] DataStore dataLocation
         * @property {string|null} [id] DataStore id
         */

        /**
         * Constructs a new DataStore.
         * @memberof walletpb
         * @classdesc Represents a DataStore.
         * @implements IDataStore
         * @constructor
         * @param {walletpb.IDataStore=} [p] Properties to set
         */
        function DataStore(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * DataStore dataLocation.
         * @member {walletpb.DataLocation} dataLocation
         * @memberof walletpb.DataStore
         * @instance
         */
        DataStore.prototype.dataLocation = 0;

        /**
         * DataStore id.
         * @member {string} id
         * @memberof walletpb.DataStore
         * @instance
         */
        DataStore.prototype.id = "";

        /**
         * Creates a new DataStore instance using the specified properties.
         * @function create
         * @memberof walletpb.DataStore
         * @static
         * @param {walletpb.IDataStore=} [properties] Properties to set
         * @returns {walletpb.DataStore} DataStore instance
         */
        DataStore.create = function create(properties) {
            return new DataStore(properties);
        };

        /**
         * Encodes the specified DataStore message. Does not implicitly {@link walletpb.DataStore.verify|verify} messages.
         * @function encode
         * @memberof walletpb.DataStore
         * @static
         * @param {walletpb.IDataStore} m DataStore message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        DataStore.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.dataLocation != null && Object.hasOwnProperty.call(m, "dataLocation"))
                w.uint32(8).int32(m.dataLocation);
            if (m.id != null && Object.hasOwnProperty.call(m, "id"))
                w.uint32(18).string(m.id);
            return w;
        };

        /**
         * Decodes a DataStore message from the specified reader or buffer.
         * @function decode
         * @memberof walletpb.DataStore
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {walletpb.DataStore} DataStore
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        DataStore.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.walletpb.DataStore();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.dataLocation = r.int32();
                    break;
                case 2:
                    m.id = r.string();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return DataStore;
    })();

    /**
     * DataLocation enum.
     * @name walletpb.DataLocation
     * @enum {number}
     * @property {number} Undefined_Location=0 Undefined_Location value
     * @property {number} Star=1 Star value
     * @property {number} PaymentsMS=2 PaymentsMS value
     * @property {number} PaymentMethodsMS=3 PaymentMethodsMS value
     */
    walletpb.DataLocation = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "Undefined_Location"] = 0;
        values[valuesById[1] = "Star"] = 1;
        values[valuesById[2] = "PaymentsMS"] = 2;
        values[valuesById[3] = "PaymentMethodsMS"] = 3;
        return values;
    })();

    walletpb.GetPaymentMethodsRequest = (function() {

        /**
         * Properties of a GetPaymentMethodsRequest.
         * @memberof walletpb
         * @interface IGetPaymentMethodsRequest
         * @property {number|null} [deprecatedContractID] GetPaymentMethodsRequest deprecatedContractID
         * @property {number|null} [deprecatedCustomerID] GetPaymentMethodsRequest deprecatedCustomerID
         * @property {string|null} [contractID] GetPaymentMethodsRequest contractID
         * @property {string|null} [customerID] GetPaymentMethodsRequest customerID
         */

        /**
         * Constructs a new GetPaymentMethodsRequest.
         * @memberof walletpb
         * @classdesc Represents a GetPaymentMethodsRequest.
         * @implements IGetPaymentMethodsRequest
         * @constructor
         * @param {walletpb.IGetPaymentMethodsRequest=} [p] Properties to set
         */
        function GetPaymentMethodsRequest(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * GetPaymentMethodsRequest deprecatedContractID.
         * @member {number} deprecatedContractID
         * @memberof walletpb.GetPaymentMethodsRequest
         * @instance
         */
        GetPaymentMethodsRequest.prototype.deprecatedContractID = 0;

        /**
         * GetPaymentMethodsRequest deprecatedCustomerID.
         * @member {number} deprecatedCustomerID
         * @memberof walletpb.GetPaymentMethodsRequest
         * @instance
         */
        GetPaymentMethodsRequest.prototype.deprecatedCustomerID = 0;

        /**
         * GetPaymentMethodsRequest contractID.
         * @member {string} contractID
         * @memberof walletpb.GetPaymentMethodsRequest
         * @instance
         */
        GetPaymentMethodsRequest.prototype.contractID = "";

        /**
         * GetPaymentMethodsRequest customerID.
         * @member {string} customerID
         * @memberof walletpb.GetPaymentMethodsRequest
         * @instance
         */
        GetPaymentMethodsRequest.prototype.customerID = "";

        /**
         * Creates a new GetPaymentMethodsRequest instance using the specified properties.
         * @function create
         * @memberof walletpb.GetPaymentMethodsRequest
         * @static
         * @param {walletpb.IGetPaymentMethodsRequest=} [properties] Properties to set
         * @returns {walletpb.GetPaymentMethodsRequest} GetPaymentMethodsRequest instance
         */
        GetPaymentMethodsRequest.create = function create(properties) {
            return new GetPaymentMethodsRequest(properties);
        };

        /**
         * Encodes the specified GetPaymentMethodsRequest message. Does not implicitly {@link walletpb.GetPaymentMethodsRequest.verify|verify} messages.
         * @function encode
         * @memberof walletpb.GetPaymentMethodsRequest
         * @static
         * @param {walletpb.IGetPaymentMethodsRequest} m GetPaymentMethodsRequest message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GetPaymentMethodsRequest.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.deprecatedContractID != null && Object.hasOwnProperty.call(m, "deprecatedContractID"))
                w.uint32(8).int32(m.deprecatedContractID);
            if (m.deprecatedCustomerID != null && Object.hasOwnProperty.call(m, "deprecatedCustomerID"))
                w.uint32(16).int32(m.deprecatedCustomerID);
            if (m.contractID != null && Object.hasOwnProperty.call(m, "contractID"))
                w.uint32(82).string(m.contractID);
            if (m.customerID != null && Object.hasOwnProperty.call(m, "customerID"))
                w.uint32(162).string(m.customerID);
            return w;
        };

        /**
         * Decodes a GetPaymentMethodsRequest message from the specified reader or buffer.
         * @function decode
         * @memberof walletpb.GetPaymentMethodsRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {walletpb.GetPaymentMethodsRequest} GetPaymentMethodsRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GetPaymentMethodsRequest.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.walletpb.GetPaymentMethodsRequest();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.deprecatedContractID = r.int32();
                    break;
                case 2:
                    m.deprecatedCustomerID = r.int32();
                    break;
                case 10:
                    m.contractID = r.string();
                    break;
                case 20:
                    m.customerID = r.string();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return GetPaymentMethodsRequest;
    })();

    walletpb.GetPaymentMethodsResponse = (function() {

        /**
         * Properties of a GetPaymentMethodsResponse.
         * @memberof walletpb
         * @interface IGetPaymentMethodsResponse
         * @property {Array.<walletpb.IPaymentMethod>|null} [paymentMethod] GetPaymentMethodsResponse paymentMethod
         */

        /**
         * Constructs a new GetPaymentMethodsResponse.
         * @memberof walletpb
         * @classdesc Represents a GetPaymentMethodsResponse.
         * @implements IGetPaymentMethodsResponse
         * @constructor
         * @param {walletpb.IGetPaymentMethodsResponse=} [p] Properties to set
         */
        function GetPaymentMethodsResponse(p) {
            this.paymentMethod = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * GetPaymentMethodsResponse paymentMethod.
         * @member {Array.<walletpb.IPaymentMethod>} paymentMethod
         * @memberof walletpb.GetPaymentMethodsResponse
         * @instance
         */
        GetPaymentMethodsResponse.prototype.paymentMethod = $util.emptyArray;

        /**
         * Creates a new GetPaymentMethodsResponse instance using the specified properties.
         * @function create
         * @memberof walletpb.GetPaymentMethodsResponse
         * @static
         * @param {walletpb.IGetPaymentMethodsResponse=} [properties] Properties to set
         * @returns {walletpb.GetPaymentMethodsResponse} GetPaymentMethodsResponse instance
         */
        GetPaymentMethodsResponse.create = function create(properties) {
            return new GetPaymentMethodsResponse(properties);
        };

        /**
         * Encodes the specified GetPaymentMethodsResponse message. Does not implicitly {@link walletpb.GetPaymentMethodsResponse.verify|verify} messages.
         * @function encode
         * @memberof walletpb.GetPaymentMethodsResponse
         * @static
         * @param {walletpb.IGetPaymentMethodsResponse} m GetPaymentMethodsResponse message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GetPaymentMethodsResponse.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.paymentMethod != null && m.paymentMethod.length) {
                for (var i = 0; i < m.paymentMethod.length; ++i)
                    $root.walletpb.PaymentMethod.encode(m.paymentMethod[i], w.uint32(10).fork()).ldelim();
            }
            return w;
        };

        /**
         * Decodes a GetPaymentMethodsResponse message from the specified reader or buffer.
         * @function decode
         * @memberof walletpb.GetPaymentMethodsResponse
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {walletpb.GetPaymentMethodsResponse} GetPaymentMethodsResponse
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GetPaymentMethodsResponse.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.walletpb.GetPaymentMethodsResponse();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    if (!(m.paymentMethod && m.paymentMethod.length))
                        m.paymentMethod = [];
                    m.paymentMethod.push($root.walletpb.PaymentMethod.decode(r, r.uint32()));
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return GetPaymentMethodsResponse;
    })();

    walletpb.SearchPaymentMethodsRequest = (function() {

        /**
         * Properties of a SearchPaymentMethodsRequest.
         * @memberof walletpb
         * @interface ISearchPaymentMethodsRequest
         * @property {walletpb.IQueryPaymentMethodID|null} [queryPaymentMethod] SearchPaymentMethodsRequest queryPaymentMethod
         * @property {boolean|null} [isDeleted] SearchPaymentMethodsRequest isDeleted
         */

        /**
         * Constructs a new SearchPaymentMethodsRequest.
         * @memberof walletpb
         * @classdesc Represents a SearchPaymentMethodsRequest.
         * @implements ISearchPaymentMethodsRequest
         * @constructor
         * @param {walletpb.ISearchPaymentMethodsRequest=} [p] Properties to set
         */
        function SearchPaymentMethodsRequest(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * SearchPaymentMethodsRequest queryPaymentMethod.
         * @member {walletpb.IQueryPaymentMethodID|null|undefined} queryPaymentMethod
         * @memberof walletpb.SearchPaymentMethodsRequest
         * @instance
         */
        SearchPaymentMethodsRequest.prototype.queryPaymentMethod = null;

        /**
         * SearchPaymentMethodsRequest isDeleted.
         * @member {boolean} isDeleted
         * @memberof walletpb.SearchPaymentMethodsRequest
         * @instance
         */
        SearchPaymentMethodsRequest.prototype.isDeleted = false;

        /**
         * Creates a new SearchPaymentMethodsRequest instance using the specified properties.
         * @function create
         * @memberof walletpb.SearchPaymentMethodsRequest
         * @static
         * @param {walletpb.ISearchPaymentMethodsRequest=} [properties] Properties to set
         * @returns {walletpb.SearchPaymentMethodsRequest} SearchPaymentMethodsRequest instance
         */
        SearchPaymentMethodsRequest.create = function create(properties) {
            return new SearchPaymentMethodsRequest(properties);
        };

        /**
         * Encodes the specified SearchPaymentMethodsRequest message. Does not implicitly {@link walletpb.SearchPaymentMethodsRequest.verify|verify} messages.
         * @function encode
         * @memberof walletpb.SearchPaymentMethodsRequest
         * @static
         * @param {walletpb.ISearchPaymentMethodsRequest} m SearchPaymentMethodsRequest message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SearchPaymentMethodsRequest.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.queryPaymentMethod != null && Object.hasOwnProperty.call(m, "queryPaymentMethod"))
                $root.walletpb.QueryPaymentMethodID.encode(m.queryPaymentMethod, w.uint32(82).fork()).ldelim();
            if (m.isDeleted != null && Object.hasOwnProperty.call(m, "isDeleted"))
                w.uint32(800).bool(m.isDeleted);
            return w;
        };

        /**
         * Decodes a SearchPaymentMethodsRequest message from the specified reader or buffer.
         * @function decode
         * @memberof walletpb.SearchPaymentMethodsRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {walletpb.SearchPaymentMethodsRequest} SearchPaymentMethodsRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SearchPaymentMethodsRequest.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.walletpb.SearchPaymentMethodsRequest();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 10:
                    m.queryPaymentMethod = $root.walletpb.QueryPaymentMethodID.decode(r, r.uint32());
                    break;
                case 100:
                    m.isDeleted = r.bool();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return SearchPaymentMethodsRequest;
    })();

    walletpb.QueryPaymentMethodID = (function() {

        /**
         * Properties of a QueryPaymentMethodID.
         * @memberof walletpb
         * @interface IQueryPaymentMethodID
         * @property {Array.<string>|null} [paymentMethodID] QueryPaymentMethodID paymentMethodID
         */

        /**
         * Constructs a new QueryPaymentMethodID.
         * @memberof walletpb
         * @classdesc Represents a QueryPaymentMethodID.
         * @implements IQueryPaymentMethodID
         * @constructor
         * @param {walletpb.IQueryPaymentMethodID=} [p] Properties to set
         */
        function QueryPaymentMethodID(p) {
            this.paymentMethodID = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * QueryPaymentMethodID paymentMethodID.
         * @member {Array.<string>} paymentMethodID
         * @memberof walletpb.QueryPaymentMethodID
         * @instance
         */
        QueryPaymentMethodID.prototype.paymentMethodID = $util.emptyArray;

        /**
         * Creates a new QueryPaymentMethodID instance using the specified properties.
         * @function create
         * @memberof walletpb.QueryPaymentMethodID
         * @static
         * @param {walletpb.IQueryPaymentMethodID=} [properties] Properties to set
         * @returns {walletpb.QueryPaymentMethodID} QueryPaymentMethodID instance
         */
        QueryPaymentMethodID.create = function create(properties) {
            return new QueryPaymentMethodID(properties);
        };

        /**
         * Encodes the specified QueryPaymentMethodID message. Does not implicitly {@link walletpb.QueryPaymentMethodID.verify|verify} messages.
         * @function encode
         * @memberof walletpb.QueryPaymentMethodID
         * @static
         * @param {walletpb.IQueryPaymentMethodID} m QueryPaymentMethodID message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        QueryPaymentMethodID.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.paymentMethodID != null && m.paymentMethodID.length) {
                for (var i = 0; i < m.paymentMethodID.length; ++i)
                    w.uint32(82).string(m.paymentMethodID[i]);
            }
            return w;
        };

        /**
         * Decodes a QueryPaymentMethodID message from the specified reader or buffer.
         * @function decode
         * @memberof walletpb.QueryPaymentMethodID
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {walletpb.QueryPaymentMethodID} QueryPaymentMethodID
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        QueryPaymentMethodID.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.walletpb.QueryPaymentMethodID();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 10:
                    if (!(m.paymentMethodID && m.paymentMethodID.length))
                        m.paymentMethodID = [];
                    m.paymentMethodID.push(r.string());
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return QueryPaymentMethodID;
    })();

    walletpb.SearchPaymentMethodsResponse = (function() {

        /**
         * Properties of a SearchPaymentMethodsResponse.
         * @memberof walletpb
         * @interface ISearchPaymentMethodsResponse
         * @property {Array.<walletpb.IPaymentMethod>|null} [paymentMethod] SearchPaymentMethodsResponse paymentMethod
         */

        /**
         * Constructs a new SearchPaymentMethodsResponse.
         * @memberof walletpb
         * @classdesc Represents a SearchPaymentMethodsResponse.
         * @implements ISearchPaymentMethodsResponse
         * @constructor
         * @param {walletpb.ISearchPaymentMethodsResponse=} [p] Properties to set
         */
        function SearchPaymentMethodsResponse(p) {
            this.paymentMethod = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * SearchPaymentMethodsResponse paymentMethod.
         * @member {Array.<walletpb.IPaymentMethod>} paymentMethod
         * @memberof walletpb.SearchPaymentMethodsResponse
         * @instance
         */
        SearchPaymentMethodsResponse.prototype.paymentMethod = $util.emptyArray;

        /**
         * Creates a new SearchPaymentMethodsResponse instance using the specified properties.
         * @function create
         * @memberof walletpb.SearchPaymentMethodsResponse
         * @static
         * @param {walletpb.ISearchPaymentMethodsResponse=} [properties] Properties to set
         * @returns {walletpb.SearchPaymentMethodsResponse} SearchPaymentMethodsResponse instance
         */
        SearchPaymentMethodsResponse.create = function create(properties) {
            return new SearchPaymentMethodsResponse(properties);
        };

        /**
         * Encodes the specified SearchPaymentMethodsResponse message. Does not implicitly {@link walletpb.SearchPaymentMethodsResponse.verify|verify} messages.
         * @function encode
         * @memberof walletpb.SearchPaymentMethodsResponse
         * @static
         * @param {walletpb.ISearchPaymentMethodsResponse} m SearchPaymentMethodsResponse message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SearchPaymentMethodsResponse.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.paymentMethod != null && m.paymentMethod.length) {
                for (var i = 0; i < m.paymentMethod.length; ++i)
                    $root.walletpb.PaymentMethod.encode(m.paymentMethod[i], w.uint32(82).fork()).ldelim();
            }
            return w;
        };

        /**
         * Decodes a SearchPaymentMethodsResponse message from the specified reader or buffer.
         * @function decode
         * @memberof walletpb.SearchPaymentMethodsResponse
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {walletpb.SearchPaymentMethodsResponse} SearchPaymentMethodsResponse
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SearchPaymentMethodsResponse.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.walletpb.SearchPaymentMethodsResponse();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 10:
                    if (!(m.paymentMethod && m.paymentMethod.length))
                        m.paymentMethod = [];
                    m.paymentMethod.push($root.walletpb.PaymentMethod.decode(r, r.uint32()));
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return SearchPaymentMethodsResponse;
    })();

    walletpb.ExternalPaymentMethodEvent = (function() {

        /**
         * Properties of an ExternalPaymentMethodEvent.
         * @memberof walletpb
         * @interface IExternalPaymentMethodEvent
         * @property {string|null} [externalContractID] ExternalPaymentMethodEvent externalContractID
         * @property {string|null} [paymentMethodID] ExternalPaymentMethodEvent paymentMethodID
         */

        /**
         * Constructs a new ExternalPaymentMethodEvent.
         * @memberof walletpb
         * @classdesc Represents an ExternalPaymentMethodEvent.
         * @implements IExternalPaymentMethodEvent
         * @constructor
         * @param {walletpb.IExternalPaymentMethodEvent=} [p] Properties to set
         */
        function ExternalPaymentMethodEvent(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * ExternalPaymentMethodEvent externalContractID.
         * @member {string} externalContractID
         * @memberof walletpb.ExternalPaymentMethodEvent
         * @instance
         */
        ExternalPaymentMethodEvent.prototype.externalContractID = "";

        /**
         * ExternalPaymentMethodEvent paymentMethodID.
         * @member {string} paymentMethodID
         * @memberof walletpb.ExternalPaymentMethodEvent
         * @instance
         */
        ExternalPaymentMethodEvent.prototype.paymentMethodID = "";

        /**
         * Creates a new ExternalPaymentMethodEvent instance using the specified properties.
         * @function create
         * @memberof walletpb.ExternalPaymentMethodEvent
         * @static
         * @param {walletpb.IExternalPaymentMethodEvent=} [properties] Properties to set
         * @returns {walletpb.ExternalPaymentMethodEvent} ExternalPaymentMethodEvent instance
         */
        ExternalPaymentMethodEvent.create = function create(properties) {
            return new ExternalPaymentMethodEvent(properties);
        };

        /**
         * Encodes the specified ExternalPaymentMethodEvent message. Does not implicitly {@link walletpb.ExternalPaymentMethodEvent.verify|verify} messages.
         * @function encode
         * @memberof walletpb.ExternalPaymentMethodEvent
         * @static
         * @param {walletpb.IExternalPaymentMethodEvent} m ExternalPaymentMethodEvent message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ExternalPaymentMethodEvent.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.externalContractID != null && Object.hasOwnProperty.call(m, "externalContractID"))
                w.uint32(10).string(m.externalContractID);
            if (m.paymentMethodID != null && Object.hasOwnProperty.call(m, "paymentMethodID"))
                w.uint32(18).string(m.paymentMethodID);
            return w;
        };

        /**
         * Decodes an ExternalPaymentMethodEvent message from the specified reader or buffer.
         * @function decode
         * @memberof walletpb.ExternalPaymentMethodEvent
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {walletpb.ExternalPaymentMethodEvent} ExternalPaymentMethodEvent
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ExternalPaymentMethodEvent.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.walletpb.ExternalPaymentMethodEvent();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.externalContractID = r.string();
                    break;
                case 2:
                    m.paymentMethodID = r.string();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return ExternalPaymentMethodEvent;
    })();

    walletpb.GetPaymentMethods = (function() {

        /**
         * Constructs a new GetPaymentMethods service.
         * @memberof walletpb
         * @classdesc Represents a GetPaymentMethods
         * @extends $protobuf.rpc.Service
         * @constructor
         * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
         * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
         * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
         */
        function GetPaymentMethods(rpcImpl, requestDelimited, responseDelimited) {
            $protobuf.rpc.Service.call(this, rpcImpl, requestDelimited, responseDelimited);
        }

        (GetPaymentMethods.prototype = Object.create($protobuf.rpc.Service.prototype)).constructor = GetPaymentMethods;

        /**
         * Creates new GetPaymentMethods service using the specified rpc implementation.
         * @function create
         * @memberof walletpb.GetPaymentMethods
         * @static
         * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
         * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
         * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
         * @returns {GetPaymentMethods} RPC service. Useful where requests and/or responses are streamed.
         */
        GetPaymentMethods.create = function create(rpcImpl, requestDelimited, responseDelimited) {
            return new this(rpcImpl, requestDelimited, responseDelimited);
        };

        /**
         * Callback as used by {@link walletpb.GetPaymentMethods#get}.
         * @memberof walletpb.GetPaymentMethods
         * @typedef GetCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {walletpb.GetPaymentMethodsResponse} [response] GetPaymentMethodsResponse
         */

        /**
         * Calls Get.
         * @function get
         * @memberof walletpb.GetPaymentMethods
         * @instance
         * @param {walletpb.IGetPaymentMethodsRequest} request GetPaymentMethodsRequest message or plain object
         * @param {walletpb.GetPaymentMethods.GetCallback} callback Node-style callback called with the error, if any, and GetPaymentMethodsResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(GetPaymentMethods.prototype.get = function get(request, callback) {
            return this.rpcCall(get, $root.walletpb.GetPaymentMethodsRequest, $root.walletpb.GetPaymentMethodsResponse, request, callback);
        }, "name", { value: "Get" });

        /**
         * Calls Get.
         * @function get
         * @memberof walletpb.GetPaymentMethods
         * @instance
         * @param {walletpb.IGetPaymentMethodsRequest} request GetPaymentMethodsRequest message or plain object
         * @returns {Promise<walletpb.GetPaymentMethodsResponse>} Promise
         * @variation 2
         */

        return GetPaymentMethods;
    })();

    walletpb.GetDefaultPaymentMethodRequest = (function() {

        /**
         * Properties of a GetDefaultPaymentMethodRequest.
         * @memberof walletpb
         * @interface IGetDefaultPaymentMethodRequest
         * @property {number|null} [deprecatedContractID] GetDefaultPaymentMethodRequest deprecatedContractID
         * @property {string|null} [contractID] GetDefaultPaymentMethodRequest contractID
         */

        /**
         * Constructs a new GetDefaultPaymentMethodRequest.
         * @memberof walletpb
         * @classdesc Represents a GetDefaultPaymentMethodRequest.
         * @implements IGetDefaultPaymentMethodRequest
         * @constructor
         * @param {walletpb.IGetDefaultPaymentMethodRequest=} [p] Properties to set
         */
        function GetDefaultPaymentMethodRequest(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * GetDefaultPaymentMethodRequest deprecatedContractID.
         * @member {number} deprecatedContractID
         * @memberof walletpb.GetDefaultPaymentMethodRequest
         * @instance
         */
        GetDefaultPaymentMethodRequest.prototype.deprecatedContractID = 0;

        /**
         * GetDefaultPaymentMethodRequest contractID.
         * @member {string} contractID
         * @memberof walletpb.GetDefaultPaymentMethodRequest
         * @instance
         */
        GetDefaultPaymentMethodRequest.prototype.contractID = "";

        /**
         * Creates a new GetDefaultPaymentMethodRequest instance using the specified properties.
         * @function create
         * @memberof walletpb.GetDefaultPaymentMethodRequest
         * @static
         * @param {walletpb.IGetDefaultPaymentMethodRequest=} [properties] Properties to set
         * @returns {walletpb.GetDefaultPaymentMethodRequest} GetDefaultPaymentMethodRequest instance
         */
        GetDefaultPaymentMethodRequest.create = function create(properties) {
            return new GetDefaultPaymentMethodRequest(properties);
        };

        /**
         * Encodes the specified GetDefaultPaymentMethodRequest message. Does not implicitly {@link walletpb.GetDefaultPaymentMethodRequest.verify|verify} messages.
         * @function encode
         * @memberof walletpb.GetDefaultPaymentMethodRequest
         * @static
         * @param {walletpb.IGetDefaultPaymentMethodRequest} m GetDefaultPaymentMethodRequest message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GetDefaultPaymentMethodRequest.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.deprecatedContractID != null && Object.hasOwnProperty.call(m, "deprecatedContractID"))
                w.uint32(8).int32(m.deprecatedContractID);
            if (m.contractID != null && Object.hasOwnProperty.call(m, "contractID"))
                w.uint32(82).string(m.contractID);
            return w;
        };

        /**
         * Decodes a GetDefaultPaymentMethodRequest message from the specified reader or buffer.
         * @function decode
         * @memberof walletpb.GetDefaultPaymentMethodRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {walletpb.GetDefaultPaymentMethodRequest} GetDefaultPaymentMethodRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GetDefaultPaymentMethodRequest.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.walletpb.GetDefaultPaymentMethodRequest();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.deprecatedContractID = r.int32();
                    break;
                case 10:
                    m.contractID = r.string();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return GetDefaultPaymentMethodRequest;
    })();

    walletpb.GetDefaultPaymentMethodResponse = (function() {

        /**
         * Properties of a GetDefaultPaymentMethodResponse.
         * @memberof walletpb
         * @interface IGetDefaultPaymentMethodResponse
         * @property {walletpb.IPaymentMethod|null} [paymentMethod] GetDefaultPaymentMethodResponse paymentMethod
         */

        /**
         * Constructs a new GetDefaultPaymentMethodResponse.
         * @memberof walletpb
         * @classdesc Represents a GetDefaultPaymentMethodResponse.
         * @implements IGetDefaultPaymentMethodResponse
         * @constructor
         * @param {walletpb.IGetDefaultPaymentMethodResponse=} [p] Properties to set
         */
        function GetDefaultPaymentMethodResponse(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * GetDefaultPaymentMethodResponse paymentMethod.
         * @member {walletpb.IPaymentMethod|null|undefined} paymentMethod
         * @memberof walletpb.GetDefaultPaymentMethodResponse
         * @instance
         */
        GetDefaultPaymentMethodResponse.prototype.paymentMethod = null;

        /**
         * Creates a new GetDefaultPaymentMethodResponse instance using the specified properties.
         * @function create
         * @memberof walletpb.GetDefaultPaymentMethodResponse
         * @static
         * @param {walletpb.IGetDefaultPaymentMethodResponse=} [properties] Properties to set
         * @returns {walletpb.GetDefaultPaymentMethodResponse} GetDefaultPaymentMethodResponse instance
         */
        GetDefaultPaymentMethodResponse.create = function create(properties) {
            return new GetDefaultPaymentMethodResponse(properties);
        };

        /**
         * Encodes the specified GetDefaultPaymentMethodResponse message. Does not implicitly {@link walletpb.GetDefaultPaymentMethodResponse.verify|verify} messages.
         * @function encode
         * @memberof walletpb.GetDefaultPaymentMethodResponse
         * @static
         * @param {walletpb.IGetDefaultPaymentMethodResponse} m GetDefaultPaymentMethodResponse message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GetDefaultPaymentMethodResponse.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.paymentMethod != null && Object.hasOwnProperty.call(m, "paymentMethod"))
                $root.walletpb.PaymentMethod.encode(m.paymentMethod, w.uint32(10).fork()).ldelim();
            return w;
        };

        /**
         * Decodes a GetDefaultPaymentMethodResponse message from the specified reader or buffer.
         * @function decode
         * @memberof walletpb.GetDefaultPaymentMethodResponse
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {walletpb.GetDefaultPaymentMethodResponse} GetDefaultPaymentMethodResponse
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GetDefaultPaymentMethodResponse.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.walletpb.GetDefaultPaymentMethodResponse();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.paymentMethod = $root.walletpb.PaymentMethod.decode(r, r.uint32());
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return GetDefaultPaymentMethodResponse;
    })();

    walletpb.GetDefaultPaymentMethod = (function() {

        /**
         * Constructs a new GetDefaultPaymentMethod service.
         * @memberof walletpb
         * @classdesc Represents a GetDefaultPaymentMethod
         * @extends $protobuf.rpc.Service
         * @constructor
         * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
         * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
         * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
         */
        function GetDefaultPaymentMethod(rpcImpl, requestDelimited, responseDelimited) {
            $protobuf.rpc.Service.call(this, rpcImpl, requestDelimited, responseDelimited);
        }

        (GetDefaultPaymentMethod.prototype = Object.create($protobuf.rpc.Service.prototype)).constructor = GetDefaultPaymentMethod;

        /**
         * Creates new GetDefaultPaymentMethod service using the specified rpc implementation.
         * @function create
         * @memberof walletpb.GetDefaultPaymentMethod
         * @static
         * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
         * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
         * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
         * @returns {GetDefaultPaymentMethod} RPC service. Useful where requests and/or responses are streamed.
         */
        GetDefaultPaymentMethod.create = function create(rpcImpl, requestDelimited, responseDelimited) {
            return new this(rpcImpl, requestDelimited, responseDelimited);
        };

        /**
         * Callback as used by {@link walletpb.GetDefaultPaymentMethod#get}.
         * @memberof walletpb.GetDefaultPaymentMethod
         * @typedef GetCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {walletpb.GetDefaultPaymentMethodResponse} [response] GetDefaultPaymentMethodResponse
         */

        /**
         * Calls Get.
         * @function get
         * @memberof walletpb.GetDefaultPaymentMethod
         * @instance
         * @param {walletpb.IGetDefaultPaymentMethodRequest} request GetDefaultPaymentMethodRequest message or plain object
         * @param {walletpb.GetDefaultPaymentMethod.GetCallback} callback Node-style callback called with the error, if any, and GetDefaultPaymentMethodResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(GetDefaultPaymentMethod.prototype.get = function get(request, callback) {
            return this.rpcCall(get, $root.walletpb.GetDefaultPaymentMethodRequest, $root.walletpb.GetDefaultPaymentMethodResponse, request, callback);
        }, "name", { value: "Get" });

        /**
         * Calls Get.
         * @function get
         * @memberof walletpb.GetDefaultPaymentMethod
         * @instance
         * @param {walletpb.IGetDefaultPaymentMethodRequest} request GetDefaultPaymentMethodRequest message or plain object
         * @returns {Promise<walletpb.GetDefaultPaymentMethodResponse>} Promise
         * @variation 2
         */

        return GetDefaultPaymentMethod;
    })();

    walletpb.UpdateDefaultPaymentMethodRequest = (function() {

        /**
         * Properties of an UpdateDefaultPaymentMethodRequest.
         * @memberof walletpb
         * @interface IUpdateDefaultPaymentMethodRequest
         * @property {number|null} [deprecatedContractID] UpdateDefaultPaymentMethodRequest deprecatedContractID
         * @property {number|null} [deprecatedCustomerID] UpdateDefaultPaymentMethodRequest deprecatedCustomerID
         * @property {string|null} [contractID] UpdateDefaultPaymentMethodRequest contractID
         * @property {string|null} [customerID] UpdateDefaultPaymentMethodRequest customerID
         * @property {walletpb.IDataStore|null} [dataStore] UpdateDefaultPaymentMethodRequest dataStore
         * @property {string|null} [sourceTypeCode] UpdateDefaultPaymentMethodRequest sourceTypeCode
         * @property {number|null} [deprecatedPropertyID] UpdateDefaultPaymentMethodRequest deprecatedPropertyID
         * @property {string|null} [propertyID] UpdateDefaultPaymentMethodRequest propertyID
         * @property {string|null} [paymentsMsID] UpdateDefaultPaymentMethodRequest paymentsMsID
         * @property {string|null} [paymentMethodsMsID] UpdateDefaultPaymentMethodRequest paymentMethodsMsID
         */

        /**
         * Constructs a new UpdateDefaultPaymentMethodRequest.
         * @memberof walletpb
         * @classdesc Represents an UpdateDefaultPaymentMethodRequest.
         * @implements IUpdateDefaultPaymentMethodRequest
         * @constructor
         * @param {walletpb.IUpdateDefaultPaymentMethodRequest=} [p] Properties to set
         */
        function UpdateDefaultPaymentMethodRequest(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * UpdateDefaultPaymentMethodRequest deprecatedContractID.
         * @member {number} deprecatedContractID
         * @memberof walletpb.UpdateDefaultPaymentMethodRequest
         * @instance
         */
        UpdateDefaultPaymentMethodRequest.prototype.deprecatedContractID = 0;

        /**
         * UpdateDefaultPaymentMethodRequest deprecatedCustomerID.
         * @member {number} deprecatedCustomerID
         * @memberof walletpb.UpdateDefaultPaymentMethodRequest
         * @instance
         */
        UpdateDefaultPaymentMethodRequest.prototype.deprecatedCustomerID = 0;

        /**
         * UpdateDefaultPaymentMethodRequest contractID.
         * @member {string} contractID
         * @memberof walletpb.UpdateDefaultPaymentMethodRequest
         * @instance
         */
        UpdateDefaultPaymentMethodRequest.prototype.contractID = "";

        /**
         * UpdateDefaultPaymentMethodRequest customerID.
         * @member {string} customerID
         * @memberof walletpb.UpdateDefaultPaymentMethodRequest
         * @instance
         */
        UpdateDefaultPaymentMethodRequest.prototype.customerID = "";

        /**
         * UpdateDefaultPaymentMethodRequest dataStore.
         * @member {walletpb.IDataStore|null|undefined} dataStore
         * @memberof walletpb.UpdateDefaultPaymentMethodRequest
         * @instance
         */
        UpdateDefaultPaymentMethodRequest.prototype.dataStore = null;

        /**
         * UpdateDefaultPaymentMethodRequest sourceTypeCode.
         * @member {string} sourceTypeCode
         * @memberof walletpb.UpdateDefaultPaymentMethodRequest
         * @instance
         */
        UpdateDefaultPaymentMethodRequest.prototype.sourceTypeCode = "";

        /**
         * UpdateDefaultPaymentMethodRequest deprecatedPropertyID.
         * @member {number} deprecatedPropertyID
         * @memberof walletpb.UpdateDefaultPaymentMethodRequest
         * @instance
         */
        UpdateDefaultPaymentMethodRequest.prototype.deprecatedPropertyID = 0;

        /**
         * UpdateDefaultPaymentMethodRequest propertyID.
         * @member {string} propertyID
         * @memberof walletpb.UpdateDefaultPaymentMethodRequest
         * @instance
         */
        UpdateDefaultPaymentMethodRequest.prototype.propertyID = "";

        /**
         * UpdateDefaultPaymentMethodRequest paymentsMsID.
         * @member {string} paymentsMsID
         * @memberof walletpb.UpdateDefaultPaymentMethodRequest
         * @instance
         */
        UpdateDefaultPaymentMethodRequest.prototype.paymentsMsID = "";

        /**
         * UpdateDefaultPaymentMethodRequest paymentMethodsMsID.
         * @member {string} paymentMethodsMsID
         * @memberof walletpb.UpdateDefaultPaymentMethodRequest
         * @instance
         */
        UpdateDefaultPaymentMethodRequest.prototype.paymentMethodsMsID = "";

        /**
         * Creates a new UpdateDefaultPaymentMethodRequest instance using the specified properties.
         * @function create
         * @memberof walletpb.UpdateDefaultPaymentMethodRequest
         * @static
         * @param {walletpb.IUpdateDefaultPaymentMethodRequest=} [properties] Properties to set
         * @returns {walletpb.UpdateDefaultPaymentMethodRequest} UpdateDefaultPaymentMethodRequest instance
         */
        UpdateDefaultPaymentMethodRequest.create = function create(properties) {
            return new UpdateDefaultPaymentMethodRequest(properties);
        };

        /**
         * Encodes the specified UpdateDefaultPaymentMethodRequest message. Does not implicitly {@link walletpb.UpdateDefaultPaymentMethodRequest.verify|verify} messages.
         * @function encode
         * @memberof walletpb.UpdateDefaultPaymentMethodRequest
         * @static
         * @param {walletpb.IUpdateDefaultPaymentMethodRequest} m UpdateDefaultPaymentMethodRequest message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        UpdateDefaultPaymentMethodRequest.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.deprecatedContractID != null && Object.hasOwnProperty.call(m, "deprecatedContractID"))
                w.uint32(8).int32(m.deprecatedContractID);
            if (m.deprecatedCustomerID != null && Object.hasOwnProperty.call(m, "deprecatedCustomerID"))
                w.uint32(16).int32(m.deprecatedCustomerID);
            if (m.dataStore != null && Object.hasOwnProperty.call(m, "dataStore"))
                $root.walletpb.DataStore.encode(m.dataStore, w.uint32(26).fork()).ldelim();
            if (m.sourceTypeCode != null && Object.hasOwnProperty.call(m, "sourceTypeCode"))
                w.uint32(34).string(m.sourceTypeCode);
            if (m.deprecatedPropertyID != null && Object.hasOwnProperty.call(m, "deprecatedPropertyID"))
                w.uint32(40).int32(m.deprecatedPropertyID);
            if (m.paymentsMsID != null && Object.hasOwnProperty.call(m, "paymentsMsID"))
                w.uint32(50).string(m.paymentsMsID);
            if (m.paymentMethodsMsID != null && Object.hasOwnProperty.call(m, "paymentMethodsMsID"))
                w.uint32(58).string(m.paymentMethodsMsID);
            if (m.contractID != null && Object.hasOwnProperty.call(m, "contractID"))
                w.uint32(82).string(m.contractID);
            if (m.customerID != null && Object.hasOwnProperty.call(m, "customerID"))
                w.uint32(162).string(m.customerID);
            if (m.propertyID != null && Object.hasOwnProperty.call(m, "propertyID"))
                w.uint32(402).string(m.propertyID);
            return w;
        };

        /**
         * Decodes an UpdateDefaultPaymentMethodRequest message from the specified reader or buffer.
         * @function decode
         * @memberof walletpb.UpdateDefaultPaymentMethodRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {walletpb.UpdateDefaultPaymentMethodRequest} UpdateDefaultPaymentMethodRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        UpdateDefaultPaymentMethodRequest.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.walletpb.UpdateDefaultPaymentMethodRequest();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.deprecatedContractID = r.int32();
                    break;
                case 2:
                    m.deprecatedCustomerID = r.int32();
                    break;
                case 10:
                    m.contractID = r.string();
                    break;
                case 20:
                    m.customerID = r.string();
                    break;
                case 3:
                    m.dataStore = $root.walletpb.DataStore.decode(r, r.uint32());
                    break;
                case 4:
                    m.sourceTypeCode = r.string();
                    break;
                case 5:
                    m.deprecatedPropertyID = r.int32();
                    break;
                case 50:
                    m.propertyID = r.string();
                    break;
                case 6:
                    m.paymentsMsID = r.string();
                    break;
                case 7:
                    m.paymentMethodsMsID = r.string();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return UpdateDefaultPaymentMethodRequest;
    })();

    walletpb.UpdateDefaultPaymentMethodResponse = (function() {

        /**
         * Properties of an UpdateDefaultPaymentMethodResponse.
         * @memberof walletpb
         * @interface IUpdateDefaultPaymentMethodResponse
         * @property {walletpb.IPaymentMethod|null} [paymentMethod] UpdateDefaultPaymentMethodResponse paymentMethod
         */

        /**
         * Constructs a new UpdateDefaultPaymentMethodResponse.
         * @memberof walletpb
         * @classdesc Represents an UpdateDefaultPaymentMethodResponse.
         * @implements IUpdateDefaultPaymentMethodResponse
         * @constructor
         * @param {walletpb.IUpdateDefaultPaymentMethodResponse=} [p] Properties to set
         */
        function UpdateDefaultPaymentMethodResponse(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * UpdateDefaultPaymentMethodResponse paymentMethod.
         * @member {walletpb.IPaymentMethod|null|undefined} paymentMethod
         * @memberof walletpb.UpdateDefaultPaymentMethodResponse
         * @instance
         */
        UpdateDefaultPaymentMethodResponse.prototype.paymentMethod = null;

        /**
         * Creates a new UpdateDefaultPaymentMethodResponse instance using the specified properties.
         * @function create
         * @memberof walletpb.UpdateDefaultPaymentMethodResponse
         * @static
         * @param {walletpb.IUpdateDefaultPaymentMethodResponse=} [properties] Properties to set
         * @returns {walletpb.UpdateDefaultPaymentMethodResponse} UpdateDefaultPaymentMethodResponse instance
         */
        UpdateDefaultPaymentMethodResponse.create = function create(properties) {
            return new UpdateDefaultPaymentMethodResponse(properties);
        };

        /**
         * Encodes the specified UpdateDefaultPaymentMethodResponse message. Does not implicitly {@link walletpb.UpdateDefaultPaymentMethodResponse.verify|verify} messages.
         * @function encode
         * @memberof walletpb.UpdateDefaultPaymentMethodResponse
         * @static
         * @param {walletpb.IUpdateDefaultPaymentMethodResponse} m UpdateDefaultPaymentMethodResponse message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        UpdateDefaultPaymentMethodResponse.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.paymentMethod != null && Object.hasOwnProperty.call(m, "paymentMethod"))
                $root.walletpb.PaymentMethod.encode(m.paymentMethod, w.uint32(10).fork()).ldelim();
            return w;
        };

        /**
         * Decodes an UpdateDefaultPaymentMethodResponse message from the specified reader or buffer.
         * @function decode
         * @memberof walletpb.UpdateDefaultPaymentMethodResponse
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {walletpb.UpdateDefaultPaymentMethodResponse} UpdateDefaultPaymentMethodResponse
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        UpdateDefaultPaymentMethodResponse.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.walletpb.UpdateDefaultPaymentMethodResponse();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.paymentMethod = $root.walletpb.PaymentMethod.decode(r, r.uint32());
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return UpdateDefaultPaymentMethodResponse;
    })();

    walletpb.UpdateDefaultPaymentMethod = (function() {

        /**
         * Constructs a new UpdateDefaultPaymentMethod service.
         * @memberof walletpb
         * @classdesc Represents an UpdateDefaultPaymentMethod
         * @extends $protobuf.rpc.Service
         * @constructor
         * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
         * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
         * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
         */
        function UpdateDefaultPaymentMethod(rpcImpl, requestDelimited, responseDelimited) {
            $protobuf.rpc.Service.call(this, rpcImpl, requestDelimited, responseDelimited);
        }

        (UpdateDefaultPaymentMethod.prototype = Object.create($protobuf.rpc.Service.prototype)).constructor = UpdateDefaultPaymentMethod;

        /**
         * Creates new UpdateDefaultPaymentMethod service using the specified rpc implementation.
         * @function create
         * @memberof walletpb.UpdateDefaultPaymentMethod
         * @static
         * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
         * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
         * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
         * @returns {UpdateDefaultPaymentMethod} RPC service. Useful where requests and/or responses are streamed.
         */
        UpdateDefaultPaymentMethod.create = function create(rpcImpl, requestDelimited, responseDelimited) {
            return new this(rpcImpl, requestDelimited, responseDelimited);
        };

        /**
         * Callback as used by {@link walletpb.UpdateDefaultPaymentMethod#put}.
         * @memberof walletpb.UpdateDefaultPaymentMethod
         * @typedef PutCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {walletpb.UpdateDefaultPaymentMethodResponse} [response] UpdateDefaultPaymentMethodResponse
         */

        /**
         * Calls Put.
         * @function put
         * @memberof walletpb.UpdateDefaultPaymentMethod
         * @instance
         * @param {walletpb.IUpdateDefaultPaymentMethodRequest} request UpdateDefaultPaymentMethodRequest message or plain object
         * @param {walletpb.UpdateDefaultPaymentMethod.PutCallback} callback Node-style callback called with the error, if any, and UpdateDefaultPaymentMethodResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(UpdateDefaultPaymentMethod.prototype.put = function put(request, callback) {
            return this.rpcCall(put, $root.walletpb.UpdateDefaultPaymentMethodRequest, $root.walletpb.UpdateDefaultPaymentMethodResponse, request, callback);
        }, "name", { value: "Put" });

        /**
         * Calls Put.
         * @function put
         * @memberof walletpb.UpdateDefaultPaymentMethod
         * @instance
         * @param {walletpb.IUpdateDefaultPaymentMethodRequest} request UpdateDefaultPaymentMethodRequest message or plain object
         * @returns {Promise<walletpb.UpdateDefaultPaymentMethodResponse>} Promise
         * @variation 2
         */

        return UpdateDefaultPaymentMethod;
    })();

    walletpb.DeletePaymentMethodRequest = (function() {

        /**
         * Properties of a DeletePaymentMethodRequest.
         * @memberof walletpb
         * @interface IDeletePaymentMethodRequest
         * @property {Array.<walletpb.IDataStore>|null} [dataStore] DeletePaymentMethodRequest dataStore
         * @property {string|null} [starID] DeletePaymentMethodRequest starID
         * @property {string|null} [paymentsMsID] DeletePaymentMethodRequest paymentsMsID
         * @property {string|null} [paymentMethodsMsID] DeletePaymentMethodRequest paymentMethodsMsID
         */

        /**
         * Constructs a new DeletePaymentMethodRequest.
         * @memberof walletpb
         * @classdesc Represents a DeletePaymentMethodRequest.
         * @implements IDeletePaymentMethodRequest
         * @constructor
         * @param {walletpb.IDeletePaymentMethodRequest=} [p] Properties to set
         */
        function DeletePaymentMethodRequest(p) {
            this.dataStore = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * DeletePaymentMethodRequest dataStore.
         * @member {Array.<walletpb.IDataStore>} dataStore
         * @memberof walletpb.DeletePaymentMethodRequest
         * @instance
         */
        DeletePaymentMethodRequest.prototype.dataStore = $util.emptyArray;

        /**
         * DeletePaymentMethodRequest starID.
         * @member {string} starID
         * @memberof walletpb.DeletePaymentMethodRequest
         * @instance
         */
        DeletePaymentMethodRequest.prototype.starID = "";

        /**
         * DeletePaymentMethodRequest paymentsMsID.
         * @member {string} paymentsMsID
         * @memberof walletpb.DeletePaymentMethodRequest
         * @instance
         */
        DeletePaymentMethodRequest.prototype.paymentsMsID = "";

        /**
         * DeletePaymentMethodRequest paymentMethodsMsID.
         * @member {string} paymentMethodsMsID
         * @memberof walletpb.DeletePaymentMethodRequest
         * @instance
         */
        DeletePaymentMethodRequest.prototype.paymentMethodsMsID = "";

        /**
         * Creates a new DeletePaymentMethodRequest instance using the specified properties.
         * @function create
         * @memberof walletpb.DeletePaymentMethodRequest
         * @static
         * @param {walletpb.IDeletePaymentMethodRequest=} [properties] Properties to set
         * @returns {walletpb.DeletePaymentMethodRequest} DeletePaymentMethodRequest instance
         */
        DeletePaymentMethodRequest.create = function create(properties) {
            return new DeletePaymentMethodRequest(properties);
        };

        /**
         * Encodes the specified DeletePaymentMethodRequest message. Does not implicitly {@link walletpb.DeletePaymentMethodRequest.verify|verify} messages.
         * @function encode
         * @memberof walletpb.DeletePaymentMethodRequest
         * @static
         * @param {walletpb.IDeletePaymentMethodRequest} m DeletePaymentMethodRequest message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        DeletePaymentMethodRequest.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.dataStore != null && m.dataStore.length) {
                for (var i = 0; i < m.dataStore.length; ++i)
                    $root.walletpb.DataStore.encode(m.dataStore[i], w.uint32(10).fork()).ldelim();
            }
            if (m.starID != null && Object.hasOwnProperty.call(m, "starID"))
                w.uint32(18).string(m.starID);
            if (m.paymentsMsID != null && Object.hasOwnProperty.call(m, "paymentsMsID"))
                w.uint32(26).string(m.paymentsMsID);
            if (m.paymentMethodsMsID != null && Object.hasOwnProperty.call(m, "paymentMethodsMsID"))
                w.uint32(34).string(m.paymentMethodsMsID);
            return w;
        };

        /**
         * Decodes a DeletePaymentMethodRequest message from the specified reader or buffer.
         * @function decode
         * @memberof walletpb.DeletePaymentMethodRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {walletpb.DeletePaymentMethodRequest} DeletePaymentMethodRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        DeletePaymentMethodRequest.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.walletpb.DeletePaymentMethodRequest();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    if (!(m.dataStore && m.dataStore.length))
                        m.dataStore = [];
                    m.dataStore.push($root.walletpb.DataStore.decode(r, r.uint32()));
                    break;
                case 2:
                    m.starID = r.string();
                    break;
                case 3:
                    m.paymentsMsID = r.string();
                    break;
                case 4:
                    m.paymentMethodsMsID = r.string();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return DeletePaymentMethodRequest;
    })();

    walletpb.DeletePaymentMethod = (function() {

        /**
         * Constructs a new DeletePaymentMethod service.
         * @memberof walletpb
         * @classdesc Represents a DeletePaymentMethod
         * @extends $protobuf.rpc.Service
         * @constructor
         * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
         * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
         * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
         */
        function DeletePaymentMethod(rpcImpl, requestDelimited, responseDelimited) {
            $protobuf.rpc.Service.call(this, rpcImpl, requestDelimited, responseDelimited);
        }

        (DeletePaymentMethod.prototype = Object.create($protobuf.rpc.Service.prototype)).constructor = DeletePaymentMethod;

        /**
         * Creates new DeletePaymentMethod service using the specified rpc implementation.
         * @function create
         * @memberof walletpb.DeletePaymentMethod
         * @static
         * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
         * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
         * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
         * @returns {DeletePaymentMethod} RPC service. Useful where requests and/or responses are streamed.
         */
        DeletePaymentMethod.create = function create(rpcImpl, requestDelimited, responseDelimited) {
            return new this(rpcImpl, requestDelimited, responseDelimited);
        };

        /**
         * Callback as used by {@link walletpb.DeletePaymentMethod#delete_}.
         * @memberof walletpb.DeletePaymentMethod
         * @typedef DeleteCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {google.protobuf.Empty} [response] Empty
         */

        /**
         * Calls Delete.
         * @function delete
         * @memberof walletpb.DeletePaymentMethod
         * @instance
         * @param {walletpb.IDeletePaymentMethodRequest} request DeletePaymentMethodRequest message or plain object
         * @param {walletpb.DeletePaymentMethod.DeleteCallback} callback Node-style callback called with the error, if any, and Empty
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(DeletePaymentMethod.prototype["delete"] = function delete_(request, callback) {
            return this.rpcCall(delete_, $root.walletpb.DeletePaymentMethodRequest, $root.google.protobuf.Empty, request, callback);
        }, "name", { value: "Delete" });

        /**
         * Calls Delete.
         * @function delete
         * @memberof walletpb.DeletePaymentMethod
         * @instance
         * @param {walletpb.IDeletePaymentMethodRequest} request DeletePaymentMethodRequest message or plain object
         * @returns {Promise<google.protobuf.Empty>} Promise
         * @variation 2
         */

        return DeletePaymentMethod;
    })();

    walletpb.SearchPaymentMethods = (function() {

        /**
         * Constructs a new SearchPaymentMethods service.
         * @memberof walletpb
         * @classdesc Represents a SearchPaymentMethods
         * @extends $protobuf.rpc.Service
         * @constructor
         * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
         * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
         * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
         */
        function SearchPaymentMethods(rpcImpl, requestDelimited, responseDelimited) {
            $protobuf.rpc.Service.call(this, rpcImpl, requestDelimited, responseDelimited);
        }

        (SearchPaymentMethods.prototype = Object.create($protobuf.rpc.Service.prototype)).constructor = SearchPaymentMethods;

        /**
         * Creates new SearchPaymentMethods service using the specified rpc implementation.
         * @function create
         * @memberof walletpb.SearchPaymentMethods
         * @static
         * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
         * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
         * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
         * @returns {SearchPaymentMethods} RPC service. Useful where requests and/or responses are streamed.
         */
        SearchPaymentMethods.create = function create(rpcImpl, requestDelimited, responseDelimited) {
            return new this(rpcImpl, requestDelimited, responseDelimited);
        };

        /**
         * Callback as used by {@link walletpb.SearchPaymentMethods#post}.
         * @memberof walletpb.SearchPaymentMethods
         * @typedef PostCallback
         * @type {function}
         * @param {Error|null} error Error, if any
         * @param {walletpb.SearchPaymentMethodsResponse} [response] SearchPaymentMethodsResponse
         */

        /**
         * Calls Post.
         * @function post
         * @memberof walletpb.SearchPaymentMethods
         * @instance
         * @param {walletpb.ISearchPaymentMethodsRequest} request SearchPaymentMethodsRequest message or plain object
         * @param {walletpb.SearchPaymentMethods.PostCallback} callback Node-style callback called with the error, if any, and SearchPaymentMethodsResponse
         * @returns {undefined}
         * @variation 1
         */
        Object.defineProperty(SearchPaymentMethods.prototype.post = function post(request, callback) {
            return this.rpcCall(post, $root.walletpb.SearchPaymentMethodsRequest, $root.walletpb.SearchPaymentMethodsResponse, request, callback);
        }, "name", { value: "Post" });

        /**
         * Calls Post.
         * @function post
         * @memberof walletpb.SearchPaymentMethods
         * @instance
         * @param {walletpb.ISearchPaymentMethodsRequest} request SearchPaymentMethodsRequest message or plain object
         * @returns {Promise<walletpb.SearchPaymentMethodsResponse>} Promise
         * @variation 2
         */

        return SearchPaymentMethods;
    })();

    return walletpb;
})();

export const common = $root.common = (() => {

    /**
     * Namespace common.
     * @exports common
     * @namespace
     */
    const common = {};

    /**
     * Tenant enum.
     * @name common.Tenant
     * @enum {number}
     * @property {number} TENANT_UNDEFINED=0 TENANT_UNDEFINED value
     * @property {number} TEST=1 TEST value
     * @property {number} AHS=2 AHS value
     * @property {number} CD=3 CD value
     * @property {number} HSA=4 HSA value
     * @property {number} OG=5 OG value
     * @property {number} LM=6 LM value
     * @property {number} FRONTDOOR=7 FRONTDOOR value
     * @property {number} AHSPC=8 AHSPC value
     * @property {number} HSAPC=9 HSAPC value
     * @property {number} FTDR=10 FTDR value
     * @property {number} HBW210=11 HBW210 value
     */
    common.Tenant = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "TENANT_UNDEFINED"] = 0;
        values[valuesById[1] = "TEST"] = 1;
        values[valuesById[2] = "AHS"] = 2;
        values[valuesById[3] = "CD"] = 3;
        values[valuesById[4] = "HSA"] = 4;
        values[valuesById[5] = "OG"] = 5;
        values[valuesById[6] = "LM"] = 6;
        values[valuesById[7] = "FRONTDOOR"] = 7;
        values[valuesById[8] = "AHSPC"] = 8;
        values[valuesById[9] = "HSAPC"] = 9;
        values[valuesById[10] = "FTDR"] = 10;
        values[valuesById[11] = "HBW210"] = 11;
        return values;
    })();

    /**
     * Alert enum.
     * @name common.Alert
     * @enum {number}
     * @property {number} ALERTS_UNDEFINED=0 ALERTS_UNDEFINED value
     * @property {number} ALERTS_UNSCHEDULED=1 ALERTS_UNSCHEDULED value
     * @property {number} ALERTS_NEED_STATUS_UPDATE=2 ALERTS_NEED_STATUS_UPDATE value
     * @property {number} ALERTS_OPEN_LONGER_THAN_AVERAGE=3 ALERTS_OPEN_LONGER_THAN_AVERAGE value
     * @property {number} ALERTS_SCHEDULE_NEXT_APPOINTMENT=4 ALERTS_SCHEDULE_NEXT_APPOINTMENT value
     * @property {number} ALERTS_RESUBMIT_REQUEST=5 ALERTS_RESUBMIT_REQUEST value
     * @property {number} ALERTS_TODAYS_APPOINTMENT=6 ALERTS_TODAYS_APPOINTMENT value
     * @property {number} ALERTS_AUTHO_STATUS_UPDATED=7 ALERTS_AUTHO_STATUS_UPDATED value
     */
    common.Alert = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "ALERTS_UNDEFINED"] = 0;
        values[valuesById[1] = "ALERTS_UNSCHEDULED"] = 1;
        values[valuesById[2] = "ALERTS_NEED_STATUS_UPDATE"] = 2;
        values[valuesById[3] = "ALERTS_OPEN_LONGER_THAN_AVERAGE"] = 3;
        values[valuesById[4] = "ALERTS_SCHEDULE_NEXT_APPOINTMENT"] = 4;
        values[valuesById[5] = "ALERTS_RESUBMIT_REQUEST"] = 5;
        values[valuesById[6] = "ALERTS_TODAYS_APPOINTMENT"] = 6;
        values[valuesById[7] = "ALERTS_AUTHO_STATUS_UPDATED"] = 7;
        return values;
    })();

    /**
     * Status enum.
     * @name common.Status
     * @enum {number}
     * @property {number} STATUS_UNDEFINED=0 STATUS_UNDEFINED value
     * @property {number} SUCCESS=1 SUCCESS value
     * @property {number} FAIL=2 FAIL value
     */
    common.Status = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "STATUS_UNDEFINED"] = 0;
        values[valuesById[1] = "SUCCESS"] = 1;
        values[valuesById[2] = "FAIL"] = 2;
        return values;
    })();

    /**
     * UserRole enum.
     * @name common.UserRole
     * @enum {number}
     * @property {number} USER_ROLE_UNDEFINED=0 USER_ROLE_UNDEFINED value
     * @property {number} CONTRACTOR=1 CONTRACTOR value
     * @property {number} AGENT=2 AGENT value
     * @property {number} ADMIN=3 ADMIN value
     * @property {number} TECHNICIAN=4 TECHNICIAN value
     * @property {number} PARTNER=5 PARTNER value
     * @property {number} CUSTOMER=6 CUSTOMER value
     * @property {number} DEVELOPER=7 DEVELOPER value
     * @property {number} EXTERNAL_PARTNER=8 EXTERNAL_PARTNER value
     */
    common.UserRole = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "USER_ROLE_UNDEFINED"] = 0;
        values[valuesById[1] = "CONTRACTOR"] = 1;
        values[valuesById[2] = "AGENT"] = 2;
        values[valuesById[3] = "ADMIN"] = 3;
        values[valuesById[4] = "TECHNICIAN"] = 4;
        values[valuesById[5] = "PARTNER"] = 5;
        values[valuesById[6] = "CUSTOMER"] = 6;
        values[valuesById[7] = "DEVELOPER"] = 7;
        values[valuesById[8] = "EXTERNAL_PARTNER"] = 8;
        return values;
    })();

    /**
     * Application enum.
     * @name common.Application
     * @enum {number}
     * @property {number} Application_UNKNOWN=0 Application_UNKNOWN value
     * @property {number} Application_CNTRTRPRTL=1 Application_CNTRTRPRTL value
     * @property {number} Application_MYACCOUNT=2 Application_MYACCOUNT value
     * @property {number} Application_CSC=3 Application_CSC value
     * @property {number} Application_MOBILEAPP=4 Application_MOBILEAPP value
     * @property {number} Application_ESTREVIEW=5 Application_ESTREVIEW value
     * @property {number} Application_DISTHRDPRT=6 Application_DISTHRDPRT value
     * @property {number} Application_DPCONN=7 Application_DPCONN value
     * @property {number} Application_DISPATCHME=8 Application_DISPATCHME value
     * @property {number} Application_DISPMEPRTL=9 Application_DISPMEPRTL value
     * @property {number} Application_SC=10 Application_SC value
     * @property {number} Application_SC_RENEWALS=11 Application_SC_RENEWALS value
     * @property {number} Application_MA_RENEWALS=12 Application_MA_RENEWALS value
     * @property {number} Application_CONTRACT_MS=13 Application_CONTRACT_MS value
     * @property {number} Application_RENEWAL_ORCHESTRATOR=14 Application_RENEWAL_ORCHESTRATOR value
     * @property {number} Application_WEBSERVICE=15 Application_WEBSERVICE value
     * @property {number} Application_CL=16 Application_CL value
     * @property {number} Application_SC_DTC=17 Application_SC_DTC value
     * @property {number} Application_SC_RE=18 Application_SC_RE value
     * @property {number} Application_RENEWALS_BATCH_JOB=19 Application_RENEWALS_BATCH_JOB value
     */
    common.Application = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "Application_UNKNOWN"] = 0;
        values[valuesById[1] = "Application_CNTRTRPRTL"] = 1;
        values[valuesById[2] = "Application_MYACCOUNT"] = 2;
        values[valuesById[3] = "Application_CSC"] = 3;
        values[valuesById[4] = "Application_MOBILEAPP"] = 4;
        values[valuesById[5] = "Application_ESTREVIEW"] = 5;
        values[valuesById[6] = "Application_DISTHRDPRT"] = 6;
        values[valuesById[7] = "Application_DPCONN"] = 7;
        values[valuesById[8] = "Application_DISPATCHME"] = 8;
        values[valuesById[9] = "Application_DISPMEPRTL"] = 9;
        values[valuesById[10] = "Application_SC"] = 10;
        values[valuesById[11] = "Application_SC_RENEWALS"] = 11;
        values[valuesById[12] = "Application_MA_RENEWALS"] = 12;
        values[valuesById[13] = "Application_CONTRACT_MS"] = 13;
        values[valuesById[14] = "Application_RENEWAL_ORCHESTRATOR"] = 14;
        values[valuesById[15] = "Application_WEBSERVICE"] = 15;
        values[valuesById[16] = "Application_CL"] = 16;
        values[valuesById[17] = "Application_SC_DTC"] = 17;
        values[valuesById[18] = "Application_SC_RE"] = 18;
        values[valuesById[19] = "Application_RENEWALS_BATCH_JOB"] = 19;
        return values;
    })();

    common.HealthCheckDetail = (function() {

        /**
         * Properties of a HealthCheckDetail.
         * @memberof common
         * @interface IHealthCheckDetail
         * @property {string|null} [componentID] HealthCheckDetail componentID
         * @property {string|null} [type] HealthCheckDetail type
         * @property {number|null} [observedValue] HealthCheckDetail observedValue
         * @property {string|null} [observedUnit] HealthCheckDetail observedUnit
         * @property {string|null} [status] HealthCheckDetail status
         * @property {google.protobuf.ITimestamp|null} [time] HealthCheckDetail time
         * @property {string|null} [output] HealthCheckDetail output
         */

        /**
         * Constructs a new HealthCheckDetail.
         * @memberof common
         * @classdesc Represents a HealthCheckDetail.
         * @implements IHealthCheckDetail
         * @constructor
         * @param {common.IHealthCheckDetail=} [p] Properties to set
         */
        function HealthCheckDetail(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * HealthCheckDetail componentID.
         * @member {string} componentID
         * @memberof common.HealthCheckDetail
         * @instance
         */
        HealthCheckDetail.prototype.componentID = "";

        /**
         * HealthCheckDetail type.
         * @member {string} type
         * @memberof common.HealthCheckDetail
         * @instance
         */
        HealthCheckDetail.prototype.type = "";

        /**
         * HealthCheckDetail observedValue.
         * @member {number} observedValue
         * @memberof common.HealthCheckDetail
         * @instance
         */
        HealthCheckDetail.prototype.observedValue = 0;

        /**
         * HealthCheckDetail observedUnit.
         * @member {string} observedUnit
         * @memberof common.HealthCheckDetail
         * @instance
         */
        HealthCheckDetail.prototype.observedUnit = "";

        /**
         * HealthCheckDetail status.
         * @member {string} status
         * @memberof common.HealthCheckDetail
         * @instance
         */
        HealthCheckDetail.prototype.status = "";

        /**
         * HealthCheckDetail time.
         * @member {google.protobuf.ITimestamp|null|undefined} time
         * @memberof common.HealthCheckDetail
         * @instance
         */
        HealthCheckDetail.prototype.time = null;

        /**
         * HealthCheckDetail output.
         * @member {string} output
         * @memberof common.HealthCheckDetail
         * @instance
         */
        HealthCheckDetail.prototype.output = "";

        /**
         * Creates a new HealthCheckDetail instance using the specified properties.
         * @function create
         * @memberof common.HealthCheckDetail
         * @static
         * @param {common.IHealthCheckDetail=} [properties] Properties to set
         * @returns {common.HealthCheckDetail} HealthCheckDetail instance
         */
        HealthCheckDetail.create = function create(properties) {
            return new HealthCheckDetail(properties);
        };

        /**
         * Encodes the specified HealthCheckDetail message. Does not implicitly {@link common.HealthCheckDetail.verify|verify} messages.
         * @function encode
         * @memberof common.HealthCheckDetail
         * @static
         * @param {common.IHealthCheckDetail} m HealthCheckDetail message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        HealthCheckDetail.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.componentID != null && Object.hasOwnProperty.call(m, "componentID"))
                w.uint32(10).string(m.componentID);
            if (m.type != null && Object.hasOwnProperty.call(m, "type"))
                w.uint32(18).string(m.type);
            if (m.observedValue != null && Object.hasOwnProperty.call(m, "observedValue"))
                w.uint32(25).double(m.observedValue);
            if (m.observedUnit != null && Object.hasOwnProperty.call(m, "observedUnit"))
                w.uint32(34).string(m.observedUnit);
            if (m.status != null && Object.hasOwnProperty.call(m, "status"))
                w.uint32(42).string(m.status);
            if (m.time != null && Object.hasOwnProperty.call(m, "time"))
                $root.google.protobuf.Timestamp.encode(m.time, w.uint32(50).fork()).ldelim();
            if (m.output != null && Object.hasOwnProperty.call(m, "output"))
                w.uint32(58).string(m.output);
            return w;
        };

        /**
         * Decodes a HealthCheckDetail message from the specified reader or buffer.
         * @function decode
         * @memberof common.HealthCheckDetail
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {common.HealthCheckDetail} HealthCheckDetail
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        HealthCheckDetail.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.common.HealthCheckDetail();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.componentID = r.string();
                    break;
                case 2:
                    m.type = r.string();
                    break;
                case 3:
                    m.observedValue = r.double();
                    break;
                case 4:
                    m.observedUnit = r.string();
                    break;
                case 5:
                    m.status = r.string();
                    break;
                case 6:
                    m.time = $root.google.protobuf.Timestamp.decode(r, r.uint32());
                    break;
                case 7:
                    m.output = r.string();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return HealthCheckDetail;
    })();

    common.NamedHealthCheckDetail = (function() {

        /**
         * Properties of a NamedHealthCheckDetail.
         * @memberof common
         * @interface INamedHealthCheckDetail
         * @property {string|null} [name] NamedHealthCheckDetail name
         * @property {Array.<common.IHealthCheckDetail>|null} [details] NamedHealthCheckDetail details
         */

        /**
         * Constructs a new NamedHealthCheckDetail.
         * @memberof common
         * @classdesc Represents a NamedHealthCheckDetail.
         * @implements INamedHealthCheckDetail
         * @constructor
         * @param {common.INamedHealthCheckDetail=} [p] Properties to set
         */
        function NamedHealthCheckDetail(p) {
            this.details = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * NamedHealthCheckDetail name.
         * @member {string} name
         * @memberof common.NamedHealthCheckDetail
         * @instance
         */
        NamedHealthCheckDetail.prototype.name = "";

        /**
         * NamedHealthCheckDetail details.
         * @member {Array.<common.IHealthCheckDetail>} details
         * @memberof common.NamedHealthCheckDetail
         * @instance
         */
        NamedHealthCheckDetail.prototype.details = $util.emptyArray;

        /**
         * Creates a new NamedHealthCheckDetail instance using the specified properties.
         * @function create
         * @memberof common.NamedHealthCheckDetail
         * @static
         * @param {common.INamedHealthCheckDetail=} [properties] Properties to set
         * @returns {common.NamedHealthCheckDetail} NamedHealthCheckDetail instance
         */
        NamedHealthCheckDetail.create = function create(properties) {
            return new NamedHealthCheckDetail(properties);
        };

        /**
         * Encodes the specified NamedHealthCheckDetail message. Does not implicitly {@link common.NamedHealthCheckDetail.verify|verify} messages.
         * @function encode
         * @memberof common.NamedHealthCheckDetail
         * @static
         * @param {common.INamedHealthCheckDetail} m NamedHealthCheckDetail message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        NamedHealthCheckDetail.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.name != null && Object.hasOwnProperty.call(m, "name"))
                w.uint32(10).string(m.name);
            if (m.details != null && m.details.length) {
                for (var i = 0; i < m.details.length; ++i)
                    $root.common.HealthCheckDetail.encode(m.details[i], w.uint32(18).fork()).ldelim();
            }
            return w;
        };

        /**
         * Decodes a NamedHealthCheckDetail message from the specified reader or buffer.
         * @function decode
         * @memberof common.NamedHealthCheckDetail
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {common.NamedHealthCheckDetail} NamedHealthCheckDetail
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        NamedHealthCheckDetail.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.common.NamedHealthCheckDetail();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.name = r.string();
                    break;
                case 2:
                    if (!(m.details && m.details.length))
                        m.details = [];
                    m.details.push($root.common.HealthCheckDetail.decode(r, r.uint32()));
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return NamedHealthCheckDetail;
    })();

    common.HealthCheck = (function() {

        /**
         * Properties of a HealthCheck.
         * @memberof common
         * @interface IHealthCheck
         * @property {string|null} [status] HealthCheck status
         * @property {string|null} [version] HealthCheck version
         * @property {string|null} [releaseID] HealthCheck releaseID
         * @property {Array.<string>|null} [notes] HealthCheck notes
         * @property {string|null} [output] HealthCheck output
         * @property {Array.<common.INamedHealthCheckDetail>|null} [details] HealthCheck details
         */

        /**
         * Constructs a new HealthCheck.
         * @memberof common
         * @classdesc Represents a HealthCheck.
         * @implements IHealthCheck
         * @constructor
         * @param {common.IHealthCheck=} [p] Properties to set
         */
        function HealthCheck(p) {
            this.notes = [];
            this.details = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * HealthCheck status.
         * @member {string} status
         * @memberof common.HealthCheck
         * @instance
         */
        HealthCheck.prototype.status = "";

        /**
         * HealthCheck version.
         * @member {string} version
         * @memberof common.HealthCheck
         * @instance
         */
        HealthCheck.prototype.version = "";

        /**
         * HealthCheck releaseID.
         * @member {string} releaseID
         * @memberof common.HealthCheck
         * @instance
         */
        HealthCheck.prototype.releaseID = "";

        /**
         * HealthCheck notes.
         * @member {Array.<string>} notes
         * @memberof common.HealthCheck
         * @instance
         */
        HealthCheck.prototype.notes = $util.emptyArray;

        /**
         * HealthCheck output.
         * @member {string} output
         * @memberof common.HealthCheck
         * @instance
         */
        HealthCheck.prototype.output = "";

        /**
         * HealthCheck details.
         * @member {Array.<common.INamedHealthCheckDetail>} details
         * @memberof common.HealthCheck
         * @instance
         */
        HealthCheck.prototype.details = $util.emptyArray;

        /**
         * Creates a new HealthCheck instance using the specified properties.
         * @function create
         * @memberof common.HealthCheck
         * @static
         * @param {common.IHealthCheck=} [properties] Properties to set
         * @returns {common.HealthCheck} HealthCheck instance
         */
        HealthCheck.create = function create(properties) {
            return new HealthCheck(properties);
        };

        /**
         * Encodes the specified HealthCheck message. Does not implicitly {@link common.HealthCheck.verify|verify} messages.
         * @function encode
         * @memberof common.HealthCheck
         * @static
         * @param {common.IHealthCheck} m HealthCheck message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        HealthCheck.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.status != null && Object.hasOwnProperty.call(m, "status"))
                w.uint32(10).string(m.status);
            if (m.version != null && Object.hasOwnProperty.call(m, "version"))
                w.uint32(18).string(m.version);
            if (m.releaseID != null && Object.hasOwnProperty.call(m, "releaseID"))
                w.uint32(26).string(m.releaseID);
            if (m.notes != null && m.notes.length) {
                for (var i = 0; i < m.notes.length; ++i)
                    w.uint32(34).string(m.notes[i]);
            }
            if (m.output != null && Object.hasOwnProperty.call(m, "output"))
                w.uint32(42).string(m.output);
            if (m.details != null && m.details.length) {
                for (var i = 0; i < m.details.length; ++i)
                    $root.common.NamedHealthCheckDetail.encode(m.details[i], w.uint32(50).fork()).ldelim();
            }
            return w;
        };

        /**
         * Decodes a HealthCheck message from the specified reader or buffer.
         * @function decode
         * @memberof common.HealthCheck
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {common.HealthCheck} HealthCheck
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        HealthCheck.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.common.HealthCheck();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.status = r.string();
                    break;
                case 2:
                    m.version = r.string();
                    break;
                case 3:
                    m.releaseID = r.string();
                    break;
                case 4:
                    if (!(m.notes && m.notes.length))
                        m.notes = [];
                    m.notes.push(r.string());
                    break;
                case 5:
                    m.output = r.string();
                    break;
                case 6:
                    if (!(m.details && m.details.length))
                        m.details = [];
                    m.details.push($root.common.NamedHealthCheckDetail.decode(r, r.uint32()));
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return HealthCheck;
    })();

    common.HealthCheckResponse = (function() {

        /**
         * Properties of a HealthCheckResponse.
         * @memberof common
         * @interface IHealthCheckResponse
         * @property {common.IHealthCheck|null} [health] HealthCheckResponse health
         */

        /**
         * Constructs a new HealthCheckResponse.
         * @memberof common
         * @classdesc Represents a HealthCheckResponse.
         * @implements IHealthCheckResponse
         * @constructor
         * @param {common.IHealthCheckResponse=} [p] Properties to set
         */
        function HealthCheckResponse(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * HealthCheckResponse health.
         * @member {common.IHealthCheck|null|undefined} health
         * @memberof common.HealthCheckResponse
         * @instance
         */
        HealthCheckResponse.prototype.health = null;

        /**
         * Creates a new HealthCheckResponse instance using the specified properties.
         * @function create
         * @memberof common.HealthCheckResponse
         * @static
         * @param {common.IHealthCheckResponse=} [properties] Properties to set
         * @returns {common.HealthCheckResponse} HealthCheckResponse instance
         */
        HealthCheckResponse.create = function create(properties) {
            return new HealthCheckResponse(properties);
        };

        /**
         * Encodes the specified HealthCheckResponse message. Does not implicitly {@link common.HealthCheckResponse.verify|verify} messages.
         * @function encode
         * @memberof common.HealthCheckResponse
         * @static
         * @param {common.IHealthCheckResponse} m HealthCheckResponse message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        HealthCheckResponse.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.health != null && Object.hasOwnProperty.call(m, "health"))
                $root.common.HealthCheck.encode(m.health, w.uint32(10).fork()).ldelim();
            return w;
        };

        /**
         * Decodes a HealthCheckResponse message from the specified reader or buffer.
         * @function decode
         * @memberof common.HealthCheckResponse
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {common.HealthCheckResponse} HealthCheckResponse
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        HealthCheckResponse.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.common.HealthCheckResponse();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.health = $root.common.HealthCheck.decode(r, r.uint32());
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return HealthCheckResponse;
    })();

    common.Timeslot = (function() {

        /**
         * Properties of a Timeslot.
         * @memberof common
         * @interface ITimeslot
         * @property {google.protobuf.ITimestamp|null} [start] Timeslot start
         * @property {google.protobuf.ITimestamp|null} [end] Timeslot end
         */

        /**
         * Constructs a new Timeslot.
         * @memberof common
         * @classdesc Represents a Timeslot.
         * @implements ITimeslot
         * @constructor
         * @param {common.ITimeslot=} [p] Properties to set
         */
        function Timeslot(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * Timeslot start.
         * @member {google.protobuf.ITimestamp|null|undefined} start
         * @memberof common.Timeslot
         * @instance
         */
        Timeslot.prototype.start = null;

        /**
         * Timeslot end.
         * @member {google.protobuf.ITimestamp|null|undefined} end
         * @memberof common.Timeslot
         * @instance
         */
        Timeslot.prototype.end = null;

        /**
         * Creates a new Timeslot instance using the specified properties.
         * @function create
         * @memberof common.Timeslot
         * @static
         * @param {common.ITimeslot=} [properties] Properties to set
         * @returns {common.Timeslot} Timeslot instance
         */
        Timeslot.create = function create(properties) {
            return new Timeslot(properties);
        };

        /**
         * Encodes the specified Timeslot message. Does not implicitly {@link common.Timeslot.verify|verify} messages.
         * @function encode
         * @memberof common.Timeslot
         * @static
         * @param {common.ITimeslot} m Timeslot message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Timeslot.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.start != null && Object.hasOwnProperty.call(m, "start"))
                $root.google.protobuf.Timestamp.encode(m.start, w.uint32(10).fork()).ldelim();
            if (m.end != null && Object.hasOwnProperty.call(m, "end"))
                $root.google.protobuf.Timestamp.encode(m.end, w.uint32(18).fork()).ldelim();
            return w;
        };

        /**
         * Decodes a Timeslot message from the specified reader or buffer.
         * @function decode
         * @memberof common.Timeslot
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {common.Timeslot} Timeslot
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Timeslot.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.common.Timeslot();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.start = $root.google.protobuf.Timestamp.decode(r, r.uint32());
                    break;
                case 2:
                    m.end = $root.google.protobuf.Timestamp.decode(r, r.uint32());
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return Timeslot;
    })();

    common.ErrorResponse = (function() {

        /**
         * Properties of an ErrorResponse.
         * @memberof common
         * @interface IErrorResponse
         * @property {Array.<common.IError>|null} [errors] ErrorResponse errors
         */

        /**
         * Constructs a new ErrorResponse.
         * @memberof common
         * @classdesc Represents an ErrorResponse.
         * @implements IErrorResponse
         * @constructor
         * @param {common.IErrorResponse=} [p] Properties to set
         */
        function ErrorResponse(p) {
            this.errors = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * ErrorResponse errors.
         * @member {Array.<common.IError>} errors
         * @memberof common.ErrorResponse
         * @instance
         */
        ErrorResponse.prototype.errors = $util.emptyArray;

        /**
         * Creates a new ErrorResponse instance using the specified properties.
         * @function create
         * @memberof common.ErrorResponse
         * @static
         * @param {common.IErrorResponse=} [properties] Properties to set
         * @returns {common.ErrorResponse} ErrorResponse instance
         */
        ErrorResponse.create = function create(properties) {
            return new ErrorResponse(properties);
        };

        /**
         * Encodes the specified ErrorResponse message. Does not implicitly {@link common.ErrorResponse.verify|verify} messages.
         * @function encode
         * @memberof common.ErrorResponse
         * @static
         * @param {common.IErrorResponse} m ErrorResponse message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ErrorResponse.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.errors != null && m.errors.length) {
                for (var i = 0; i < m.errors.length; ++i)
                    $root.common.Error.encode(m.errors[i], w.uint32(10).fork()).ldelim();
            }
            return w;
        };

        /**
         * Decodes an ErrorResponse message from the specified reader or buffer.
         * @function decode
         * @memberof common.ErrorResponse
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {common.ErrorResponse} ErrorResponse
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ErrorResponse.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.common.ErrorResponse();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    if (!(m.errors && m.errors.length))
                        m.errors = [];
                    m.errors.push($root.common.Error.decode(r, r.uint32()));
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return ErrorResponse;
    })();

    common.Error = (function() {

        /**
         * Properties of an Error.
         * @memberof common
         * @interface IError
         * @property {string|null} [message] Error message
         * @property {string|null} [code] Error code
         */

        /**
         * Constructs a new Error.
         * @memberof common
         * @classdesc Represents an Error.
         * @implements IError
         * @constructor
         * @param {common.IError=} [p] Properties to set
         */
        function Error(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * Error message.
         * @member {string} message
         * @memberof common.Error
         * @instance
         */
        Error.prototype.message = "";

        /**
         * Error code.
         * @member {string} code
         * @memberof common.Error
         * @instance
         */
        Error.prototype.code = "";

        /**
         * Creates a new Error instance using the specified properties.
         * @function create
         * @memberof common.Error
         * @static
         * @param {common.IError=} [properties] Properties to set
         * @returns {common.Error} Error instance
         */
        Error.create = function create(properties) {
            return new Error(properties);
        };

        /**
         * Encodes the specified Error message. Does not implicitly {@link common.Error.verify|verify} messages.
         * @function encode
         * @memberof common.Error
         * @static
         * @param {common.IError} m Error message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Error.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.message != null && Object.hasOwnProperty.call(m, "message"))
                w.uint32(10).string(m.message);
            if (m.code != null && Object.hasOwnProperty.call(m, "code"))
                w.uint32(18).string(m.code);
            return w;
        };

        /**
         * Decodes an Error message from the specified reader or buffer.
         * @function decode
         * @memberof common.Error
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {common.Error} Error
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Error.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.common.Error();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.message = r.string();
                    break;
                case 2:
                    m.code = r.string();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return Error;
    })();

    common.Money = (function() {

        /**
         * Properties of a Money.
         * @memberof common
         * @interface IMoney
         * @property {string|null} [currencyCode] Money currencyCode
         * @property {number|Long|null} [units] Money units
         * @property {number|null} [nanos] Money nanos
         */

        /**
         * Constructs a new Money.
         * @memberof common
         * @classdesc Represents a Money.
         * @implements IMoney
         * @constructor
         * @param {common.IMoney=} [p] Properties to set
         */
        function Money(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * Money currencyCode.
         * @member {string} currencyCode
         * @memberof common.Money
         * @instance
         */
        Money.prototype.currencyCode = "";

        /**
         * Money units.
         * @member {number|Long} units
         * @memberof common.Money
         * @instance
         */
        Money.prototype.units = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * Money nanos.
         * @member {number} nanos
         * @memberof common.Money
         * @instance
         */
        Money.prototype.nanos = 0;

        /**
         * Creates a new Money instance using the specified properties.
         * @function create
         * @memberof common.Money
         * @static
         * @param {common.IMoney=} [properties] Properties to set
         * @returns {common.Money} Money instance
         */
        Money.create = function create(properties) {
            return new Money(properties);
        };

        /**
         * Encodes the specified Money message. Does not implicitly {@link common.Money.verify|verify} messages.
         * @function encode
         * @memberof common.Money
         * @static
         * @param {common.IMoney} m Money message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Money.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.currencyCode != null && Object.hasOwnProperty.call(m, "currencyCode"))
                w.uint32(10).string(m.currencyCode);
            if (m.units != null && Object.hasOwnProperty.call(m, "units"))
                w.uint32(16).int64(m.units);
            if (m.nanos != null && Object.hasOwnProperty.call(m, "nanos"))
                w.uint32(24).int32(m.nanos);
            return w;
        };

        /**
         * Decodes a Money message from the specified reader or buffer.
         * @function decode
         * @memberof common.Money
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {common.Money} Money
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Money.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.common.Money();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.currencyCode = r.string();
                    break;
                case 2:
                    m.units = r.int64();
                    break;
                case 3:
                    m.nanos = r.int32();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return Money;
    })();

    common.Date = (function() {

        /**
         * Properties of a Date.
         * @memberof common
         * @interface IDate
         * @property {number|null} [year] Date year
         * @property {number|null} [month] Date month
         * @property {number|null} [day] Date day
         */

        /**
         * Constructs a new Date.
         * @memberof common
         * @classdesc Represents a Date.
         * @implements IDate
         * @constructor
         * @param {common.IDate=} [p] Properties to set
         */
        function Date(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * Date year.
         * @member {number} year
         * @memberof common.Date
         * @instance
         */
        Date.prototype.year = 0;

        /**
         * Date month.
         * @member {number} month
         * @memberof common.Date
         * @instance
         */
        Date.prototype.month = 0;

        /**
         * Date day.
         * @member {number} day
         * @memberof common.Date
         * @instance
         */
        Date.prototype.day = 0;

        /**
         * Creates a new Date instance using the specified properties.
         * @function create
         * @memberof common.Date
         * @static
         * @param {common.IDate=} [properties] Properties to set
         * @returns {common.Date} Date instance
         */
        Date.create = function create(properties) {
            return new Date(properties);
        };

        /**
         * Encodes the specified Date message. Does not implicitly {@link common.Date.verify|verify} messages.
         * @function encode
         * @memberof common.Date
         * @static
         * @param {common.IDate} m Date message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Date.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.year != null && Object.hasOwnProperty.call(m, "year"))
                w.uint32(8).int32(m.year);
            if (m.month != null && Object.hasOwnProperty.call(m, "month"))
                w.uint32(16).int32(m.month);
            if (m.day != null && Object.hasOwnProperty.call(m, "day"))
                w.uint32(24).int32(m.day);
            return w;
        };

        /**
         * Decodes a Date message from the specified reader or buffer.
         * @function decode
         * @memberof common.Date
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {common.Date} Date
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Date.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.common.Date();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.year = r.int32();
                    break;
                case 2:
                    m.month = r.int32();
                    break;
                case 3:
                    m.day = r.int32();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return Date;
    })();

    common.GeoLocation = (function() {

        /**
         * Properties of a GeoLocation.
         * @memberof common
         * @interface IGeoLocation
         * @property {number|null} [latitude] GeoLocation latitude
         * @property {number|null} [longitude] GeoLocation longitude
         */

        /**
         * Constructs a new GeoLocation.
         * @memberof common
         * @classdesc Represents a GeoLocation.
         * @implements IGeoLocation
         * @constructor
         * @param {common.IGeoLocation=} [p] Properties to set
         */
        function GeoLocation(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * GeoLocation latitude.
         * @member {number} latitude
         * @memberof common.GeoLocation
         * @instance
         */
        GeoLocation.prototype.latitude = 0;

        /**
         * GeoLocation longitude.
         * @member {number} longitude
         * @memberof common.GeoLocation
         * @instance
         */
        GeoLocation.prototype.longitude = 0;

        /**
         * Creates a new GeoLocation instance using the specified properties.
         * @function create
         * @memberof common.GeoLocation
         * @static
         * @param {common.IGeoLocation=} [properties] Properties to set
         * @returns {common.GeoLocation} GeoLocation instance
         */
        GeoLocation.create = function create(properties) {
            return new GeoLocation(properties);
        };

        /**
         * Encodes the specified GeoLocation message. Does not implicitly {@link common.GeoLocation.verify|verify} messages.
         * @function encode
         * @memberof common.GeoLocation
         * @static
         * @param {common.IGeoLocation} m GeoLocation message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GeoLocation.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.latitude != null && Object.hasOwnProperty.call(m, "latitude"))
                w.uint32(13).float(m.latitude);
            if (m.longitude != null && Object.hasOwnProperty.call(m, "longitude"))
                w.uint32(21).float(m.longitude);
            return w;
        };

        /**
         * Decodes a GeoLocation message from the specified reader or buffer.
         * @function decode
         * @memberof common.GeoLocation
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {common.GeoLocation} GeoLocation
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GeoLocation.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.common.GeoLocation();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.latitude = r.float();
                    break;
                case 2:
                    m.longitude = r.float();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return GeoLocation;
    })();

    /**
     * Locale enum.
     * @name common.Locale
     * @enum {number}
     * @property {number} EN=0 EN value
     * @property {number} ES=1 ES value
     */
    common.Locale = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "EN"] = 0;
        values[valuesById[1] = "ES"] = 1;
        return values;
    })();

    common.Range_U32 = (function() {

        /**
         * Properties of a Range_U32.
         * @memberof common
         * @interface IRange_U32
         * @property {number|null} [min] Range_U32 min
         * @property {number|null} [max] Range_U32 max
         */

        /**
         * Constructs a new Range_U32.
         * @memberof common
         * @classdesc Represents a Range_U32.
         * @implements IRange_U32
         * @constructor
         * @param {common.IRange_U32=} [p] Properties to set
         */
        function Range_U32(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * Range_U32 min.
         * @member {number} min
         * @memberof common.Range_U32
         * @instance
         */
        Range_U32.prototype.min = 0;

        /**
         * Range_U32 max.
         * @member {number} max
         * @memberof common.Range_U32
         * @instance
         */
        Range_U32.prototype.max = 0;

        /**
         * Creates a new Range_U32 instance using the specified properties.
         * @function create
         * @memberof common.Range_U32
         * @static
         * @param {common.IRange_U32=} [properties] Properties to set
         * @returns {common.Range_U32} Range_U32 instance
         */
        Range_U32.create = function create(properties) {
            return new Range_U32(properties);
        };

        /**
         * Encodes the specified Range_U32 message. Does not implicitly {@link common.Range_U32.verify|verify} messages.
         * @function encode
         * @memberof common.Range_U32
         * @static
         * @param {common.IRange_U32} m Range_U32 message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Range_U32.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.min != null && Object.hasOwnProperty.call(m, "min"))
                w.uint32(8).uint32(m.min);
            if (m.max != null && Object.hasOwnProperty.call(m, "max"))
                w.uint32(16).uint32(m.max);
            return w;
        };

        /**
         * Decodes a Range_U32 message from the specified reader or buffer.
         * @function decode
         * @memberof common.Range_U32
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {common.Range_U32} Range_U32
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Range_U32.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.common.Range_U32();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.min = r.uint32();
                    break;
                case 2:
                    m.max = r.uint32();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return Range_U32;
    })();

    common.ApplicationSource = (function() {

        /**
         * Properties of an ApplicationSource.
         * @memberof common
         * @interface IApplicationSource
         * @property {string|null} [name] ApplicationSource name
         * @property {string|null} [version] ApplicationSource version
         * @property {string|null} [authorVersion] ApplicationSource authorVersion
         */

        /**
         * Constructs a new ApplicationSource.
         * @memberof common
         * @classdesc Represents an ApplicationSource.
         * @implements IApplicationSource
         * @constructor
         * @param {common.IApplicationSource=} [p] Properties to set
         */
        function ApplicationSource(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * ApplicationSource name.
         * @member {string} name
         * @memberof common.ApplicationSource
         * @instance
         */
        ApplicationSource.prototype.name = "";

        /**
         * ApplicationSource version.
         * @member {string} version
         * @memberof common.ApplicationSource
         * @instance
         */
        ApplicationSource.prototype.version = "";

        /**
         * ApplicationSource authorVersion.
         * @member {string} authorVersion
         * @memberof common.ApplicationSource
         * @instance
         */
        ApplicationSource.prototype.authorVersion = "";

        /**
         * Creates a new ApplicationSource instance using the specified properties.
         * @function create
         * @memberof common.ApplicationSource
         * @static
         * @param {common.IApplicationSource=} [properties] Properties to set
         * @returns {common.ApplicationSource} ApplicationSource instance
         */
        ApplicationSource.create = function create(properties) {
            return new ApplicationSource(properties);
        };

        /**
         * Encodes the specified ApplicationSource message. Does not implicitly {@link common.ApplicationSource.verify|verify} messages.
         * @function encode
         * @memberof common.ApplicationSource
         * @static
         * @param {common.IApplicationSource} m ApplicationSource message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ApplicationSource.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.name != null && Object.hasOwnProperty.call(m, "name"))
                w.uint32(10).string(m.name);
            if (m.version != null && Object.hasOwnProperty.call(m, "version"))
                w.uint32(18).string(m.version);
            if (m.authorVersion != null && Object.hasOwnProperty.call(m, "authorVersion"))
                w.uint32(26).string(m.authorVersion);
            return w;
        };

        /**
         * Decodes an ApplicationSource message from the specified reader or buffer.
         * @function decode
         * @memberof common.ApplicationSource
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {common.ApplicationSource} ApplicationSource
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ApplicationSource.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.common.ApplicationSource();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.name = r.string();
                    break;
                case 2:
                    m.version = r.string();
                    break;
                case 3:
                    m.authorVersion = r.string();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return ApplicationSource;
    })();

    common.Pagination = (function() {

        /**
         * Properties of a Pagination.
         * @memberof common
         * @interface IPagination
         * @property {number|null} [currentPage] Pagination currentPage
         * @property {number|null} [itemsPerPage] Pagination itemsPerPage
         * @property {number|null} [totalPages] Pagination totalPages
         * @property {number|null} [totalRecords] Pagination totalRecords
         */

        /**
         * Constructs a new Pagination.
         * @memberof common
         * @classdesc Represents a Pagination.
         * @implements IPagination
         * @constructor
         * @param {common.IPagination=} [p] Properties to set
         */
        function Pagination(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * Pagination currentPage.
         * @member {number} currentPage
         * @memberof common.Pagination
         * @instance
         */
        Pagination.prototype.currentPage = 0;

        /**
         * Pagination itemsPerPage.
         * @member {number} itemsPerPage
         * @memberof common.Pagination
         * @instance
         */
        Pagination.prototype.itemsPerPage = 0;

        /**
         * Pagination totalPages.
         * @member {number} totalPages
         * @memberof common.Pagination
         * @instance
         */
        Pagination.prototype.totalPages = 0;

        /**
         * Pagination totalRecords.
         * @member {number} totalRecords
         * @memberof common.Pagination
         * @instance
         */
        Pagination.prototype.totalRecords = 0;

        /**
         * Creates a new Pagination instance using the specified properties.
         * @function create
         * @memberof common.Pagination
         * @static
         * @param {common.IPagination=} [properties] Properties to set
         * @returns {common.Pagination} Pagination instance
         */
        Pagination.create = function create(properties) {
            return new Pagination(properties);
        };

        /**
         * Encodes the specified Pagination message. Does not implicitly {@link common.Pagination.verify|verify} messages.
         * @function encode
         * @memberof common.Pagination
         * @static
         * @param {common.IPagination} m Pagination message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Pagination.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.currentPage != null && Object.hasOwnProperty.call(m, "currentPage"))
                w.uint32(8).int32(m.currentPage);
            if (m.itemsPerPage != null && Object.hasOwnProperty.call(m, "itemsPerPage"))
                w.uint32(16).int32(m.itemsPerPage);
            if (m.totalPages != null && Object.hasOwnProperty.call(m, "totalPages"))
                w.uint32(24).int32(m.totalPages);
            if (m.totalRecords != null && Object.hasOwnProperty.call(m, "totalRecords"))
                w.uint32(32).int32(m.totalRecords);
            return w;
        };

        /**
         * Decodes a Pagination message from the specified reader or buffer.
         * @function decode
         * @memberof common.Pagination
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {common.Pagination} Pagination
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Pagination.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.common.Pagination();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.currentPage = r.int32();
                    break;
                case 2:
                    m.itemsPerPage = r.int32();
                    break;
                case 3:
                    m.totalPages = r.int32();
                    break;
                case 4:
                    m.totalRecords = r.int32();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return Pagination;
    })();

    common.PaginationRequest = (function() {

        /**
         * Properties of a PaginationRequest.
         * @memberof common
         * @interface IPaginationRequest
         * @property {number|null} [currentPage] PaginationRequest currentPage
         * @property {number|null} [itemsPerPage] PaginationRequest itemsPerPage
         */

        /**
         * Constructs a new PaginationRequest.
         * @memberof common
         * @classdesc Represents a PaginationRequest.
         * @implements IPaginationRequest
         * @constructor
         * @param {common.IPaginationRequest=} [p] Properties to set
         */
        function PaginationRequest(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * PaginationRequest currentPage.
         * @member {number} currentPage
         * @memberof common.PaginationRequest
         * @instance
         */
        PaginationRequest.prototype.currentPage = 0;

        /**
         * PaginationRequest itemsPerPage.
         * @member {number} itemsPerPage
         * @memberof common.PaginationRequest
         * @instance
         */
        PaginationRequest.prototype.itemsPerPage = 0;

        /**
         * Creates a new PaginationRequest instance using the specified properties.
         * @function create
         * @memberof common.PaginationRequest
         * @static
         * @param {common.IPaginationRequest=} [properties] Properties to set
         * @returns {common.PaginationRequest} PaginationRequest instance
         */
        PaginationRequest.create = function create(properties) {
            return new PaginationRequest(properties);
        };

        /**
         * Encodes the specified PaginationRequest message. Does not implicitly {@link common.PaginationRequest.verify|verify} messages.
         * @function encode
         * @memberof common.PaginationRequest
         * @static
         * @param {common.IPaginationRequest} m PaginationRequest message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        PaginationRequest.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.currentPage != null && Object.hasOwnProperty.call(m, "currentPage"))
                w.uint32(8).uint32(m.currentPage);
            if (m.itemsPerPage != null && Object.hasOwnProperty.call(m, "itemsPerPage"))
                w.uint32(16).uint32(m.itemsPerPage);
            return w;
        };

        /**
         * Decodes a PaginationRequest message from the specified reader or buffer.
         * @function decode
         * @memberof common.PaginationRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {common.PaginationRequest} PaginationRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        PaginationRequest.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.common.PaginationRequest();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.currentPage = r.uint32();
                    break;
                case 2:
                    m.itemsPerPage = r.uint32();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        return PaginationRequest;
    })();

    /**
     * USStateAlphaCode enum.
     * @name common.USStateAlphaCode
     * @enum {number}
     * @property {number} UnknownState=0 UnknownState value
     * @property {number} AL=1 AL value
     * @property {number} AK=2 AK value
     * @property {number} AZ=3 AZ value
     * @property {number} AR=4 AR value
     * @property {number} CA=5 CA value
     * @property {number} CO=6 CO value
     * @property {number} CT=7 CT value
     * @property {number} DE=11 DE value
     * @property {number} DC=12 DC value
     * @property {number} FL=13 FL value
     * @property {number} GA=21 GA value
     * @property {number} HI=22 HI value
     * @property {number} ID=23 ID value
     * @property {number} IL=24 IL value
     * @property {number} IN=25 IN value
     * @property {number} IA=26 IA value
     * @property {number} KS=31 KS value
     * @property {number} KY=32 KY value
     * @property {number} LA=33 LA value
     * @property {number} ME=41 ME value
     * @property {number} MD=42 MD value
     * @property {number} MA=43 MA value
     * @property {number} MI=44 MI value
     * @property {number} MN=45 MN value
     * @property {number} MS=46 MS value
     * @property {number} MO=47 MO value
     * @property {number} MT=48 MT value
     * @property {number} NE=51 NE value
     * @property {number} NV=52 NV value
     * @property {number} NH=53 NH value
     * @property {number} NJ=54 NJ value
     * @property {number} NM=55 NM value
     * @property {number} NY=56 NY value
     * @property {number} NC=57 NC value
     * @property {number} ND=58 ND value
     * @property {number} OH=61 OH value
     * @property {number} OK=62 OK value
     * @property {number} OR=63 OR value
     * @property {number} PA=64 PA value
     * @property {number} RI=65 RI value
     * @property {number} SC=66 SC value
     * @property {number} SD=67 SD value
     * @property {number} TN=71 TN value
     * @property {number} TX=72 TX value
     * @property {number} UT=73 UT value
     * @property {number} VT=74 VT value
     * @property {number} VA=75 VA value
     * @property {number} WA=76 WA value
     * @property {number} WV=77 WV value
     * @property {number} WI=78 WI value
     * @property {number} WY=79 WY value
     */
    common.USStateAlphaCode = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "UnknownState"] = 0;
        values[valuesById[1] = "AL"] = 1;
        values[valuesById[2] = "AK"] = 2;
        values[valuesById[3] = "AZ"] = 3;
        values[valuesById[4] = "AR"] = 4;
        values[valuesById[5] = "CA"] = 5;
        values[valuesById[6] = "CO"] = 6;
        values[valuesById[7] = "CT"] = 7;
        values[valuesById[11] = "DE"] = 11;
        values[valuesById[12] = "DC"] = 12;
        values[valuesById[13] = "FL"] = 13;
        values[valuesById[21] = "GA"] = 21;
        values[valuesById[22] = "HI"] = 22;
        values[valuesById[23] = "ID"] = 23;
        values[valuesById[24] = "IL"] = 24;
        values[valuesById[25] = "IN"] = 25;
        values[valuesById[26] = "IA"] = 26;
        values[valuesById[31] = "KS"] = 31;
        values[valuesById[32] = "KY"] = 32;
        values[valuesById[33] = "LA"] = 33;
        values[valuesById[41] = "ME"] = 41;
        values[valuesById[42] = "MD"] = 42;
        values[valuesById[43] = "MA"] = 43;
        values[valuesById[44] = "MI"] = 44;
        values[valuesById[45] = "MN"] = 45;
        values[valuesById[46] = "MS"] = 46;
        values[valuesById[47] = "MO"] = 47;
        values[valuesById[48] = "MT"] = 48;
        values[valuesById[51] = "NE"] = 51;
        values[valuesById[52] = "NV"] = 52;
        values[valuesById[53] = "NH"] = 53;
        values[valuesById[54] = "NJ"] = 54;
        values[valuesById[55] = "NM"] = 55;
        values[valuesById[56] = "NY"] = 56;
        values[valuesById[57] = "NC"] = 57;
        values[valuesById[58] = "ND"] = 58;
        values[valuesById[61] = "OH"] = 61;
        values[valuesById[62] = "OK"] = 62;
        values[valuesById[63] = "OR"] = 63;
        values[valuesById[64] = "PA"] = 64;
        values[valuesById[65] = "RI"] = 65;
        values[valuesById[66] = "SC"] = 66;
        values[valuesById[67] = "SD"] = 67;
        values[valuesById[71] = "TN"] = 71;
        values[valuesById[72] = "TX"] = 72;
        values[valuesById[73] = "UT"] = 73;
        values[valuesById[74] = "VT"] = 74;
        values[valuesById[75] = "VA"] = 75;
        values[valuesById[76] = "WA"] = 76;
        values[valuesById[77] = "WV"] = 77;
        values[valuesById[78] = "WI"] = 78;
        values[valuesById[79] = "WY"] = 79;
        return values;
    })();

    common.AuditTrailEntry = (function() {

        /**
         * Properties of an AuditTrailEntry.
         * @memberof common
         * @interface IAuditTrailEntry
         * @property {google.protobuf.ITimestamp|null} [createdOn] AuditTrailEntry createdOn
         * @property {string|null} [createdBy] AuditTrailEntry createdBy
         * @property {Array.<common.AuditTrailEntry.IAuditTrailEntryDetail>|null} [details] AuditTrailEntry details
         */

        /**
         * Constructs a new AuditTrailEntry.
         * @memberof common
         * @classdesc Represents an AuditTrailEntry.
         * @implements IAuditTrailEntry
         * @constructor
         * @param {common.IAuditTrailEntry=} [p] Properties to set
         */
        function AuditTrailEntry(p) {
            this.details = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * AuditTrailEntry createdOn.
         * @member {google.protobuf.ITimestamp|null|undefined} createdOn
         * @memberof common.AuditTrailEntry
         * @instance
         */
        AuditTrailEntry.prototype.createdOn = null;

        /**
         * AuditTrailEntry createdBy.
         * @member {string} createdBy
         * @memberof common.AuditTrailEntry
         * @instance
         */
        AuditTrailEntry.prototype.createdBy = "";

        /**
         * AuditTrailEntry details.
         * @member {Array.<common.AuditTrailEntry.IAuditTrailEntryDetail>} details
         * @memberof common.AuditTrailEntry
         * @instance
         */
        AuditTrailEntry.prototype.details = $util.emptyArray;

        /**
         * Creates a new AuditTrailEntry instance using the specified properties.
         * @function create
         * @memberof common.AuditTrailEntry
         * @static
         * @param {common.IAuditTrailEntry=} [properties] Properties to set
         * @returns {common.AuditTrailEntry} AuditTrailEntry instance
         */
        AuditTrailEntry.create = function create(properties) {
            return new AuditTrailEntry(properties);
        };

        /**
         * Encodes the specified AuditTrailEntry message. Does not implicitly {@link common.AuditTrailEntry.verify|verify} messages.
         * @function encode
         * @memberof common.AuditTrailEntry
         * @static
         * @param {common.IAuditTrailEntry} m AuditTrailEntry message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        AuditTrailEntry.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.createdOn != null && Object.hasOwnProperty.call(m, "createdOn"))
                $root.google.protobuf.Timestamp.encode(m.createdOn, w.uint32(10).fork()).ldelim();
            if (m.createdBy != null && Object.hasOwnProperty.call(m, "createdBy"))
                w.uint32(18).string(m.createdBy);
            if (m.details != null && m.details.length) {
                for (var i = 0; i < m.details.length; ++i)
                    $root.common.AuditTrailEntry.AuditTrailEntryDetail.encode(m.details[i], w.uint32(26).fork()).ldelim();
            }
            return w;
        };

        /**
         * Decodes an AuditTrailEntry message from the specified reader or buffer.
         * @function decode
         * @memberof common.AuditTrailEntry
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {common.AuditTrailEntry} AuditTrailEntry
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        AuditTrailEntry.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.common.AuditTrailEntry();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.createdOn = $root.google.protobuf.Timestamp.decode(r, r.uint32());
                    break;
                case 2:
                    m.createdBy = r.string();
                    break;
                case 3:
                    if (!(m.details && m.details.length))
                        m.details = [];
                    m.details.push($root.common.AuditTrailEntry.AuditTrailEntryDetail.decode(r, r.uint32()));
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        AuditTrailEntry.AuditTrailEntryDetail = (function() {

            /**
             * Properties of an AuditTrailEntryDetail.
             * @memberof common.AuditTrailEntry
             * @interface IAuditTrailEntryDetail
             * @property {string|null} [type] AuditTrailEntryDetail type
             * @property {Object.<string,string>|null} [old] AuditTrailEntryDetail old
             * @property {Object.<string,string>|null} ["new"] AuditTrailEntryDetail new
             */

            /**
             * Constructs a new AuditTrailEntryDetail.
             * @memberof common.AuditTrailEntry
             * @classdesc Represents an AuditTrailEntryDetail.
             * @implements IAuditTrailEntryDetail
             * @constructor
             * @param {common.AuditTrailEntry.IAuditTrailEntryDetail=} [p] Properties to set
             */
            function AuditTrailEntryDetail(p) {
                this.old = {};
                this["new"] = {};
                if (p)
                    for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                        if (p[ks[i]] != null)
                            this[ks[i]] = p[ks[i]];
            }

            /**
             * AuditTrailEntryDetail type.
             * @member {string} type
             * @memberof common.AuditTrailEntry.AuditTrailEntryDetail
             * @instance
             */
            AuditTrailEntryDetail.prototype.type = "";

            /**
             * AuditTrailEntryDetail old.
             * @member {Object.<string,string>} old
             * @memberof common.AuditTrailEntry.AuditTrailEntryDetail
             * @instance
             */
            AuditTrailEntryDetail.prototype.old = $util.emptyObject;

            /**
             * AuditTrailEntryDetail new.
             * @member {Object.<string,string>} new
             * @memberof common.AuditTrailEntry.AuditTrailEntryDetail
             * @instance
             */
            AuditTrailEntryDetail.prototype["new"] = $util.emptyObject;

            /**
             * Creates a new AuditTrailEntryDetail instance using the specified properties.
             * @function create
             * @memberof common.AuditTrailEntry.AuditTrailEntryDetail
             * @static
             * @param {common.AuditTrailEntry.IAuditTrailEntryDetail=} [properties] Properties to set
             * @returns {common.AuditTrailEntry.AuditTrailEntryDetail} AuditTrailEntryDetail instance
             */
            AuditTrailEntryDetail.create = function create(properties) {
                return new AuditTrailEntryDetail(properties);
            };

            /**
             * Encodes the specified AuditTrailEntryDetail message. Does not implicitly {@link common.AuditTrailEntry.AuditTrailEntryDetail.verify|verify} messages.
             * @function encode
             * @memberof common.AuditTrailEntry.AuditTrailEntryDetail
             * @static
             * @param {common.AuditTrailEntry.IAuditTrailEntryDetail} m AuditTrailEntryDetail message or plain object to encode
             * @param {$protobuf.Writer} [w] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            AuditTrailEntryDetail.encode = function encode(m, w) {
                if (!w)
                    w = $Writer.create();
                if (m.type != null && Object.hasOwnProperty.call(m, "type"))
                    w.uint32(10).string(m.type);
                if (m.old != null && Object.hasOwnProperty.call(m, "old")) {
                    for (var ks = Object.keys(m.old), i = 0; i < ks.length; ++i) {
                        w.uint32(18).fork().uint32(10).string(ks[i]).uint32(18).string(m.old[ks[i]]).ldelim();
                    }
                }
                if (m["new"] != null && Object.hasOwnProperty.call(m, "new")) {
                    for (var ks = Object.keys(m["new"]), i = 0; i < ks.length; ++i) {
                        w.uint32(26).fork().uint32(10).string(ks[i]).uint32(18).string(m["new"][ks[i]]).ldelim();
                    }
                }
                return w;
            };

            /**
             * Decodes an AuditTrailEntryDetail message from the specified reader or buffer.
             * @function decode
             * @memberof common.AuditTrailEntry.AuditTrailEntryDetail
             * @static
             * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
             * @param {number} [l] Message length if known beforehand
             * @returns {common.AuditTrailEntry.AuditTrailEntryDetail} AuditTrailEntryDetail
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            AuditTrailEntryDetail.decode = function decode(r, l) {
                if (!(r instanceof $Reader))
                    r = $Reader.create(r);
                var c = l === undefined ? r.len : r.pos + l, m = new $root.common.AuditTrailEntry.AuditTrailEntryDetail(), k, value;
                while (r.pos < c) {
                    var t = r.uint32();
                    switch (t >>> 3) {
                    case 1:
                        m.type = r.string();
                        break;
                    case 2:
                        if (m.old === $util.emptyObject)
                            m.old = {};
                        var c2 = r.uint32() + r.pos;
                        k = "";
                        value = "";
                        while (r.pos < c2) {
                            var tag2 = r.uint32();
                            switch (tag2 >>> 3) {
                            case 1:
                                k = r.string();
                                break;
                            case 2:
                                value = r.string();
                                break;
                            default:
                                r.skipType(tag2 & 7);
                                break;
                            }
                        }
                        m.old[k] = value;
                        break;
                    case 3:
                        if (m["new"] === $util.emptyObject)
                            m["new"] = {};
                        var c2 = r.uint32() + r.pos;
                        k = "";
                        value = "";
                        while (r.pos < c2) {
                            var tag2 = r.uint32();
                            switch (tag2 >>> 3) {
                            case 1:
                                k = r.string();
                                break;
                            case 2:
                                value = r.string();
                                break;
                            default:
                                r.skipType(tag2 & 7);
                                break;
                            }
                        }
                        m["new"][k] = value;
                        break;
                    default:
                        r.skipType(t & 7);
                        break;
                    }
                }
                return m;
            };

            return AuditTrailEntryDetail;
        })();

        return AuditTrailEntry;
    })();

    return common;
})();

export const google = $root.google = (() => {

    /**
     * Namespace google.
     * @exports google
     * @namespace
     */
    const google = {};

    google.protobuf = (function() {

        /**
         * Namespace protobuf.
         * @memberof google
         * @namespace
         */
        const protobuf = {};

        protobuf.FileDescriptorSet = (function() {

            /**
             * Properties of a FileDescriptorSet.
             * @memberof google.protobuf
             * @interface IFileDescriptorSet
             * @property {Array.<google.protobuf.IFileDescriptorProto>|null} [file] FileDescriptorSet file
             */

            /**
             * Constructs a new FileDescriptorSet.
             * @memberof google.protobuf
             * @classdesc Represents a FileDescriptorSet.
             * @implements IFileDescriptorSet
             * @constructor
             * @param {google.protobuf.IFileDescriptorSet=} [p] Properties to set
             */
            function FileDescriptorSet(p) {
                this.file = [];
                if (p)
                    for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                        if (p[ks[i]] != null)
                            this[ks[i]] = p[ks[i]];
            }

            /**
             * FileDescriptorSet file.
             * @member {Array.<google.protobuf.IFileDescriptorProto>} file
             * @memberof google.protobuf.FileDescriptorSet
             * @instance
             */
            FileDescriptorSet.prototype.file = $util.emptyArray;

            /**
             * Creates a new FileDescriptorSet instance using the specified properties.
             * @function create
             * @memberof google.protobuf.FileDescriptorSet
             * @static
             * @param {google.protobuf.IFileDescriptorSet=} [properties] Properties to set
             * @returns {google.protobuf.FileDescriptorSet} FileDescriptorSet instance
             */
            FileDescriptorSet.create = function create(properties) {
                return new FileDescriptorSet(properties);
            };

            /**
             * Encodes the specified FileDescriptorSet message. Does not implicitly {@link google.protobuf.FileDescriptorSet.verify|verify} messages.
             * @function encode
             * @memberof google.protobuf.FileDescriptorSet
             * @static
             * @param {google.protobuf.IFileDescriptorSet} m FileDescriptorSet message or plain object to encode
             * @param {$protobuf.Writer} [w] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            FileDescriptorSet.encode = function encode(m, w) {
                if (!w)
                    w = $Writer.create();
                if (m.file != null && m.file.length) {
                    for (var i = 0; i < m.file.length; ++i)
                        $root.google.protobuf.FileDescriptorProto.encode(m.file[i], w.uint32(10).fork()).ldelim();
                }
                return w;
            };

            /**
             * Decodes a FileDescriptorSet message from the specified reader or buffer.
             * @function decode
             * @memberof google.protobuf.FileDescriptorSet
             * @static
             * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
             * @param {number} [l] Message length if known beforehand
             * @returns {google.protobuf.FileDescriptorSet} FileDescriptorSet
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            FileDescriptorSet.decode = function decode(r, l) {
                if (!(r instanceof $Reader))
                    r = $Reader.create(r);
                var c = l === undefined ? r.len : r.pos + l, m = new $root.google.protobuf.FileDescriptorSet();
                while (r.pos < c) {
                    var t = r.uint32();
                    switch (t >>> 3) {
                    case 1:
                        if (!(m.file && m.file.length))
                            m.file = [];
                        m.file.push($root.google.protobuf.FileDescriptorProto.decode(r, r.uint32()));
                        break;
                    default:
                        r.skipType(t & 7);
                        break;
                    }
                }
                return m;
            };

            return FileDescriptorSet;
        })();

        protobuf.FileDescriptorProto = (function() {

            /**
             * Properties of a FileDescriptorProto.
             * @memberof google.protobuf
             * @interface IFileDescriptorProto
             * @property {string|null} [name] FileDescriptorProto name
             * @property {string|null} ["package"] FileDescriptorProto package
             * @property {Array.<string>|null} [dependency] FileDescriptorProto dependency
             * @property {Array.<number>|null} [publicDependency] FileDescriptorProto publicDependency
             * @property {Array.<number>|null} [weakDependency] FileDescriptorProto weakDependency
             * @property {Array.<google.protobuf.IDescriptorProto>|null} [messageType] FileDescriptorProto messageType
             * @property {Array.<google.protobuf.IEnumDescriptorProto>|null} [enumType] FileDescriptorProto enumType
             * @property {Array.<google.protobuf.IServiceDescriptorProto>|null} [service] FileDescriptorProto service
             * @property {Array.<google.protobuf.IFieldDescriptorProto>|null} [extension] FileDescriptorProto extension
             * @property {google.protobuf.IFileOptions|null} [options] FileDescriptorProto options
             * @property {google.protobuf.ISourceCodeInfo|null} [sourceCodeInfo] FileDescriptorProto sourceCodeInfo
             * @property {string|null} [syntax] FileDescriptorProto syntax
             */

            /**
             * Constructs a new FileDescriptorProto.
             * @memberof google.protobuf
             * @classdesc Represents a FileDescriptorProto.
             * @implements IFileDescriptorProto
             * @constructor
             * @param {google.protobuf.IFileDescriptorProto=} [p] Properties to set
             */
            function FileDescriptorProto(p) {
                this.dependency = [];
                this.publicDependency = [];
                this.weakDependency = [];
                this.messageType = [];
                this.enumType = [];
                this.service = [];
                this.extension = [];
                if (p)
                    for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                        if (p[ks[i]] != null)
                            this[ks[i]] = p[ks[i]];
            }

            /**
             * FileDescriptorProto name.
             * @member {string} name
             * @memberof google.protobuf.FileDescriptorProto
             * @instance
             */
            FileDescriptorProto.prototype.name = "";

            /**
             * FileDescriptorProto package.
             * @member {string} package
             * @memberof google.protobuf.FileDescriptorProto
             * @instance
             */
            FileDescriptorProto.prototype["package"] = "";

            /**
             * FileDescriptorProto dependency.
             * @member {Array.<string>} dependency
             * @memberof google.protobuf.FileDescriptorProto
             * @instance
             */
            FileDescriptorProto.prototype.dependency = $util.emptyArray;

            /**
             * FileDescriptorProto publicDependency.
             * @member {Array.<number>} publicDependency
             * @memberof google.protobuf.FileDescriptorProto
             * @instance
             */
            FileDescriptorProto.prototype.publicDependency = $util.emptyArray;

            /**
             * FileDescriptorProto weakDependency.
             * @member {Array.<number>} weakDependency
             * @memberof google.protobuf.FileDescriptorProto
             * @instance
             */
            FileDescriptorProto.prototype.weakDependency = $util.emptyArray;

            /**
             * FileDescriptorProto messageType.
             * @member {Array.<google.protobuf.IDescriptorProto>} messageType
             * @memberof google.protobuf.FileDescriptorProto
             * @instance
             */
            FileDescriptorProto.prototype.messageType = $util.emptyArray;

            /**
             * FileDescriptorProto enumType.
             * @member {Array.<google.protobuf.IEnumDescriptorProto>} enumType
             * @memberof google.protobuf.FileDescriptorProto
             * @instance
             */
            FileDescriptorProto.prototype.enumType = $util.emptyArray;

            /**
             * FileDescriptorProto service.
             * @member {Array.<google.protobuf.IServiceDescriptorProto>} service
             * @memberof google.protobuf.FileDescriptorProto
             * @instance
             */
            FileDescriptorProto.prototype.service = $util.emptyArray;

            /**
             * FileDescriptorProto extension.
             * @member {Array.<google.protobuf.IFieldDescriptorProto>} extension
             * @memberof google.protobuf.FileDescriptorProto
             * @instance
             */
            FileDescriptorProto.prototype.extension = $util.emptyArray;

            /**
             * FileDescriptorProto options.
             * @member {google.protobuf.IFileOptions|null|undefined} options
             * @memberof google.protobuf.FileDescriptorProto
             * @instance
             */
            FileDescriptorProto.prototype.options = null;

            /**
             * FileDescriptorProto sourceCodeInfo.
             * @member {google.protobuf.ISourceCodeInfo|null|undefined} sourceCodeInfo
             * @memberof google.protobuf.FileDescriptorProto
             * @instance
             */
            FileDescriptorProto.prototype.sourceCodeInfo = null;

            /**
             * FileDescriptorProto syntax.
             * @member {string} syntax
             * @memberof google.protobuf.FileDescriptorProto
             * @instance
             */
            FileDescriptorProto.prototype.syntax = "";

            /**
             * Creates a new FileDescriptorProto instance using the specified properties.
             * @function create
             * @memberof google.protobuf.FileDescriptorProto
             * @static
             * @param {google.protobuf.IFileDescriptorProto=} [properties] Properties to set
             * @returns {google.protobuf.FileDescriptorProto} FileDescriptorProto instance
             */
            FileDescriptorProto.create = function create(properties) {
                return new FileDescriptorProto(properties);
            };

            /**
             * Encodes the specified FileDescriptorProto message. Does not implicitly {@link google.protobuf.FileDescriptorProto.verify|verify} messages.
             * @function encode
             * @memberof google.protobuf.FileDescriptorProto
             * @static
             * @param {google.protobuf.IFileDescriptorProto} m FileDescriptorProto message or plain object to encode
             * @param {$protobuf.Writer} [w] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            FileDescriptorProto.encode = function encode(m, w) {
                if (!w)
                    w = $Writer.create();
                if (m.name != null && Object.hasOwnProperty.call(m, "name"))
                    w.uint32(10).string(m.name);
                if (m["package"] != null && Object.hasOwnProperty.call(m, "package"))
                    w.uint32(18).string(m["package"]);
                if (m.dependency != null && m.dependency.length) {
                    for (var i = 0; i < m.dependency.length; ++i)
                        w.uint32(26).string(m.dependency[i]);
                }
                if (m.messageType != null && m.messageType.length) {
                    for (var i = 0; i < m.messageType.length; ++i)
                        $root.google.protobuf.DescriptorProto.encode(m.messageType[i], w.uint32(34).fork()).ldelim();
                }
                if (m.enumType != null && m.enumType.length) {
                    for (var i = 0; i < m.enumType.length; ++i)
                        $root.google.protobuf.EnumDescriptorProto.encode(m.enumType[i], w.uint32(42).fork()).ldelim();
                }
                if (m.service != null && m.service.length) {
                    for (var i = 0; i < m.service.length; ++i)
                        $root.google.protobuf.ServiceDescriptorProto.encode(m.service[i], w.uint32(50).fork()).ldelim();
                }
                if (m.extension != null && m.extension.length) {
                    for (var i = 0; i < m.extension.length; ++i)
                        $root.google.protobuf.FieldDescriptorProto.encode(m.extension[i], w.uint32(58).fork()).ldelim();
                }
                if (m.options != null && Object.hasOwnProperty.call(m, "options"))
                    $root.google.protobuf.FileOptions.encode(m.options, w.uint32(66).fork()).ldelim();
                if (m.sourceCodeInfo != null && Object.hasOwnProperty.call(m, "sourceCodeInfo"))
                    $root.google.protobuf.SourceCodeInfo.encode(m.sourceCodeInfo, w.uint32(74).fork()).ldelim();
                if (m.publicDependency != null && m.publicDependency.length) {
                    for (var i = 0; i < m.publicDependency.length; ++i)
                        w.uint32(80).int32(m.publicDependency[i]);
                }
                if (m.weakDependency != null && m.weakDependency.length) {
                    for (var i = 0; i < m.weakDependency.length; ++i)
                        w.uint32(88).int32(m.weakDependency[i]);
                }
                if (m.syntax != null && Object.hasOwnProperty.call(m, "syntax"))
                    w.uint32(98).string(m.syntax);
                return w;
            };

            /**
             * Decodes a FileDescriptorProto message from the specified reader or buffer.
             * @function decode
             * @memberof google.protobuf.FileDescriptorProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
             * @param {number} [l] Message length if known beforehand
             * @returns {google.protobuf.FileDescriptorProto} FileDescriptorProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            FileDescriptorProto.decode = function decode(r, l) {
                if (!(r instanceof $Reader))
                    r = $Reader.create(r);
                var c = l === undefined ? r.len : r.pos + l, m = new $root.google.protobuf.FileDescriptorProto();
                while (r.pos < c) {
                    var t = r.uint32();
                    switch (t >>> 3) {
                    case 1:
                        m.name = r.string();
                        break;
                    case 2:
                        m["package"] = r.string();
                        break;
                    case 3:
                        if (!(m.dependency && m.dependency.length))
                            m.dependency = [];
                        m.dependency.push(r.string());
                        break;
                    case 10:
                        if (!(m.publicDependency && m.publicDependency.length))
                            m.publicDependency = [];
                        if ((t & 7) === 2) {
                            var c2 = r.uint32() + r.pos;
                            while (r.pos < c2)
                                m.publicDependency.push(r.int32());
                        } else
                            m.publicDependency.push(r.int32());
                        break;
                    case 11:
                        if (!(m.weakDependency && m.weakDependency.length))
                            m.weakDependency = [];
                        if ((t & 7) === 2) {
                            var c2 = r.uint32() + r.pos;
                            while (r.pos < c2)
                                m.weakDependency.push(r.int32());
                        } else
                            m.weakDependency.push(r.int32());
                        break;
                    case 4:
                        if (!(m.messageType && m.messageType.length))
                            m.messageType = [];
                        m.messageType.push($root.google.protobuf.DescriptorProto.decode(r, r.uint32()));
                        break;
                    case 5:
                        if (!(m.enumType && m.enumType.length))
                            m.enumType = [];
                        m.enumType.push($root.google.protobuf.EnumDescriptorProto.decode(r, r.uint32()));
                        break;
                    case 6:
                        if (!(m.service && m.service.length))
                            m.service = [];
                        m.service.push($root.google.protobuf.ServiceDescriptorProto.decode(r, r.uint32()));
                        break;
                    case 7:
                        if (!(m.extension && m.extension.length))
                            m.extension = [];
                        m.extension.push($root.google.protobuf.FieldDescriptorProto.decode(r, r.uint32()));
                        break;
                    case 8:
                        m.options = $root.google.protobuf.FileOptions.decode(r, r.uint32());
                        break;
                    case 9:
                        m.sourceCodeInfo = $root.google.protobuf.SourceCodeInfo.decode(r, r.uint32());
                        break;
                    case 12:
                        m.syntax = r.string();
                        break;
                    default:
                        r.skipType(t & 7);
                        break;
                    }
                }
                return m;
            };

            return FileDescriptorProto;
        })();

        protobuf.DescriptorProto = (function() {

            /**
             * Properties of a DescriptorProto.
             * @memberof google.protobuf
             * @interface IDescriptorProto
             * @property {string|null} [name] DescriptorProto name
             * @property {Array.<google.protobuf.IFieldDescriptorProto>|null} [field] DescriptorProto field
             * @property {Array.<google.protobuf.IFieldDescriptorProto>|null} [extension] DescriptorProto extension
             * @property {Array.<google.protobuf.IDescriptorProto>|null} [nestedType] DescriptorProto nestedType
             * @property {Array.<google.protobuf.IEnumDescriptorProto>|null} [enumType] DescriptorProto enumType
             * @property {Array.<google.protobuf.DescriptorProto.IExtensionRange>|null} [extensionRange] DescriptorProto extensionRange
             * @property {Array.<google.protobuf.IOneofDescriptorProto>|null} [oneofDecl] DescriptorProto oneofDecl
             * @property {google.protobuf.IMessageOptions|null} [options] DescriptorProto options
             * @property {Array.<google.protobuf.DescriptorProto.IReservedRange>|null} [reservedRange] DescriptorProto reservedRange
             * @property {Array.<string>|null} [reservedName] DescriptorProto reservedName
             */

            /**
             * Constructs a new DescriptorProto.
             * @memberof google.protobuf
             * @classdesc Represents a DescriptorProto.
             * @implements IDescriptorProto
             * @constructor
             * @param {google.protobuf.IDescriptorProto=} [p] Properties to set
             */
            function DescriptorProto(p) {
                this.field = [];
                this.extension = [];
                this.nestedType = [];
                this.enumType = [];
                this.extensionRange = [];
                this.oneofDecl = [];
                this.reservedRange = [];
                this.reservedName = [];
                if (p)
                    for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                        if (p[ks[i]] != null)
                            this[ks[i]] = p[ks[i]];
            }

            /**
             * DescriptorProto name.
             * @member {string} name
             * @memberof google.protobuf.DescriptorProto
             * @instance
             */
            DescriptorProto.prototype.name = "";

            /**
             * DescriptorProto field.
             * @member {Array.<google.protobuf.IFieldDescriptorProto>} field
             * @memberof google.protobuf.DescriptorProto
             * @instance
             */
            DescriptorProto.prototype.field = $util.emptyArray;

            /**
             * DescriptorProto extension.
             * @member {Array.<google.protobuf.IFieldDescriptorProto>} extension
             * @memberof google.protobuf.DescriptorProto
             * @instance
             */
            DescriptorProto.prototype.extension = $util.emptyArray;

            /**
             * DescriptorProto nestedType.
             * @member {Array.<google.protobuf.IDescriptorProto>} nestedType
             * @memberof google.protobuf.DescriptorProto
             * @instance
             */
            DescriptorProto.prototype.nestedType = $util.emptyArray;

            /**
             * DescriptorProto enumType.
             * @member {Array.<google.protobuf.IEnumDescriptorProto>} enumType
             * @memberof google.protobuf.DescriptorProto
             * @instance
             */
            DescriptorProto.prototype.enumType = $util.emptyArray;

            /**
             * DescriptorProto extensionRange.
             * @member {Array.<google.protobuf.DescriptorProto.IExtensionRange>} extensionRange
             * @memberof google.protobuf.DescriptorProto
             * @instance
             */
            DescriptorProto.prototype.extensionRange = $util.emptyArray;

            /**
             * DescriptorProto oneofDecl.
             * @member {Array.<google.protobuf.IOneofDescriptorProto>} oneofDecl
             * @memberof google.protobuf.DescriptorProto
             * @instance
             */
            DescriptorProto.prototype.oneofDecl = $util.emptyArray;

            /**
             * DescriptorProto options.
             * @member {google.protobuf.IMessageOptions|null|undefined} options
             * @memberof google.protobuf.DescriptorProto
             * @instance
             */
            DescriptorProto.prototype.options = null;

            /**
             * DescriptorProto reservedRange.
             * @member {Array.<google.protobuf.DescriptorProto.IReservedRange>} reservedRange
             * @memberof google.protobuf.DescriptorProto
             * @instance
             */
            DescriptorProto.prototype.reservedRange = $util.emptyArray;

            /**
             * DescriptorProto reservedName.
             * @member {Array.<string>} reservedName
             * @memberof google.protobuf.DescriptorProto
             * @instance
             */
            DescriptorProto.prototype.reservedName = $util.emptyArray;

            /**
             * Creates a new DescriptorProto instance using the specified properties.
             * @function create
             * @memberof google.protobuf.DescriptorProto
             * @static
             * @param {google.protobuf.IDescriptorProto=} [properties] Properties to set
             * @returns {google.protobuf.DescriptorProto} DescriptorProto instance
             */
            DescriptorProto.create = function create(properties) {
                return new DescriptorProto(properties);
            };

            /**
             * Encodes the specified DescriptorProto message. Does not implicitly {@link google.protobuf.DescriptorProto.verify|verify} messages.
             * @function encode
             * @memberof google.protobuf.DescriptorProto
             * @static
             * @param {google.protobuf.IDescriptorProto} m DescriptorProto message or plain object to encode
             * @param {$protobuf.Writer} [w] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            DescriptorProto.encode = function encode(m, w) {
                if (!w)
                    w = $Writer.create();
                if (m.name != null && Object.hasOwnProperty.call(m, "name"))
                    w.uint32(10).string(m.name);
                if (m.field != null && m.field.length) {
                    for (var i = 0; i < m.field.length; ++i)
                        $root.google.protobuf.FieldDescriptorProto.encode(m.field[i], w.uint32(18).fork()).ldelim();
                }
                if (m.nestedType != null && m.nestedType.length) {
                    for (var i = 0; i < m.nestedType.length; ++i)
                        $root.google.protobuf.DescriptorProto.encode(m.nestedType[i], w.uint32(26).fork()).ldelim();
                }
                if (m.enumType != null && m.enumType.length) {
                    for (var i = 0; i < m.enumType.length; ++i)
                        $root.google.protobuf.EnumDescriptorProto.encode(m.enumType[i], w.uint32(34).fork()).ldelim();
                }
                if (m.extensionRange != null && m.extensionRange.length) {
                    for (var i = 0; i < m.extensionRange.length; ++i)
                        $root.google.protobuf.DescriptorProto.ExtensionRange.encode(m.extensionRange[i], w.uint32(42).fork()).ldelim();
                }
                if (m.extension != null && m.extension.length) {
                    for (var i = 0; i < m.extension.length; ++i)
                        $root.google.protobuf.FieldDescriptorProto.encode(m.extension[i], w.uint32(50).fork()).ldelim();
                }
                if (m.options != null && Object.hasOwnProperty.call(m, "options"))
                    $root.google.protobuf.MessageOptions.encode(m.options, w.uint32(58).fork()).ldelim();
                if (m.oneofDecl != null && m.oneofDecl.length) {
                    for (var i = 0; i < m.oneofDecl.length; ++i)
                        $root.google.protobuf.OneofDescriptorProto.encode(m.oneofDecl[i], w.uint32(66).fork()).ldelim();
                }
                if (m.reservedRange != null && m.reservedRange.length) {
                    for (var i = 0; i < m.reservedRange.length; ++i)
                        $root.google.protobuf.DescriptorProto.ReservedRange.encode(m.reservedRange[i], w.uint32(74).fork()).ldelim();
                }
                if (m.reservedName != null && m.reservedName.length) {
                    for (var i = 0; i < m.reservedName.length; ++i)
                        w.uint32(82).string(m.reservedName[i]);
                }
                return w;
            };

            /**
             * Decodes a DescriptorProto message from the specified reader or buffer.
             * @function decode
             * @memberof google.protobuf.DescriptorProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
             * @param {number} [l] Message length if known beforehand
             * @returns {google.protobuf.DescriptorProto} DescriptorProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            DescriptorProto.decode = function decode(r, l) {
                if (!(r instanceof $Reader))
                    r = $Reader.create(r);
                var c = l === undefined ? r.len : r.pos + l, m = new $root.google.protobuf.DescriptorProto();
                while (r.pos < c) {
                    var t = r.uint32();
                    switch (t >>> 3) {
                    case 1:
                        m.name = r.string();
                        break;
                    case 2:
                        if (!(m.field && m.field.length))
                            m.field = [];
                        m.field.push($root.google.protobuf.FieldDescriptorProto.decode(r, r.uint32()));
                        break;
                    case 6:
                        if (!(m.extension && m.extension.length))
                            m.extension = [];
                        m.extension.push($root.google.protobuf.FieldDescriptorProto.decode(r, r.uint32()));
                        break;
                    case 3:
                        if (!(m.nestedType && m.nestedType.length))
                            m.nestedType = [];
                        m.nestedType.push($root.google.protobuf.DescriptorProto.decode(r, r.uint32()));
                        break;
                    case 4:
                        if (!(m.enumType && m.enumType.length))
                            m.enumType = [];
                        m.enumType.push($root.google.protobuf.EnumDescriptorProto.decode(r, r.uint32()));
                        break;
                    case 5:
                        if (!(m.extensionRange && m.extensionRange.length))
                            m.extensionRange = [];
                        m.extensionRange.push($root.google.protobuf.DescriptorProto.ExtensionRange.decode(r, r.uint32()));
                        break;
                    case 8:
                        if (!(m.oneofDecl && m.oneofDecl.length))
                            m.oneofDecl = [];
                        m.oneofDecl.push($root.google.protobuf.OneofDescriptorProto.decode(r, r.uint32()));
                        break;
                    case 7:
                        m.options = $root.google.protobuf.MessageOptions.decode(r, r.uint32());
                        break;
                    case 9:
                        if (!(m.reservedRange && m.reservedRange.length))
                            m.reservedRange = [];
                        m.reservedRange.push($root.google.protobuf.DescriptorProto.ReservedRange.decode(r, r.uint32()));
                        break;
                    case 10:
                        if (!(m.reservedName && m.reservedName.length))
                            m.reservedName = [];
                        m.reservedName.push(r.string());
                        break;
                    default:
                        r.skipType(t & 7);
                        break;
                    }
                }
                return m;
            };

            DescriptorProto.ExtensionRange = (function() {

                /**
                 * Properties of an ExtensionRange.
                 * @memberof google.protobuf.DescriptorProto
                 * @interface IExtensionRange
                 * @property {number|null} [start] ExtensionRange start
                 * @property {number|null} [end] ExtensionRange end
                 */

                /**
                 * Constructs a new ExtensionRange.
                 * @memberof google.protobuf.DescriptorProto
                 * @classdesc Represents an ExtensionRange.
                 * @implements IExtensionRange
                 * @constructor
                 * @param {google.protobuf.DescriptorProto.IExtensionRange=} [p] Properties to set
                 */
                function ExtensionRange(p) {
                    if (p)
                        for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                            if (p[ks[i]] != null)
                                this[ks[i]] = p[ks[i]];
                }

                /**
                 * ExtensionRange start.
                 * @member {number} start
                 * @memberof google.protobuf.DescriptorProto.ExtensionRange
                 * @instance
                 */
                ExtensionRange.prototype.start = 0;

                /**
                 * ExtensionRange end.
                 * @member {number} end
                 * @memberof google.protobuf.DescriptorProto.ExtensionRange
                 * @instance
                 */
                ExtensionRange.prototype.end = 0;

                /**
                 * Creates a new ExtensionRange instance using the specified properties.
                 * @function create
                 * @memberof google.protobuf.DescriptorProto.ExtensionRange
                 * @static
                 * @param {google.protobuf.DescriptorProto.IExtensionRange=} [properties] Properties to set
                 * @returns {google.protobuf.DescriptorProto.ExtensionRange} ExtensionRange instance
                 */
                ExtensionRange.create = function create(properties) {
                    return new ExtensionRange(properties);
                };

                /**
                 * Encodes the specified ExtensionRange message. Does not implicitly {@link google.protobuf.DescriptorProto.ExtensionRange.verify|verify} messages.
                 * @function encode
                 * @memberof google.protobuf.DescriptorProto.ExtensionRange
                 * @static
                 * @param {google.protobuf.DescriptorProto.IExtensionRange} m ExtensionRange message or plain object to encode
                 * @param {$protobuf.Writer} [w] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ExtensionRange.encode = function encode(m, w) {
                    if (!w)
                        w = $Writer.create();
                    if (m.start != null && Object.hasOwnProperty.call(m, "start"))
                        w.uint32(8).int32(m.start);
                    if (m.end != null && Object.hasOwnProperty.call(m, "end"))
                        w.uint32(16).int32(m.end);
                    return w;
                };

                /**
                 * Decodes an ExtensionRange message from the specified reader or buffer.
                 * @function decode
                 * @memberof google.protobuf.DescriptorProto.ExtensionRange
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
                 * @param {number} [l] Message length if known beforehand
                 * @returns {google.protobuf.DescriptorProto.ExtensionRange} ExtensionRange
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ExtensionRange.decode = function decode(r, l) {
                    if (!(r instanceof $Reader))
                        r = $Reader.create(r);
                    var c = l === undefined ? r.len : r.pos + l, m = new $root.google.protobuf.DescriptorProto.ExtensionRange();
                    while (r.pos < c) {
                        var t = r.uint32();
                        switch (t >>> 3) {
                        case 1:
                            m.start = r.int32();
                            break;
                        case 2:
                            m.end = r.int32();
                            break;
                        default:
                            r.skipType(t & 7);
                            break;
                        }
                    }
                    return m;
                };

                return ExtensionRange;
            })();

            DescriptorProto.ReservedRange = (function() {

                /**
                 * Properties of a ReservedRange.
                 * @memberof google.protobuf.DescriptorProto
                 * @interface IReservedRange
                 * @property {number|null} [start] ReservedRange start
                 * @property {number|null} [end] ReservedRange end
                 */

                /**
                 * Constructs a new ReservedRange.
                 * @memberof google.protobuf.DescriptorProto
                 * @classdesc Represents a ReservedRange.
                 * @implements IReservedRange
                 * @constructor
                 * @param {google.protobuf.DescriptorProto.IReservedRange=} [p] Properties to set
                 */
                function ReservedRange(p) {
                    if (p)
                        for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                            if (p[ks[i]] != null)
                                this[ks[i]] = p[ks[i]];
                }

                /**
                 * ReservedRange start.
                 * @member {number} start
                 * @memberof google.protobuf.DescriptorProto.ReservedRange
                 * @instance
                 */
                ReservedRange.prototype.start = 0;

                /**
                 * ReservedRange end.
                 * @member {number} end
                 * @memberof google.protobuf.DescriptorProto.ReservedRange
                 * @instance
                 */
                ReservedRange.prototype.end = 0;

                /**
                 * Creates a new ReservedRange instance using the specified properties.
                 * @function create
                 * @memberof google.protobuf.DescriptorProto.ReservedRange
                 * @static
                 * @param {google.protobuf.DescriptorProto.IReservedRange=} [properties] Properties to set
                 * @returns {google.protobuf.DescriptorProto.ReservedRange} ReservedRange instance
                 */
                ReservedRange.create = function create(properties) {
                    return new ReservedRange(properties);
                };

                /**
                 * Encodes the specified ReservedRange message. Does not implicitly {@link google.protobuf.DescriptorProto.ReservedRange.verify|verify} messages.
                 * @function encode
                 * @memberof google.protobuf.DescriptorProto.ReservedRange
                 * @static
                 * @param {google.protobuf.DescriptorProto.IReservedRange} m ReservedRange message or plain object to encode
                 * @param {$protobuf.Writer} [w] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ReservedRange.encode = function encode(m, w) {
                    if (!w)
                        w = $Writer.create();
                    if (m.start != null && Object.hasOwnProperty.call(m, "start"))
                        w.uint32(8).int32(m.start);
                    if (m.end != null && Object.hasOwnProperty.call(m, "end"))
                        w.uint32(16).int32(m.end);
                    return w;
                };

                /**
                 * Decodes a ReservedRange message from the specified reader or buffer.
                 * @function decode
                 * @memberof google.protobuf.DescriptorProto.ReservedRange
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
                 * @param {number} [l] Message length if known beforehand
                 * @returns {google.protobuf.DescriptorProto.ReservedRange} ReservedRange
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ReservedRange.decode = function decode(r, l) {
                    if (!(r instanceof $Reader))
                        r = $Reader.create(r);
                    var c = l === undefined ? r.len : r.pos + l, m = new $root.google.protobuf.DescriptorProto.ReservedRange();
                    while (r.pos < c) {
                        var t = r.uint32();
                        switch (t >>> 3) {
                        case 1:
                            m.start = r.int32();
                            break;
                        case 2:
                            m.end = r.int32();
                            break;
                        default:
                            r.skipType(t & 7);
                            break;
                        }
                    }
                    return m;
                };

                return ReservedRange;
            })();

            return DescriptorProto;
        })();

        protobuf.FieldDescriptorProto = (function() {

            /**
             * Properties of a FieldDescriptorProto.
             * @memberof google.protobuf
             * @interface IFieldDescriptorProto
             * @property {string|null} [name] FieldDescriptorProto name
             * @property {number|null} [number] FieldDescriptorProto number
             * @property {google.protobuf.FieldDescriptorProto.Label|null} [label] FieldDescriptorProto label
             * @property {google.protobuf.FieldDescriptorProto.Type|null} [type] FieldDescriptorProto type
             * @property {string|null} [typeName] FieldDescriptorProto typeName
             * @property {string|null} [extendee] FieldDescriptorProto extendee
             * @property {string|null} [defaultValue] FieldDescriptorProto defaultValue
             * @property {number|null} [oneofIndex] FieldDescriptorProto oneofIndex
             * @property {string|null} [jsonName] FieldDescriptorProto jsonName
             * @property {google.protobuf.IFieldOptions|null} [options] FieldDescriptorProto options
             */

            /**
             * Constructs a new FieldDescriptorProto.
             * @memberof google.protobuf
             * @classdesc Represents a FieldDescriptorProto.
             * @implements IFieldDescriptorProto
             * @constructor
             * @param {google.protobuf.IFieldDescriptorProto=} [p] Properties to set
             */
            function FieldDescriptorProto(p) {
                if (p)
                    for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                        if (p[ks[i]] != null)
                            this[ks[i]] = p[ks[i]];
            }

            /**
             * FieldDescriptorProto name.
             * @member {string} name
             * @memberof google.protobuf.FieldDescriptorProto
             * @instance
             */
            FieldDescriptorProto.prototype.name = "";

            /**
             * FieldDescriptorProto number.
             * @member {number} number
             * @memberof google.protobuf.FieldDescriptorProto
             * @instance
             */
            FieldDescriptorProto.prototype.number = 0;

            /**
             * FieldDescriptorProto label.
             * @member {google.protobuf.FieldDescriptorProto.Label} label
             * @memberof google.protobuf.FieldDescriptorProto
             * @instance
             */
            FieldDescriptorProto.prototype.label = 1;

            /**
             * FieldDescriptorProto type.
             * @member {google.protobuf.FieldDescriptorProto.Type} type
             * @memberof google.protobuf.FieldDescriptorProto
             * @instance
             */
            FieldDescriptorProto.prototype.type = 1;

            /**
             * FieldDescriptorProto typeName.
             * @member {string} typeName
             * @memberof google.protobuf.FieldDescriptorProto
             * @instance
             */
            FieldDescriptorProto.prototype.typeName = "";

            /**
             * FieldDescriptorProto extendee.
             * @member {string} extendee
             * @memberof google.protobuf.FieldDescriptorProto
             * @instance
             */
            FieldDescriptorProto.prototype.extendee = "";

            /**
             * FieldDescriptorProto defaultValue.
             * @member {string} defaultValue
             * @memberof google.protobuf.FieldDescriptorProto
             * @instance
             */
            FieldDescriptorProto.prototype.defaultValue = "";

            /**
             * FieldDescriptorProto oneofIndex.
             * @member {number} oneofIndex
             * @memberof google.protobuf.FieldDescriptorProto
             * @instance
             */
            FieldDescriptorProto.prototype.oneofIndex = 0;

            /**
             * FieldDescriptorProto jsonName.
             * @member {string} jsonName
             * @memberof google.protobuf.FieldDescriptorProto
             * @instance
             */
            FieldDescriptorProto.prototype.jsonName = "";

            /**
             * FieldDescriptorProto options.
             * @member {google.protobuf.IFieldOptions|null|undefined} options
             * @memberof google.protobuf.FieldDescriptorProto
             * @instance
             */
            FieldDescriptorProto.prototype.options = null;

            /**
             * Creates a new FieldDescriptorProto instance using the specified properties.
             * @function create
             * @memberof google.protobuf.FieldDescriptorProto
             * @static
             * @param {google.protobuf.IFieldDescriptorProto=} [properties] Properties to set
             * @returns {google.protobuf.FieldDescriptorProto} FieldDescriptorProto instance
             */
            FieldDescriptorProto.create = function create(properties) {
                return new FieldDescriptorProto(properties);
            };

            /**
             * Encodes the specified FieldDescriptorProto message. Does not implicitly {@link google.protobuf.FieldDescriptorProto.verify|verify} messages.
             * @function encode
             * @memberof google.protobuf.FieldDescriptorProto
             * @static
             * @param {google.protobuf.IFieldDescriptorProto} m FieldDescriptorProto message or plain object to encode
             * @param {$protobuf.Writer} [w] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            FieldDescriptorProto.encode = function encode(m, w) {
                if (!w)
                    w = $Writer.create();
                if (m.name != null && Object.hasOwnProperty.call(m, "name"))
                    w.uint32(10).string(m.name);
                if (m.extendee != null && Object.hasOwnProperty.call(m, "extendee"))
                    w.uint32(18).string(m.extendee);
                if (m.number != null && Object.hasOwnProperty.call(m, "number"))
                    w.uint32(24).int32(m.number);
                if (m.label != null && Object.hasOwnProperty.call(m, "label"))
                    w.uint32(32).int32(m.label);
                if (m.type != null && Object.hasOwnProperty.call(m, "type"))
                    w.uint32(40).int32(m.type);
                if (m.typeName != null && Object.hasOwnProperty.call(m, "typeName"))
                    w.uint32(50).string(m.typeName);
                if (m.defaultValue != null && Object.hasOwnProperty.call(m, "defaultValue"))
                    w.uint32(58).string(m.defaultValue);
                if (m.options != null && Object.hasOwnProperty.call(m, "options"))
                    $root.google.protobuf.FieldOptions.encode(m.options, w.uint32(66).fork()).ldelim();
                if (m.oneofIndex != null && Object.hasOwnProperty.call(m, "oneofIndex"))
                    w.uint32(72).int32(m.oneofIndex);
                if (m.jsonName != null && Object.hasOwnProperty.call(m, "jsonName"))
                    w.uint32(82).string(m.jsonName);
                return w;
            };

            /**
             * Decodes a FieldDescriptorProto message from the specified reader or buffer.
             * @function decode
             * @memberof google.protobuf.FieldDescriptorProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
             * @param {number} [l] Message length if known beforehand
             * @returns {google.protobuf.FieldDescriptorProto} FieldDescriptorProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            FieldDescriptorProto.decode = function decode(r, l) {
                if (!(r instanceof $Reader))
                    r = $Reader.create(r);
                var c = l === undefined ? r.len : r.pos + l, m = new $root.google.protobuf.FieldDescriptorProto();
                while (r.pos < c) {
                    var t = r.uint32();
                    switch (t >>> 3) {
                    case 1:
                        m.name = r.string();
                        break;
                    case 3:
                        m.number = r.int32();
                        break;
                    case 4:
                        m.label = r.int32();
                        break;
                    case 5:
                        m.type = r.int32();
                        break;
                    case 6:
                        m.typeName = r.string();
                        break;
                    case 2:
                        m.extendee = r.string();
                        break;
                    case 7:
                        m.defaultValue = r.string();
                        break;
                    case 9:
                        m.oneofIndex = r.int32();
                        break;
                    case 10:
                        m.jsonName = r.string();
                        break;
                    case 8:
                        m.options = $root.google.protobuf.FieldOptions.decode(r, r.uint32());
                        break;
                    default:
                        r.skipType(t & 7);
                        break;
                    }
                }
                return m;
            };

            /**
             * Type enum.
             * @name google.protobuf.FieldDescriptorProto.Type
             * @enum {number}
             * @property {number} TYPE_DOUBLE=1 TYPE_DOUBLE value
             * @property {number} TYPE_FLOAT=2 TYPE_FLOAT value
             * @property {number} TYPE_INT64=3 TYPE_INT64 value
             * @property {number} TYPE_UINT64=4 TYPE_UINT64 value
             * @property {number} TYPE_INT32=5 TYPE_INT32 value
             * @property {number} TYPE_FIXED64=6 TYPE_FIXED64 value
             * @property {number} TYPE_FIXED32=7 TYPE_FIXED32 value
             * @property {number} TYPE_BOOL=8 TYPE_BOOL value
             * @property {number} TYPE_STRING=9 TYPE_STRING value
             * @property {number} TYPE_GROUP=10 TYPE_GROUP value
             * @property {number} TYPE_MESSAGE=11 TYPE_MESSAGE value
             * @property {number} TYPE_BYTES=12 TYPE_BYTES value
             * @property {number} TYPE_UINT32=13 TYPE_UINT32 value
             * @property {number} TYPE_ENUM=14 TYPE_ENUM value
             * @property {number} TYPE_SFIXED32=15 TYPE_SFIXED32 value
             * @property {number} TYPE_SFIXED64=16 TYPE_SFIXED64 value
             * @property {number} TYPE_SINT32=17 TYPE_SINT32 value
             * @property {number} TYPE_SINT64=18 TYPE_SINT64 value
             */
            FieldDescriptorProto.Type = (function() {
                const valuesById = {}, values = Object.create(valuesById);
                values[valuesById[1] = "TYPE_DOUBLE"] = 1;
                values[valuesById[2] = "TYPE_FLOAT"] = 2;
                values[valuesById[3] = "TYPE_INT64"] = 3;
                values[valuesById[4] = "TYPE_UINT64"] = 4;
                values[valuesById[5] = "TYPE_INT32"] = 5;
                values[valuesById[6] = "TYPE_FIXED64"] = 6;
                values[valuesById[7] = "TYPE_FIXED32"] = 7;
                values[valuesById[8] = "TYPE_BOOL"] = 8;
                values[valuesById[9] = "TYPE_STRING"] = 9;
                values[valuesById[10] = "TYPE_GROUP"] = 10;
                values[valuesById[11] = "TYPE_MESSAGE"] = 11;
                values[valuesById[12] = "TYPE_BYTES"] = 12;
                values[valuesById[13] = "TYPE_UINT32"] = 13;
                values[valuesById[14] = "TYPE_ENUM"] = 14;
                values[valuesById[15] = "TYPE_SFIXED32"] = 15;
                values[valuesById[16] = "TYPE_SFIXED64"] = 16;
                values[valuesById[17] = "TYPE_SINT32"] = 17;
                values[valuesById[18] = "TYPE_SINT64"] = 18;
                return values;
            })();

            /**
             * Label enum.
             * @name google.protobuf.FieldDescriptorProto.Label
             * @enum {number}
             * @property {number} LABEL_OPTIONAL=1 LABEL_OPTIONAL value
             * @property {number} LABEL_REQUIRED=2 LABEL_REQUIRED value
             * @property {number} LABEL_REPEATED=3 LABEL_REPEATED value
             */
            FieldDescriptorProto.Label = (function() {
                const valuesById = {}, values = Object.create(valuesById);
                values[valuesById[1] = "LABEL_OPTIONAL"] = 1;
                values[valuesById[2] = "LABEL_REQUIRED"] = 2;
                values[valuesById[3] = "LABEL_REPEATED"] = 3;
                return values;
            })();

            return FieldDescriptorProto;
        })();

        protobuf.OneofDescriptorProto = (function() {

            /**
             * Properties of an OneofDescriptorProto.
             * @memberof google.protobuf
             * @interface IOneofDescriptorProto
             * @property {string|null} [name] OneofDescriptorProto name
             * @property {google.protobuf.IOneofOptions|null} [options] OneofDescriptorProto options
             */

            /**
             * Constructs a new OneofDescriptorProto.
             * @memberof google.protobuf
             * @classdesc Represents an OneofDescriptorProto.
             * @implements IOneofDescriptorProto
             * @constructor
             * @param {google.protobuf.IOneofDescriptorProto=} [p] Properties to set
             */
            function OneofDescriptorProto(p) {
                if (p)
                    for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                        if (p[ks[i]] != null)
                            this[ks[i]] = p[ks[i]];
            }

            /**
             * OneofDescriptorProto name.
             * @member {string} name
             * @memberof google.protobuf.OneofDescriptorProto
             * @instance
             */
            OneofDescriptorProto.prototype.name = "";

            /**
             * OneofDescriptorProto options.
             * @member {google.protobuf.IOneofOptions|null|undefined} options
             * @memberof google.protobuf.OneofDescriptorProto
             * @instance
             */
            OneofDescriptorProto.prototype.options = null;

            /**
             * Creates a new OneofDescriptorProto instance using the specified properties.
             * @function create
             * @memberof google.protobuf.OneofDescriptorProto
             * @static
             * @param {google.protobuf.IOneofDescriptorProto=} [properties] Properties to set
             * @returns {google.protobuf.OneofDescriptorProto} OneofDescriptorProto instance
             */
            OneofDescriptorProto.create = function create(properties) {
                return new OneofDescriptorProto(properties);
            };

            /**
             * Encodes the specified OneofDescriptorProto message. Does not implicitly {@link google.protobuf.OneofDescriptorProto.verify|verify} messages.
             * @function encode
             * @memberof google.protobuf.OneofDescriptorProto
             * @static
             * @param {google.protobuf.IOneofDescriptorProto} m OneofDescriptorProto message or plain object to encode
             * @param {$protobuf.Writer} [w] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            OneofDescriptorProto.encode = function encode(m, w) {
                if (!w)
                    w = $Writer.create();
                if (m.name != null && Object.hasOwnProperty.call(m, "name"))
                    w.uint32(10).string(m.name);
                if (m.options != null && Object.hasOwnProperty.call(m, "options"))
                    $root.google.protobuf.OneofOptions.encode(m.options, w.uint32(18).fork()).ldelim();
                return w;
            };

            /**
             * Decodes an OneofDescriptorProto message from the specified reader or buffer.
             * @function decode
             * @memberof google.protobuf.OneofDescriptorProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
             * @param {number} [l] Message length if known beforehand
             * @returns {google.protobuf.OneofDescriptorProto} OneofDescriptorProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            OneofDescriptorProto.decode = function decode(r, l) {
                if (!(r instanceof $Reader))
                    r = $Reader.create(r);
                var c = l === undefined ? r.len : r.pos + l, m = new $root.google.protobuf.OneofDescriptorProto();
                while (r.pos < c) {
                    var t = r.uint32();
                    switch (t >>> 3) {
                    case 1:
                        m.name = r.string();
                        break;
                    case 2:
                        m.options = $root.google.protobuf.OneofOptions.decode(r, r.uint32());
                        break;
                    default:
                        r.skipType(t & 7);
                        break;
                    }
                }
                return m;
            };

            return OneofDescriptorProto;
        })();

        protobuf.EnumDescriptorProto = (function() {

            /**
             * Properties of an EnumDescriptorProto.
             * @memberof google.protobuf
             * @interface IEnumDescriptorProto
             * @property {string|null} [name] EnumDescriptorProto name
             * @property {Array.<google.protobuf.IEnumValueDescriptorProto>|null} [value] EnumDescriptorProto value
             * @property {google.protobuf.IEnumOptions|null} [options] EnumDescriptorProto options
             */

            /**
             * Constructs a new EnumDescriptorProto.
             * @memberof google.protobuf
             * @classdesc Represents an EnumDescriptorProto.
             * @implements IEnumDescriptorProto
             * @constructor
             * @param {google.protobuf.IEnumDescriptorProto=} [p] Properties to set
             */
            function EnumDescriptorProto(p) {
                this.value = [];
                if (p)
                    for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                        if (p[ks[i]] != null)
                            this[ks[i]] = p[ks[i]];
            }

            /**
             * EnumDescriptorProto name.
             * @member {string} name
             * @memberof google.protobuf.EnumDescriptorProto
             * @instance
             */
            EnumDescriptorProto.prototype.name = "";

            /**
             * EnumDescriptorProto value.
             * @member {Array.<google.protobuf.IEnumValueDescriptorProto>} value
             * @memberof google.protobuf.EnumDescriptorProto
             * @instance
             */
            EnumDescriptorProto.prototype.value = $util.emptyArray;

            /**
             * EnumDescriptorProto options.
             * @member {google.protobuf.IEnumOptions|null|undefined} options
             * @memberof google.protobuf.EnumDescriptorProto
             * @instance
             */
            EnumDescriptorProto.prototype.options = null;

            /**
             * Creates a new EnumDescriptorProto instance using the specified properties.
             * @function create
             * @memberof google.protobuf.EnumDescriptorProto
             * @static
             * @param {google.protobuf.IEnumDescriptorProto=} [properties] Properties to set
             * @returns {google.protobuf.EnumDescriptorProto} EnumDescriptorProto instance
             */
            EnumDescriptorProto.create = function create(properties) {
                return new EnumDescriptorProto(properties);
            };

            /**
             * Encodes the specified EnumDescriptorProto message. Does not implicitly {@link google.protobuf.EnumDescriptorProto.verify|verify} messages.
             * @function encode
             * @memberof google.protobuf.EnumDescriptorProto
             * @static
             * @param {google.protobuf.IEnumDescriptorProto} m EnumDescriptorProto message or plain object to encode
             * @param {$protobuf.Writer} [w] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            EnumDescriptorProto.encode = function encode(m, w) {
                if (!w)
                    w = $Writer.create();
                if (m.name != null && Object.hasOwnProperty.call(m, "name"))
                    w.uint32(10).string(m.name);
                if (m.value != null && m.value.length) {
                    for (var i = 0; i < m.value.length; ++i)
                        $root.google.protobuf.EnumValueDescriptorProto.encode(m.value[i], w.uint32(18).fork()).ldelim();
                }
                if (m.options != null && Object.hasOwnProperty.call(m, "options"))
                    $root.google.protobuf.EnumOptions.encode(m.options, w.uint32(26).fork()).ldelim();
                return w;
            };

            /**
             * Decodes an EnumDescriptorProto message from the specified reader or buffer.
             * @function decode
             * @memberof google.protobuf.EnumDescriptorProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
             * @param {number} [l] Message length if known beforehand
             * @returns {google.protobuf.EnumDescriptorProto} EnumDescriptorProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            EnumDescriptorProto.decode = function decode(r, l) {
                if (!(r instanceof $Reader))
                    r = $Reader.create(r);
                var c = l === undefined ? r.len : r.pos + l, m = new $root.google.protobuf.EnumDescriptorProto();
                while (r.pos < c) {
                    var t = r.uint32();
                    switch (t >>> 3) {
                    case 1:
                        m.name = r.string();
                        break;
                    case 2:
                        if (!(m.value && m.value.length))
                            m.value = [];
                        m.value.push($root.google.protobuf.EnumValueDescriptorProto.decode(r, r.uint32()));
                        break;
                    case 3:
                        m.options = $root.google.protobuf.EnumOptions.decode(r, r.uint32());
                        break;
                    default:
                        r.skipType(t & 7);
                        break;
                    }
                }
                return m;
            };

            return EnumDescriptorProto;
        })();

        protobuf.EnumValueDescriptorProto = (function() {

            /**
             * Properties of an EnumValueDescriptorProto.
             * @memberof google.protobuf
             * @interface IEnumValueDescriptorProto
             * @property {string|null} [name] EnumValueDescriptorProto name
             * @property {number|null} [number] EnumValueDescriptorProto number
             * @property {google.protobuf.IEnumValueOptions|null} [options] EnumValueDescriptorProto options
             */

            /**
             * Constructs a new EnumValueDescriptorProto.
             * @memberof google.protobuf
             * @classdesc Represents an EnumValueDescriptorProto.
             * @implements IEnumValueDescriptorProto
             * @constructor
             * @param {google.protobuf.IEnumValueDescriptorProto=} [p] Properties to set
             */
            function EnumValueDescriptorProto(p) {
                if (p)
                    for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                        if (p[ks[i]] != null)
                            this[ks[i]] = p[ks[i]];
            }

            /**
             * EnumValueDescriptorProto name.
             * @member {string} name
             * @memberof google.protobuf.EnumValueDescriptorProto
             * @instance
             */
            EnumValueDescriptorProto.prototype.name = "";

            /**
             * EnumValueDescriptorProto number.
             * @member {number} number
             * @memberof google.protobuf.EnumValueDescriptorProto
             * @instance
             */
            EnumValueDescriptorProto.prototype.number = 0;

            /**
             * EnumValueDescriptorProto options.
             * @member {google.protobuf.IEnumValueOptions|null|undefined} options
             * @memberof google.protobuf.EnumValueDescriptorProto
             * @instance
             */
            EnumValueDescriptorProto.prototype.options = null;

            /**
             * Creates a new EnumValueDescriptorProto instance using the specified properties.
             * @function create
             * @memberof google.protobuf.EnumValueDescriptorProto
             * @static
             * @param {google.protobuf.IEnumValueDescriptorProto=} [properties] Properties to set
             * @returns {google.protobuf.EnumValueDescriptorProto} EnumValueDescriptorProto instance
             */
            EnumValueDescriptorProto.create = function create(properties) {
                return new EnumValueDescriptorProto(properties);
            };

            /**
             * Encodes the specified EnumValueDescriptorProto message. Does not implicitly {@link google.protobuf.EnumValueDescriptorProto.verify|verify} messages.
             * @function encode
             * @memberof google.protobuf.EnumValueDescriptorProto
             * @static
             * @param {google.protobuf.IEnumValueDescriptorProto} m EnumValueDescriptorProto message or plain object to encode
             * @param {$protobuf.Writer} [w] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            EnumValueDescriptorProto.encode = function encode(m, w) {
                if (!w)
                    w = $Writer.create();
                if (m.name != null && Object.hasOwnProperty.call(m, "name"))
                    w.uint32(10).string(m.name);
                if (m.number != null && Object.hasOwnProperty.call(m, "number"))
                    w.uint32(16).int32(m.number);
                if (m.options != null && Object.hasOwnProperty.call(m, "options"))
                    $root.google.protobuf.EnumValueOptions.encode(m.options, w.uint32(26).fork()).ldelim();
                return w;
            };

            /**
             * Decodes an EnumValueDescriptorProto message from the specified reader or buffer.
             * @function decode
             * @memberof google.protobuf.EnumValueDescriptorProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
             * @param {number} [l] Message length if known beforehand
             * @returns {google.protobuf.EnumValueDescriptorProto} EnumValueDescriptorProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            EnumValueDescriptorProto.decode = function decode(r, l) {
                if (!(r instanceof $Reader))
                    r = $Reader.create(r);
                var c = l === undefined ? r.len : r.pos + l, m = new $root.google.protobuf.EnumValueDescriptorProto();
                while (r.pos < c) {
                    var t = r.uint32();
                    switch (t >>> 3) {
                    case 1:
                        m.name = r.string();
                        break;
                    case 2:
                        m.number = r.int32();
                        break;
                    case 3:
                        m.options = $root.google.protobuf.EnumValueOptions.decode(r, r.uint32());
                        break;
                    default:
                        r.skipType(t & 7);
                        break;
                    }
                }
                return m;
            };

            return EnumValueDescriptorProto;
        })();

        protobuf.ServiceDescriptorProto = (function() {

            /**
             * Properties of a ServiceDescriptorProto.
             * @memberof google.protobuf
             * @interface IServiceDescriptorProto
             * @property {string|null} [name] ServiceDescriptorProto name
             * @property {Array.<google.protobuf.IMethodDescriptorProto>|null} [method] ServiceDescriptorProto method
             * @property {google.protobuf.IServiceOptions|null} [options] ServiceDescriptorProto options
             */

            /**
             * Constructs a new ServiceDescriptorProto.
             * @memberof google.protobuf
             * @classdesc Represents a ServiceDescriptorProto.
             * @implements IServiceDescriptorProto
             * @constructor
             * @param {google.protobuf.IServiceDescriptorProto=} [p] Properties to set
             */
            function ServiceDescriptorProto(p) {
                this.method = [];
                if (p)
                    for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                        if (p[ks[i]] != null)
                            this[ks[i]] = p[ks[i]];
            }

            /**
             * ServiceDescriptorProto name.
             * @member {string} name
             * @memberof google.protobuf.ServiceDescriptorProto
             * @instance
             */
            ServiceDescriptorProto.prototype.name = "";

            /**
             * ServiceDescriptorProto method.
             * @member {Array.<google.protobuf.IMethodDescriptorProto>} method
             * @memberof google.protobuf.ServiceDescriptorProto
             * @instance
             */
            ServiceDescriptorProto.prototype.method = $util.emptyArray;

            /**
             * ServiceDescriptorProto options.
             * @member {google.protobuf.IServiceOptions|null|undefined} options
             * @memberof google.protobuf.ServiceDescriptorProto
             * @instance
             */
            ServiceDescriptorProto.prototype.options = null;

            /**
             * Creates a new ServiceDescriptorProto instance using the specified properties.
             * @function create
             * @memberof google.protobuf.ServiceDescriptorProto
             * @static
             * @param {google.protobuf.IServiceDescriptorProto=} [properties] Properties to set
             * @returns {google.protobuf.ServiceDescriptorProto} ServiceDescriptorProto instance
             */
            ServiceDescriptorProto.create = function create(properties) {
                return new ServiceDescriptorProto(properties);
            };

            /**
             * Encodes the specified ServiceDescriptorProto message. Does not implicitly {@link google.protobuf.ServiceDescriptorProto.verify|verify} messages.
             * @function encode
             * @memberof google.protobuf.ServiceDescriptorProto
             * @static
             * @param {google.protobuf.IServiceDescriptorProto} m ServiceDescriptorProto message or plain object to encode
             * @param {$protobuf.Writer} [w] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            ServiceDescriptorProto.encode = function encode(m, w) {
                if (!w)
                    w = $Writer.create();
                if (m.name != null && Object.hasOwnProperty.call(m, "name"))
                    w.uint32(10).string(m.name);
                if (m.method != null && m.method.length) {
                    for (var i = 0; i < m.method.length; ++i)
                        $root.google.protobuf.MethodDescriptorProto.encode(m.method[i], w.uint32(18).fork()).ldelim();
                }
                if (m.options != null && Object.hasOwnProperty.call(m, "options"))
                    $root.google.protobuf.ServiceOptions.encode(m.options, w.uint32(26).fork()).ldelim();
                return w;
            };

            /**
             * Decodes a ServiceDescriptorProto message from the specified reader or buffer.
             * @function decode
             * @memberof google.protobuf.ServiceDescriptorProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
             * @param {number} [l] Message length if known beforehand
             * @returns {google.protobuf.ServiceDescriptorProto} ServiceDescriptorProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            ServiceDescriptorProto.decode = function decode(r, l) {
                if (!(r instanceof $Reader))
                    r = $Reader.create(r);
                var c = l === undefined ? r.len : r.pos + l, m = new $root.google.protobuf.ServiceDescriptorProto();
                while (r.pos < c) {
                    var t = r.uint32();
                    switch (t >>> 3) {
                    case 1:
                        m.name = r.string();
                        break;
                    case 2:
                        if (!(m.method && m.method.length))
                            m.method = [];
                        m.method.push($root.google.protobuf.MethodDescriptorProto.decode(r, r.uint32()));
                        break;
                    case 3:
                        m.options = $root.google.protobuf.ServiceOptions.decode(r, r.uint32());
                        break;
                    default:
                        r.skipType(t & 7);
                        break;
                    }
                }
                return m;
            };

            return ServiceDescriptorProto;
        })();

        protobuf.MethodDescriptorProto = (function() {

            /**
             * Properties of a MethodDescriptorProto.
             * @memberof google.protobuf
             * @interface IMethodDescriptorProto
             * @property {string|null} [name] MethodDescriptorProto name
             * @property {string|null} [inputType] MethodDescriptorProto inputType
             * @property {string|null} [outputType] MethodDescriptorProto outputType
             * @property {google.protobuf.IMethodOptions|null} [options] MethodDescriptorProto options
             * @property {boolean|null} [clientStreaming] MethodDescriptorProto clientStreaming
             * @property {boolean|null} [serverStreaming] MethodDescriptorProto serverStreaming
             */

            /**
             * Constructs a new MethodDescriptorProto.
             * @memberof google.protobuf
             * @classdesc Represents a MethodDescriptorProto.
             * @implements IMethodDescriptorProto
             * @constructor
             * @param {google.protobuf.IMethodDescriptorProto=} [p] Properties to set
             */
            function MethodDescriptorProto(p) {
                if (p)
                    for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                        if (p[ks[i]] != null)
                            this[ks[i]] = p[ks[i]];
            }

            /**
             * MethodDescriptorProto name.
             * @member {string} name
             * @memberof google.protobuf.MethodDescriptorProto
             * @instance
             */
            MethodDescriptorProto.prototype.name = "";

            /**
             * MethodDescriptorProto inputType.
             * @member {string} inputType
             * @memberof google.protobuf.MethodDescriptorProto
             * @instance
             */
            MethodDescriptorProto.prototype.inputType = "";

            /**
             * MethodDescriptorProto outputType.
             * @member {string} outputType
             * @memberof google.protobuf.MethodDescriptorProto
             * @instance
             */
            MethodDescriptorProto.prototype.outputType = "";

            /**
             * MethodDescriptorProto options.
             * @member {google.protobuf.IMethodOptions|null|undefined} options
             * @memberof google.protobuf.MethodDescriptorProto
             * @instance
             */
            MethodDescriptorProto.prototype.options = null;

            /**
             * MethodDescriptorProto clientStreaming.
             * @member {boolean} clientStreaming
             * @memberof google.protobuf.MethodDescriptorProto
             * @instance
             */
            MethodDescriptorProto.prototype.clientStreaming = false;

            /**
             * MethodDescriptorProto serverStreaming.
             * @member {boolean} serverStreaming
             * @memberof google.protobuf.MethodDescriptorProto
             * @instance
             */
            MethodDescriptorProto.prototype.serverStreaming = false;

            /**
             * Creates a new MethodDescriptorProto instance using the specified properties.
             * @function create
             * @memberof google.protobuf.MethodDescriptorProto
             * @static
             * @param {google.protobuf.IMethodDescriptorProto=} [properties] Properties to set
             * @returns {google.protobuf.MethodDescriptorProto} MethodDescriptorProto instance
             */
            MethodDescriptorProto.create = function create(properties) {
                return new MethodDescriptorProto(properties);
            };

            /**
             * Encodes the specified MethodDescriptorProto message. Does not implicitly {@link google.protobuf.MethodDescriptorProto.verify|verify} messages.
             * @function encode
             * @memberof google.protobuf.MethodDescriptorProto
             * @static
             * @param {google.protobuf.IMethodDescriptorProto} m MethodDescriptorProto message or plain object to encode
             * @param {$protobuf.Writer} [w] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            MethodDescriptorProto.encode = function encode(m, w) {
                if (!w)
                    w = $Writer.create();
                if (m.name != null && Object.hasOwnProperty.call(m, "name"))
                    w.uint32(10).string(m.name);
                if (m.inputType != null && Object.hasOwnProperty.call(m, "inputType"))
                    w.uint32(18).string(m.inputType);
                if (m.outputType != null && Object.hasOwnProperty.call(m, "outputType"))
                    w.uint32(26).string(m.outputType);
                if (m.options != null && Object.hasOwnProperty.call(m, "options"))
                    $root.google.protobuf.MethodOptions.encode(m.options, w.uint32(34).fork()).ldelim();
                if (m.clientStreaming != null && Object.hasOwnProperty.call(m, "clientStreaming"))
                    w.uint32(40).bool(m.clientStreaming);
                if (m.serverStreaming != null && Object.hasOwnProperty.call(m, "serverStreaming"))
                    w.uint32(48).bool(m.serverStreaming);
                return w;
            };

            /**
             * Decodes a MethodDescriptorProto message from the specified reader or buffer.
             * @function decode
             * @memberof google.protobuf.MethodDescriptorProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
             * @param {number} [l] Message length if known beforehand
             * @returns {google.protobuf.MethodDescriptorProto} MethodDescriptorProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            MethodDescriptorProto.decode = function decode(r, l) {
                if (!(r instanceof $Reader))
                    r = $Reader.create(r);
                var c = l === undefined ? r.len : r.pos + l, m = new $root.google.protobuf.MethodDescriptorProto();
                while (r.pos < c) {
                    var t = r.uint32();
                    switch (t >>> 3) {
                    case 1:
                        m.name = r.string();
                        break;
                    case 2:
                        m.inputType = r.string();
                        break;
                    case 3:
                        m.outputType = r.string();
                        break;
                    case 4:
                        m.options = $root.google.protobuf.MethodOptions.decode(r, r.uint32());
                        break;
                    case 5:
                        m.clientStreaming = r.bool();
                        break;
                    case 6:
                        m.serverStreaming = r.bool();
                        break;
                    default:
                        r.skipType(t & 7);
                        break;
                    }
                }
                return m;
            };

            return MethodDescriptorProto;
        })();

        protobuf.FileOptions = (function() {

            /**
             * Properties of a FileOptions.
             * @memberof google.protobuf
             * @interface IFileOptions
             * @property {string|null} [javaPackage] FileOptions javaPackage
             * @property {string|null} [javaOuterClassname] FileOptions javaOuterClassname
             * @property {boolean|null} [javaMultipleFiles] FileOptions javaMultipleFiles
             * @property {boolean|null} [javaGenerateEqualsAndHash] FileOptions javaGenerateEqualsAndHash
             * @property {boolean|null} [javaStringCheckUtf8] FileOptions javaStringCheckUtf8
             * @property {google.protobuf.FileOptions.OptimizeMode|null} [optimizeFor] FileOptions optimizeFor
             * @property {string|null} [goPackage] FileOptions goPackage
             * @property {boolean|null} [ccGenericServices] FileOptions ccGenericServices
             * @property {boolean|null} [javaGenericServices] FileOptions javaGenericServices
             * @property {boolean|null} [pyGenericServices] FileOptions pyGenericServices
             * @property {boolean|null} [deprecated] FileOptions deprecated
             * @property {boolean|null} [ccEnableArenas] FileOptions ccEnableArenas
             * @property {string|null} [objcClassPrefix] FileOptions objcClassPrefix
             * @property {string|null} [csharpNamespace] FileOptions csharpNamespace
             * @property {Array.<google.protobuf.IUninterpretedOption>|null} [uninterpretedOption] FileOptions uninterpretedOption
             * @property {string|null} [".common.serviceCalls"] FileOptions .common.serviceCalls
             */

            /**
             * Constructs a new FileOptions.
             * @memberof google.protobuf
             * @classdesc Represents a FileOptions.
             * @implements IFileOptions
             * @constructor
             * @param {google.protobuf.IFileOptions=} [p] Properties to set
             */
            function FileOptions(p) {
                this.uninterpretedOption = [];
                if (p)
                    for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                        if (p[ks[i]] != null)
                            this[ks[i]] = p[ks[i]];
            }

            /**
             * FileOptions javaPackage.
             * @member {string} javaPackage
             * @memberof google.protobuf.FileOptions
             * @instance
             */
            FileOptions.prototype.javaPackage = "";

            /**
             * FileOptions javaOuterClassname.
             * @member {string} javaOuterClassname
             * @memberof google.protobuf.FileOptions
             * @instance
             */
            FileOptions.prototype.javaOuterClassname = "";

            /**
             * FileOptions javaMultipleFiles.
             * @member {boolean} javaMultipleFiles
             * @memberof google.protobuf.FileOptions
             * @instance
             */
            FileOptions.prototype.javaMultipleFiles = false;

            /**
             * FileOptions javaGenerateEqualsAndHash.
             * @member {boolean} javaGenerateEqualsAndHash
             * @memberof google.protobuf.FileOptions
             * @instance
             */
            FileOptions.prototype.javaGenerateEqualsAndHash = false;

            /**
             * FileOptions javaStringCheckUtf8.
             * @member {boolean} javaStringCheckUtf8
             * @memberof google.protobuf.FileOptions
             * @instance
             */
            FileOptions.prototype.javaStringCheckUtf8 = false;

            /**
             * FileOptions optimizeFor.
             * @member {google.protobuf.FileOptions.OptimizeMode} optimizeFor
             * @memberof google.protobuf.FileOptions
             * @instance
             */
            FileOptions.prototype.optimizeFor = 1;

            /**
             * FileOptions goPackage.
             * @member {string} goPackage
             * @memberof google.protobuf.FileOptions
             * @instance
             */
            FileOptions.prototype.goPackage = "";

            /**
             * FileOptions ccGenericServices.
             * @member {boolean} ccGenericServices
             * @memberof google.protobuf.FileOptions
             * @instance
             */
            FileOptions.prototype.ccGenericServices = false;

            /**
             * FileOptions javaGenericServices.
             * @member {boolean} javaGenericServices
             * @memberof google.protobuf.FileOptions
             * @instance
             */
            FileOptions.prototype.javaGenericServices = false;

            /**
             * FileOptions pyGenericServices.
             * @member {boolean} pyGenericServices
             * @memberof google.protobuf.FileOptions
             * @instance
             */
            FileOptions.prototype.pyGenericServices = false;

            /**
             * FileOptions deprecated.
             * @member {boolean} deprecated
             * @memberof google.protobuf.FileOptions
             * @instance
             */
            FileOptions.prototype.deprecated = false;

            /**
             * FileOptions ccEnableArenas.
             * @member {boolean} ccEnableArenas
             * @memberof google.protobuf.FileOptions
             * @instance
             */
            FileOptions.prototype.ccEnableArenas = false;

            /**
             * FileOptions objcClassPrefix.
             * @member {string} objcClassPrefix
             * @memberof google.protobuf.FileOptions
             * @instance
             */
            FileOptions.prototype.objcClassPrefix = "";

            /**
             * FileOptions csharpNamespace.
             * @member {string} csharpNamespace
             * @memberof google.protobuf.FileOptions
             * @instance
             */
            FileOptions.prototype.csharpNamespace = "";

            /**
             * FileOptions uninterpretedOption.
             * @member {Array.<google.protobuf.IUninterpretedOption>} uninterpretedOption
             * @memberof google.protobuf.FileOptions
             * @instance
             */
            FileOptions.prototype.uninterpretedOption = $util.emptyArray;

            /**
             * FileOptions .common.serviceCalls.
             * @member {string} .common.serviceCalls
             * @memberof google.protobuf.FileOptions
             * @instance
             */
            FileOptions.prototype[".common.serviceCalls"] = "";

            /**
             * Creates a new FileOptions instance using the specified properties.
             * @function create
             * @memberof google.protobuf.FileOptions
             * @static
             * @param {google.protobuf.IFileOptions=} [properties] Properties to set
             * @returns {google.protobuf.FileOptions} FileOptions instance
             */
            FileOptions.create = function create(properties) {
                return new FileOptions(properties);
            };

            /**
             * Encodes the specified FileOptions message. Does not implicitly {@link google.protobuf.FileOptions.verify|verify} messages.
             * @function encode
             * @memberof google.protobuf.FileOptions
             * @static
             * @param {google.protobuf.IFileOptions} m FileOptions message or plain object to encode
             * @param {$protobuf.Writer} [w] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            FileOptions.encode = function encode(m, w) {
                if (!w)
                    w = $Writer.create();
                if (m.javaPackage != null && Object.hasOwnProperty.call(m, "javaPackage"))
                    w.uint32(10).string(m.javaPackage);
                if (m.javaOuterClassname != null && Object.hasOwnProperty.call(m, "javaOuterClassname"))
                    w.uint32(66).string(m.javaOuterClassname);
                if (m.optimizeFor != null && Object.hasOwnProperty.call(m, "optimizeFor"))
                    w.uint32(72).int32(m.optimizeFor);
                if (m.javaMultipleFiles != null && Object.hasOwnProperty.call(m, "javaMultipleFiles"))
                    w.uint32(80).bool(m.javaMultipleFiles);
                if (m.goPackage != null && Object.hasOwnProperty.call(m, "goPackage"))
                    w.uint32(90).string(m.goPackage);
                if (m.ccGenericServices != null && Object.hasOwnProperty.call(m, "ccGenericServices"))
                    w.uint32(128).bool(m.ccGenericServices);
                if (m.javaGenericServices != null && Object.hasOwnProperty.call(m, "javaGenericServices"))
                    w.uint32(136).bool(m.javaGenericServices);
                if (m.pyGenericServices != null && Object.hasOwnProperty.call(m, "pyGenericServices"))
                    w.uint32(144).bool(m.pyGenericServices);
                if (m.javaGenerateEqualsAndHash != null && Object.hasOwnProperty.call(m, "javaGenerateEqualsAndHash"))
                    w.uint32(160).bool(m.javaGenerateEqualsAndHash);
                if (m.deprecated != null && Object.hasOwnProperty.call(m, "deprecated"))
                    w.uint32(184).bool(m.deprecated);
                if (m.javaStringCheckUtf8 != null && Object.hasOwnProperty.call(m, "javaStringCheckUtf8"))
                    w.uint32(216).bool(m.javaStringCheckUtf8);
                if (m.ccEnableArenas != null && Object.hasOwnProperty.call(m, "ccEnableArenas"))
                    w.uint32(248).bool(m.ccEnableArenas);
                if (m.objcClassPrefix != null && Object.hasOwnProperty.call(m, "objcClassPrefix"))
                    w.uint32(290).string(m.objcClassPrefix);
                if (m.csharpNamespace != null && Object.hasOwnProperty.call(m, "csharpNamespace"))
                    w.uint32(298).string(m.csharpNamespace);
                if (m.uninterpretedOption != null && m.uninterpretedOption.length) {
                    for (var i = 0; i < m.uninterpretedOption.length; ++i)
                        $root.google.protobuf.UninterpretedOption.encode(m.uninterpretedOption[i], w.uint32(7994).fork()).ldelim();
                }
                if (m[".common.serviceCalls"] != null && Object.hasOwnProperty.call(m, ".common.serviceCalls"))
                    w.uint32(400034).string(m[".common.serviceCalls"]);
                return w;
            };

            /**
             * Decodes a FileOptions message from the specified reader or buffer.
             * @function decode
             * @memberof google.protobuf.FileOptions
             * @static
             * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
             * @param {number} [l] Message length if known beforehand
             * @returns {google.protobuf.FileOptions} FileOptions
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            FileOptions.decode = function decode(r, l) {
                if (!(r instanceof $Reader))
                    r = $Reader.create(r);
                var c = l === undefined ? r.len : r.pos + l, m = new $root.google.protobuf.FileOptions();
                while (r.pos < c) {
                    var t = r.uint32();
                    switch (t >>> 3) {
                    case 1:
                        m.javaPackage = r.string();
                        break;
                    case 8:
                        m.javaOuterClassname = r.string();
                        break;
                    case 10:
                        m.javaMultipleFiles = r.bool();
                        break;
                    case 20:
                        m.javaGenerateEqualsAndHash = r.bool();
                        break;
                    case 27:
                        m.javaStringCheckUtf8 = r.bool();
                        break;
                    case 9:
                        m.optimizeFor = r.int32();
                        break;
                    case 11:
                        m.goPackage = r.string();
                        break;
                    case 16:
                        m.ccGenericServices = r.bool();
                        break;
                    case 17:
                        m.javaGenericServices = r.bool();
                        break;
                    case 18:
                        m.pyGenericServices = r.bool();
                        break;
                    case 23:
                        m.deprecated = r.bool();
                        break;
                    case 31:
                        m.ccEnableArenas = r.bool();
                        break;
                    case 36:
                        m.objcClassPrefix = r.string();
                        break;
                    case 37:
                        m.csharpNamespace = r.string();
                        break;
                    case 999:
                        if (!(m.uninterpretedOption && m.uninterpretedOption.length))
                            m.uninterpretedOption = [];
                        m.uninterpretedOption.push($root.google.protobuf.UninterpretedOption.decode(r, r.uint32()));
                        break;
                    case 50004:
                        m[".common.serviceCalls"] = r.string();
                        break;
                    default:
                        r.skipType(t & 7);
                        break;
                    }
                }
                return m;
            };

            /**
             * OptimizeMode enum.
             * @name google.protobuf.FileOptions.OptimizeMode
             * @enum {number}
             * @property {number} SPEED=1 SPEED value
             * @property {number} CODE_SIZE=2 CODE_SIZE value
             * @property {number} LITE_RUNTIME=3 LITE_RUNTIME value
             */
            FileOptions.OptimizeMode = (function() {
                const valuesById = {}, values = Object.create(valuesById);
                values[valuesById[1] = "SPEED"] = 1;
                values[valuesById[2] = "CODE_SIZE"] = 2;
                values[valuesById[3] = "LITE_RUNTIME"] = 3;
                return values;
            })();

            return FileOptions;
        })();

        protobuf.MessageOptions = (function() {

            /**
             * Properties of a MessageOptions.
             * @memberof google.protobuf
             * @interface IMessageOptions
             * @property {boolean|null} [messageSetWireFormat] MessageOptions messageSetWireFormat
             * @property {boolean|null} [noStandardDescriptorAccessor] MessageOptions noStandardDescriptorAccessor
             * @property {boolean|null} [deprecated] MessageOptions deprecated
             * @property {boolean|null} [mapEntry] MessageOptions mapEntry
             * @property {Array.<google.protobuf.IUninterpretedOption>|null} [uninterpretedOption] MessageOptions uninterpretedOption
             */

            /**
             * Constructs a new MessageOptions.
             * @memberof google.protobuf
             * @classdesc Represents a MessageOptions.
             * @implements IMessageOptions
             * @constructor
             * @param {google.protobuf.IMessageOptions=} [p] Properties to set
             */
            function MessageOptions(p) {
                this.uninterpretedOption = [];
                if (p)
                    for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                        if (p[ks[i]] != null)
                            this[ks[i]] = p[ks[i]];
            }

            /**
             * MessageOptions messageSetWireFormat.
             * @member {boolean} messageSetWireFormat
             * @memberof google.protobuf.MessageOptions
             * @instance
             */
            MessageOptions.prototype.messageSetWireFormat = false;

            /**
             * MessageOptions noStandardDescriptorAccessor.
             * @member {boolean} noStandardDescriptorAccessor
             * @memberof google.protobuf.MessageOptions
             * @instance
             */
            MessageOptions.prototype.noStandardDescriptorAccessor = false;

            /**
             * MessageOptions deprecated.
             * @member {boolean} deprecated
             * @memberof google.protobuf.MessageOptions
             * @instance
             */
            MessageOptions.prototype.deprecated = false;

            /**
             * MessageOptions mapEntry.
             * @member {boolean} mapEntry
             * @memberof google.protobuf.MessageOptions
             * @instance
             */
            MessageOptions.prototype.mapEntry = false;

            /**
             * MessageOptions uninterpretedOption.
             * @member {Array.<google.protobuf.IUninterpretedOption>} uninterpretedOption
             * @memberof google.protobuf.MessageOptions
             * @instance
             */
            MessageOptions.prototype.uninterpretedOption = $util.emptyArray;

            /**
             * Creates a new MessageOptions instance using the specified properties.
             * @function create
             * @memberof google.protobuf.MessageOptions
             * @static
             * @param {google.protobuf.IMessageOptions=} [properties] Properties to set
             * @returns {google.protobuf.MessageOptions} MessageOptions instance
             */
            MessageOptions.create = function create(properties) {
                return new MessageOptions(properties);
            };

            /**
             * Encodes the specified MessageOptions message. Does not implicitly {@link google.protobuf.MessageOptions.verify|verify} messages.
             * @function encode
             * @memberof google.protobuf.MessageOptions
             * @static
             * @param {google.protobuf.IMessageOptions} m MessageOptions message or plain object to encode
             * @param {$protobuf.Writer} [w] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            MessageOptions.encode = function encode(m, w) {
                if (!w)
                    w = $Writer.create();
                if (m.messageSetWireFormat != null && Object.hasOwnProperty.call(m, "messageSetWireFormat"))
                    w.uint32(8).bool(m.messageSetWireFormat);
                if (m.noStandardDescriptorAccessor != null && Object.hasOwnProperty.call(m, "noStandardDescriptorAccessor"))
                    w.uint32(16).bool(m.noStandardDescriptorAccessor);
                if (m.deprecated != null && Object.hasOwnProperty.call(m, "deprecated"))
                    w.uint32(24).bool(m.deprecated);
                if (m.mapEntry != null && Object.hasOwnProperty.call(m, "mapEntry"))
                    w.uint32(56).bool(m.mapEntry);
                if (m.uninterpretedOption != null && m.uninterpretedOption.length) {
                    for (var i = 0; i < m.uninterpretedOption.length; ++i)
                        $root.google.protobuf.UninterpretedOption.encode(m.uninterpretedOption[i], w.uint32(7994).fork()).ldelim();
                }
                return w;
            };

            /**
             * Decodes a MessageOptions message from the specified reader or buffer.
             * @function decode
             * @memberof google.protobuf.MessageOptions
             * @static
             * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
             * @param {number} [l] Message length if known beforehand
             * @returns {google.protobuf.MessageOptions} MessageOptions
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            MessageOptions.decode = function decode(r, l) {
                if (!(r instanceof $Reader))
                    r = $Reader.create(r);
                var c = l === undefined ? r.len : r.pos + l, m = new $root.google.protobuf.MessageOptions();
                while (r.pos < c) {
                    var t = r.uint32();
                    switch (t >>> 3) {
                    case 1:
                        m.messageSetWireFormat = r.bool();
                        break;
                    case 2:
                        m.noStandardDescriptorAccessor = r.bool();
                        break;
                    case 3:
                        m.deprecated = r.bool();
                        break;
                    case 7:
                        m.mapEntry = r.bool();
                        break;
                    case 999:
                        if (!(m.uninterpretedOption && m.uninterpretedOption.length))
                            m.uninterpretedOption = [];
                        m.uninterpretedOption.push($root.google.protobuf.UninterpretedOption.decode(r, r.uint32()));
                        break;
                    default:
                        r.skipType(t & 7);
                        break;
                    }
                }
                return m;
            };

            return MessageOptions;
        })();

        protobuf.FieldOptions = (function() {

            /**
             * Properties of a FieldOptions.
             * @memberof google.protobuf
             * @interface IFieldOptions
             * @property {google.protobuf.FieldOptions.CType|null} [ctype] FieldOptions ctype
             * @property {boolean|null} [packed] FieldOptions packed
             * @property {google.protobuf.FieldOptions.JSType|null} [jstype] FieldOptions jstype
             * @property {boolean|null} [lazy] FieldOptions lazy
             * @property {boolean|null} [deprecated] FieldOptions deprecated
             * @property {boolean|null} [weak] FieldOptions weak
             * @property {Array.<google.protobuf.IUninterpretedOption>|null} [uninterpretedOption] FieldOptions uninterpretedOption
             * @property {boolean|null} [".common.doNotLog"] FieldOptions .common.doNotLog
             * @property {boolean|null} [".common.internal"] FieldOptions .common.internal
             */

            /**
             * Constructs a new FieldOptions.
             * @memberof google.protobuf
             * @classdesc Represents a FieldOptions.
             * @implements IFieldOptions
             * @constructor
             * @param {google.protobuf.IFieldOptions=} [p] Properties to set
             */
            function FieldOptions(p) {
                this.uninterpretedOption = [];
                if (p)
                    for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                        if (p[ks[i]] != null)
                            this[ks[i]] = p[ks[i]];
            }

            /**
             * FieldOptions ctype.
             * @member {google.protobuf.FieldOptions.CType} ctype
             * @memberof google.protobuf.FieldOptions
             * @instance
             */
            FieldOptions.prototype.ctype = 0;

            /**
             * FieldOptions packed.
             * @member {boolean} packed
             * @memberof google.protobuf.FieldOptions
             * @instance
             */
            FieldOptions.prototype.packed = false;

            /**
             * FieldOptions jstype.
             * @member {google.protobuf.FieldOptions.JSType} jstype
             * @memberof google.protobuf.FieldOptions
             * @instance
             */
            FieldOptions.prototype.jstype = 0;

            /**
             * FieldOptions lazy.
             * @member {boolean} lazy
             * @memberof google.protobuf.FieldOptions
             * @instance
             */
            FieldOptions.prototype.lazy = false;

            /**
             * FieldOptions deprecated.
             * @member {boolean} deprecated
             * @memberof google.protobuf.FieldOptions
             * @instance
             */
            FieldOptions.prototype.deprecated = false;

            /**
             * FieldOptions weak.
             * @member {boolean} weak
             * @memberof google.protobuf.FieldOptions
             * @instance
             */
            FieldOptions.prototype.weak = false;

            /**
             * FieldOptions uninterpretedOption.
             * @member {Array.<google.protobuf.IUninterpretedOption>} uninterpretedOption
             * @memberof google.protobuf.FieldOptions
             * @instance
             */
            FieldOptions.prototype.uninterpretedOption = $util.emptyArray;

            /**
             * FieldOptions .common.doNotLog.
             * @member {boolean} .common.doNotLog
             * @memberof google.protobuf.FieldOptions
             * @instance
             */
            FieldOptions.prototype[".common.doNotLog"] = false;

            /**
             * FieldOptions .common.internal.
             * @member {boolean} .common.internal
             * @memberof google.protobuf.FieldOptions
             * @instance
             */
            FieldOptions.prototype[".common.internal"] = false;

            /**
             * Creates a new FieldOptions instance using the specified properties.
             * @function create
             * @memberof google.protobuf.FieldOptions
             * @static
             * @param {google.protobuf.IFieldOptions=} [properties] Properties to set
             * @returns {google.protobuf.FieldOptions} FieldOptions instance
             */
            FieldOptions.create = function create(properties) {
                return new FieldOptions(properties);
            };

            /**
             * Encodes the specified FieldOptions message. Does not implicitly {@link google.protobuf.FieldOptions.verify|verify} messages.
             * @function encode
             * @memberof google.protobuf.FieldOptions
             * @static
             * @param {google.protobuf.IFieldOptions} m FieldOptions message or plain object to encode
             * @param {$protobuf.Writer} [w] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            FieldOptions.encode = function encode(m, w) {
                if (!w)
                    w = $Writer.create();
                if (m.ctype != null && Object.hasOwnProperty.call(m, "ctype"))
                    w.uint32(8).int32(m.ctype);
                if (m.packed != null && Object.hasOwnProperty.call(m, "packed"))
                    w.uint32(16).bool(m.packed);
                if (m.deprecated != null && Object.hasOwnProperty.call(m, "deprecated"))
                    w.uint32(24).bool(m.deprecated);
                if (m.lazy != null && Object.hasOwnProperty.call(m, "lazy"))
                    w.uint32(40).bool(m.lazy);
                if (m.jstype != null && Object.hasOwnProperty.call(m, "jstype"))
                    w.uint32(48).int32(m.jstype);
                if (m.weak != null && Object.hasOwnProperty.call(m, "weak"))
                    w.uint32(80).bool(m.weak);
                if (m.uninterpretedOption != null && m.uninterpretedOption.length) {
                    for (var i = 0; i < m.uninterpretedOption.length; ++i)
                        $root.google.protobuf.UninterpretedOption.encode(m.uninterpretedOption[i], w.uint32(7994).fork()).ldelim();
                }
                if (m[".common.doNotLog"] != null && Object.hasOwnProperty.call(m, ".common.doNotLog"))
                    w.uint32(400800).bool(m[".common.doNotLog"]);
                if (m[".common.internal"] != null && Object.hasOwnProperty.call(m, ".common.internal"))
                    w.uint32(401600).bool(m[".common.internal"]);
                return w;
            };

            /**
             * Decodes a FieldOptions message from the specified reader or buffer.
             * @function decode
             * @memberof google.protobuf.FieldOptions
             * @static
             * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
             * @param {number} [l] Message length if known beforehand
             * @returns {google.protobuf.FieldOptions} FieldOptions
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            FieldOptions.decode = function decode(r, l) {
                if (!(r instanceof $Reader))
                    r = $Reader.create(r);
                var c = l === undefined ? r.len : r.pos + l, m = new $root.google.protobuf.FieldOptions();
                while (r.pos < c) {
                    var t = r.uint32();
                    switch (t >>> 3) {
                    case 1:
                        m.ctype = r.int32();
                        break;
                    case 2:
                        m.packed = r.bool();
                        break;
                    case 6:
                        m.jstype = r.int32();
                        break;
                    case 5:
                        m.lazy = r.bool();
                        break;
                    case 3:
                        m.deprecated = r.bool();
                        break;
                    case 10:
                        m.weak = r.bool();
                        break;
                    case 999:
                        if (!(m.uninterpretedOption && m.uninterpretedOption.length))
                            m.uninterpretedOption = [];
                        m.uninterpretedOption.push($root.google.protobuf.UninterpretedOption.decode(r, r.uint32()));
                        break;
                    case 50100:
                        m[".common.doNotLog"] = r.bool();
                        break;
                    case 50200:
                        m[".common.internal"] = r.bool();
                        break;
                    default:
                        r.skipType(t & 7);
                        break;
                    }
                }
                return m;
            };

            /**
             * CType enum.
             * @name google.protobuf.FieldOptions.CType
             * @enum {number}
             * @property {number} STRING=0 STRING value
             * @property {number} CORD=1 CORD value
             * @property {number} STRING_PIECE=2 STRING_PIECE value
             */
            FieldOptions.CType = (function() {
                const valuesById = {}, values = Object.create(valuesById);
                values[valuesById[0] = "STRING"] = 0;
                values[valuesById[1] = "CORD"] = 1;
                values[valuesById[2] = "STRING_PIECE"] = 2;
                return values;
            })();

            /**
             * JSType enum.
             * @name google.protobuf.FieldOptions.JSType
             * @enum {number}
             * @property {number} JS_NORMAL=0 JS_NORMAL value
             * @property {number} JS_STRING=1 JS_STRING value
             * @property {number} JS_NUMBER=2 JS_NUMBER value
             */
            FieldOptions.JSType = (function() {
                const valuesById = {}, values = Object.create(valuesById);
                values[valuesById[0] = "JS_NORMAL"] = 0;
                values[valuesById[1] = "JS_STRING"] = 1;
                values[valuesById[2] = "JS_NUMBER"] = 2;
                return values;
            })();

            return FieldOptions;
        })();

        protobuf.OneofOptions = (function() {

            /**
             * Properties of an OneofOptions.
             * @memberof google.protobuf
             * @interface IOneofOptions
             * @property {Array.<google.protobuf.IUninterpretedOption>|null} [uninterpretedOption] OneofOptions uninterpretedOption
             */

            /**
             * Constructs a new OneofOptions.
             * @memberof google.protobuf
             * @classdesc Represents an OneofOptions.
             * @implements IOneofOptions
             * @constructor
             * @param {google.protobuf.IOneofOptions=} [p] Properties to set
             */
            function OneofOptions(p) {
                this.uninterpretedOption = [];
                if (p)
                    for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                        if (p[ks[i]] != null)
                            this[ks[i]] = p[ks[i]];
            }

            /**
             * OneofOptions uninterpretedOption.
             * @member {Array.<google.protobuf.IUninterpretedOption>} uninterpretedOption
             * @memberof google.protobuf.OneofOptions
             * @instance
             */
            OneofOptions.prototype.uninterpretedOption = $util.emptyArray;

            /**
             * Creates a new OneofOptions instance using the specified properties.
             * @function create
             * @memberof google.protobuf.OneofOptions
             * @static
             * @param {google.protobuf.IOneofOptions=} [properties] Properties to set
             * @returns {google.protobuf.OneofOptions} OneofOptions instance
             */
            OneofOptions.create = function create(properties) {
                return new OneofOptions(properties);
            };

            /**
             * Encodes the specified OneofOptions message. Does not implicitly {@link google.protobuf.OneofOptions.verify|verify} messages.
             * @function encode
             * @memberof google.protobuf.OneofOptions
             * @static
             * @param {google.protobuf.IOneofOptions} m OneofOptions message or plain object to encode
             * @param {$protobuf.Writer} [w] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            OneofOptions.encode = function encode(m, w) {
                if (!w)
                    w = $Writer.create();
                if (m.uninterpretedOption != null && m.uninterpretedOption.length) {
                    for (var i = 0; i < m.uninterpretedOption.length; ++i)
                        $root.google.protobuf.UninterpretedOption.encode(m.uninterpretedOption[i], w.uint32(7994).fork()).ldelim();
                }
                return w;
            };

            /**
             * Decodes an OneofOptions message from the specified reader or buffer.
             * @function decode
             * @memberof google.protobuf.OneofOptions
             * @static
             * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
             * @param {number} [l] Message length if known beforehand
             * @returns {google.protobuf.OneofOptions} OneofOptions
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            OneofOptions.decode = function decode(r, l) {
                if (!(r instanceof $Reader))
                    r = $Reader.create(r);
                var c = l === undefined ? r.len : r.pos + l, m = new $root.google.protobuf.OneofOptions();
                while (r.pos < c) {
                    var t = r.uint32();
                    switch (t >>> 3) {
                    case 999:
                        if (!(m.uninterpretedOption && m.uninterpretedOption.length))
                            m.uninterpretedOption = [];
                        m.uninterpretedOption.push($root.google.protobuf.UninterpretedOption.decode(r, r.uint32()));
                        break;
                    default:
                        r.skipType(t & 7);
                        break;
                    }
                }
                return m;
            };

            return OneofOptions;
        })();

        protobuf.EnumOptions = (function() {

            /**
             * Properties of an EnumOptions.
             * @memberof google.protobuf
             * @interface IEnumOptions
             * @property {boolean|null} [allowAlias] EnumOptions allowAlias
             * @property {boolean|null} [deprecated] EnumOptions deprecated
             * @property {Array.<google.protobuf.IUninterpretedOption>|null} [uninterpretedOption] EnumOptions uninterpretedOption
             */

            /**
             * Constructs a new EnumOptions.
             * @memberof google.protobuf
             * @classdesc Represents an EnumOptions.
             * @implements IEnumOptions
             * @constructor
             * @param {google.protobuf.IEnumOptions=} [p] Properties to set
             */
            function EnumOptions(p) {
                this.uninterpretedOption = [];
                if (p)
                    for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                        if (p[ks[i]] != null)
                            this[ks[i]] = p[ks[i]];
            }

            /**
             * EnumOptions allowAlias.
             * @member {boolean} allowAlias
             * @memberof google.protobuf.EnumOptions
             * @instance
             */
            EnumOptions.prototype.allowAlias = false;

            /**
             * EnumOptions deprecated.
             * @member {boolean} deprecated
             * @memberof google.protobuf.EnumOptions
             * @instance
             */
            EnumOptions.prototype.deprecated = false;

            /**
             * EnumOptions uninterpretedOption.
             * @member {Array.<google.protobuf.IUninterpretedOption>} uninterpretedOption
             * @memberof google.protobuf.EnumOptions
             * @instance
             */
            EnumOptions.prototype.uninterpretedOption = $util.emptyArray;

            /**
             * Creates a new EnumOptions instance using the specified properties.
             * @function create
             * @memberof google.protobuf.EnumOptions
             * @static
             * @param {google.protobuf.IEnumOptions=} [properties] Properties to set
             * @returns {google.protobuf.EnumOptions} EnumOptions instance
             */
            EnumOptions.create = function create(properties) {
                return new EnumOptions(properties);
            };

            /**
             * Encodes the specified EnumOptions message. Does not implicitly {@link google.protobuf.EnumOptions.verify|verify} messages.
             * @function encode
             * @memberof google.protobuf.EnumOptions
             * @static
             * @param {google.protobuf.IEnumOptions} m EnumOptions message or plain object to encode
             * @param {$protobuf.Writer} [w] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            EnumOptions.encode = function encode(m, w) {
                if (!w)
                    w = $Writer.create();
                if (m.allowAlias != null && Object.hasOwnProperty.call(m, "allowAlias"))
                    w.uint32(16).bool(m.allowAlias);
                if (m.deprecated != null && Object.hasOwnProperty.call(m, "deprecated"))
                    w.uint32(24).bool(m.deprecated);
                if (m.uninterpretedOption != null && m.uninterpretedOption.length) {
                    for (var i = 0; i < m.uninterpretedOption.length; ++i)
                        $root.google.protobuf.UninterpretedOption.encode(m.uninterpretedOption[i], w.uint32(7994).fork()).ldelim();
                }
                return w;
            };

            /**
             * Decodes an EnumOptions message from the specified reader or buffer.
             * @function decode
             * @memberof google.protobuf.EnumOptions
             * @static
             * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
             * @param {number} [l] Message length if known beforehand
             * @returns {google.protobuf.EnumOptions} EnumOptions
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            EnumOptions.decode = function decode(r, l) {
                if (!(r instanceof $Reader))
                    r = $Reader.create(r);
                var c = l === undefined ? r.len : r.pos + l, m = new $root.google.protobuf.EnumOptions();
                while (r.pos < c) {
                    var t = r.uint32();
                    switch (t >>> 3) {
                    case 2:
                        m.allowAlias = r.bool();
                        break;
                    case 3:
                        m.deprecated = r.bool();
                        break;
                    case 999:
                        if (!(m.uninterpretedOption && m.uninterpretedOption.length))
                            m.uninterpretedOption = [];
                        m.uninterpretedOption.push($root.google.protobuf.UninterpretedOption.decode(r, r.uint32()));
                        break;
                    default:
                        r.skipType(t & 7);
                        break;
                    }
                }
                return m;
            };

            return EnumOptions;
        })();

        protobuf.EnumValueOptions = (function() {

            /**
             * Properties of an EnumValueOptions.
             * @memberof google.protobuf
             * @interface IEnumValueOptions
             * @property {boolean|null} [deprecated] EnumValueOptions deprecated
             * @property {Array.<google.protobuf.IUninterpretedOption>|null} [uninterpretedOption] EnumValueOptions uninterpretedOption
             */

            /**
             * Constructs a new EnumValueOptions.
             * @memberof google.protobuf
             * @classdesc Represents an EnumValueOptions.
             * @implements IEnumValueOptions
             * @constructor
             * @param {google.protobuf.IEnumValueOptions=} [p] Properties to set
             */
            function EnumValueOptions(p) {
                this.uninterpretedOption = [];
                if (p)
                    for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                        if (p[ks[i]] != null)
                            this[ks[i]] = p[ks[i]];
            }

            /**
             * EnumValueOptions deprecated.
             * @member {boolean} deprecated
             * @memberof google.protobuf.EnumValueOptions
             * @instance
             */
            EnumValueOptions.prototype.deprecated = false;

            /**
             * EnumValueOptions uninterpretedOption.
             * @member {Array.<google.protobuf.IUninterpretedOption>} uninterpretedOption
             * @memberof google.protobuf.EnumValueOptions
             * @instance
             */
            EnumValueOptions.prototype.uninterpretedOption = $util.emptyArray;

            /**
             * Creates a new EnumValueOptions instance using the specified properties.
             * @function create
             * @memberof google.protobuf.EnumValueOptions
             * @static
             * @param {google.protobuf.IEnumValueOptions=} [properties] Properties to set
             * @returns {google.protobuf.EnumValueOptions} EnumValueOptions instance
             */
            EnumValueOptions.create = function create(properties) {
                return new EnumValueOptions(properties);
            };

            /**
             * Encodes the specified EnumValueOptions message. Does not implicitly {@link google.protobuf.EnumValueOptions.verify|verify} messages.
             * @function encode
             * @memberof google.protobuf.EnumValueOptions
             * @static
             * @param {google.protobuf.IEnumValueOptions} m EnumValueOptions message or plain object to encode
             * @param {$protobuf.Writer} [w] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            EnumValueOptions.encode = function encode(m, w) {
                if (!w)
                    w = $Writer.create();
                if (m.deprecated != null && Object.hasOwnProperty.call(m, "deprecated"))
                    w.uint32(8).bool(m.deprecated);
                if (m.uninterpretedOption != null && m.uninterpretedOption.length) {
                    for (var i = 0; i < m.uninterpretedOption.length; ++i)
                        $root.google.protobuf.UninterpretedOption.encode(m.uninterpretedOption[i], w.uint32(7994).fork()).ldelim();
                }
                return w;
            };

            /**
             * Decodes an EnumValueOptions message from the specified reader or buffer.
             * @function decode
             * @memberof google.protobuf.EnumValueOptions
             * @static
             * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
             * @param {number} [l] Message length if known beforehand
             * @returns {google.protobuf.EnumValueOptions} EnumValueOptions
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            EnumValueOptions.decode = function decode(r, l) {
                if (!(r instanceof $Reader))
                    r = $Reader.create(r);
                var c = l === undefined ? r.len : r.pos + l, m = new $root.google.protobuf.EnumValueOptions();
                while (r.pos < c) {
                    var t = r.uint32();
                    switch (t >>> 3) {
                    case 1:
                        m.deprecated = r.bool();
                        break;
                    case 999:
                        if (!(m.uninterpretedOption && m.uninterpretedOption.length))
                            m.uninterpretedOption = [];
                        m.uninterpretedOption.push($root.google.protobuf.UninterpretedOption.decode(r, r.uint32()));
                        break;
                    default:
                        r.skipType(t & 7);
                        break;
                    }
                }
                return m;
            };

            return EnumValueOptions;
        })();

        protobuf.ServiceOptions = (function() {

            /**
             * Properties of a ServiceOptions.
             * @memberof google.protobuf
             * @interface IServiceOptions
             * @property {boolean|null} [deprecated] ServiceOptions deprecated
             * @property {Array.<google.protobuf.IUninterpretedOption>|null} [uninterpretedOption] ServiceOptions uninterpretedOption
             * @property {string|null} [".common.URI"] ServiceOptions .common.URI
             */

            /**
             * Constructs a new ServiceOptions.
             * @memberof google.protobuf
             * @classdesc Represents a ServiceOptions.
             * @implements IServiceOptions
             * @constructor
             * @param {google.protobuf.IServiceOptions=} [p] Properties to set
             */
            function ServiceOptions(p) {
                this.uninterpretedOption = [];
                if (p)
                    for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                        if (p[ks[i]] != null)
                            this[ks[i]] = p[ks[i]];
            }

            /**
             * ServiceOptions deprecated.
             * @member {boolean} deprecated
             * @memberof google.protobuf.ServiceOptions
             * @instance
             */
            ServiceOptions.prototype.deprecated = false;

            /**
             * ServiceOptions uninterpretedOption.
             * @member {Array.<google.protobuf.IUninterpretedOption>} uninterpretedOption
             * @memberof google.protobuf.ServiceOptions
             * @instance
             */
            ServiceOptions.prototype.uninterpretedOption = $util.emptyArray;

            /**
             * ServiceOptions .common.URI.
             * @member {string} .common.URI
             * @memberof google.protobuf.ServiceOptions
             * @instance
             */
            ServiceOptions.prototype[".common.URI"] = "";

            /**
             * Creates a new ServiceOptions instance using the specified properties.
             * @function create
             * @memberof google.protobuf.ServiceOptions
             * @static
             * @param {google.protobuf.IServiceOptions=} [properties] Properties to set
             * @returns {google.protobuf.ServiceOptions} ServiceOptions instance
             */
            ServiceOptions.create = function create(properties) {
                return new ServiceOptions(properties);
            };

            /**
             * Encodes the specified ServiceOptions message. Does not implicitly {@link google.protobuf.ServiceOptions.verify|verify} messages.
             * @function encode
             * @memberof google.protobuf.ServiceOptions
             * @static
             * @param {google.protobuf.IServiceOptions} m ServiceOptions message or plain object to encode
             * @param {$protobuf.Writer} [w] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            ServiceOptions.encode = function encode(m, w) {
                if (!w)
                    w = $Writer.create();
                if (m.deprecated != null && Object.hasOwnProperty.call(m, "deprecated"))
                    w.uint32(264).bool(m.deprecated);
                if (m.uninterpretedOption != null && m.uninterpretedOption.length) {
                    for (var i = 0; i < m.uninterpretedOption.length; ++i)
                        $root.google.protobuf.UninterpretedOption.encode(m.uninterpretedOption[i], w.uint32(7994).fork()).ldelim();
                }
                if (m[".common.URI"] != null && Object.hasOwnProperty.call(m, ".common.URI"))
                    w.uint32(400010).string(m[".common.URI"]);
                return w;
            };

            /**
             * Decodes a ServiceOptions message from the specified reader or buffer.
             * @function decode
             * @memberof google.protobuf.ServiceOptions
             * @static
             * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
             * @param {number} [l] Message length if known beforehand
             * @returns {google.protobuf.ServiceOptions} ServiceOptions
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            ServiceOptions.decode = function decode(r, l) {
                if (!(r instanceof $Reader))
                    r = $Reader.create(r);
                var c = l === undefined ? r.len : r.pos + l, m = new $root.google.protobuf.ServiceOptions();
                while (r.pos < c) {
                    var t = r.uint32();
                    switch (t >>> 3) {
                    case 33:
                        m.deprecated = r.bool();
                        break;
                    case 999:
                        if (!(m.uninterpretedOption && m.uninterpretedOption.length))
                            m.uninterpretedOption = [];
                        m.uninterpretedOption.push($root.google.protobuf.UninterpretedOption.decode(r, r.uint32()));
                        break;
                    case 50001:
                        m[".common.URI"] = r.string();
                        break;
                    default:
                        r.skipType(t & 7);
                        break;
                    }
                }
                return m;
            };

            return ServiceOptions;
        })();

        protobuf.MethodOptions = (function() {

            /**
             * Properties of a MethodOptions.
             * @memberof google.protobuf
             * @interface IMethodOptions
             * @property {boolean|null} [deprecated] MethodOptions deprecated
             * @property {Array.<google.protobuf.IUninterpretedOption>|null} [uninterpretedOption] MethodOptions uninterpretedOption
             * @property {boolean|null} [".common.allowJson"] MethodOptions .common.allowJson
             * @property {string|null} [".common.methodCalls"] MethodOptions .common.methodCalls
             * @property {string|null} [".common.httpMethod"] MethodOptions .common.httpMethod
             * @property {string|null} [".common.methodURI"] MethodOptions .common.methodURI
             */

            /**
             * Constructs a new MethodOptions.
             * @memberof google.protobuf
             * @classdesc Represents a MethodOptions.
             * @implements IMethodOptions
             * @constructor
             * @param {google.protobuf.IMethodOptions=} [p] Properties to set
             */
            function MethodOptions(p) {
                this.uninterpretedOption = [];
                if (p)
                    for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                        if (p[ks[i]] != null)
                            this[ks[i]] = p[ks[i]];
            }

            /**
             * MethodOptions deprecated.
             * @member {boolean} deprecated
             * @memberof google.protobuf.MethodOptions
             * @instance
             */
            MethodOptions.prototype.deprecated = false;

            /**
             * MethodOptions uninterpretedOption.
             * @member {Array.<google.protobuf.IUninterpretedOption>} uninterpretedOption
             * @memberof google.protobuf.MethodOptions
             * @instance
             */
            MethodOptions.prototype.uninterpretedOption = $util.emptyArray;

            /**
             * MethodOptions .common.allowJson.
             * @member {boolean} .common.allowJson
             * @memberof google.protobuf.MethodOptions
             * @instance
             */
            MethodOptions.prototype[".common.allowJson"] = false;

            /**
             * MethodOptions .common.methodCalls.
             * @member {string} .common.methodCalls
             * @memberof google.protobuf.MethodOptions
             * @instance
             */
            MethodOptions.prototype[".common.methodCalls"] = "";

            /**
             * MethodOptions .common.httpMethod.
             * @member {string} .common.httpMethod
             * @memberof google.protobuf.MethodOptions
             * @instance
             */
            MethodOptions.prototype[".common.httpMethod"] = "";

            /**
             * MethodOptions .common.methodURI.
             * @member {string} .common.methodURI
             * @memberof google.protobuf.MethodOptions
             * @instance
             */
            MethodOptions.prototype[".common.methodURI"] = "";

            /**
             * Creates a new MethodOptions instance using the specified properties.
             * @function create
             * @memberof google.protobuf.MethodOptions
             * @static
             * @param {google.protobuf.IMethodOptions=} [properties] Properties to set
             * @returns {google.protobuf.MethodOptions} MethodOptions instance
             */
            MethodOptions.create = function create(properties) {
                return new MethodOptions(properties);
            };

            /**
             * Encodes the specified MethodOptions message. Does not implicitly {@link google.protobuf.MethodOptions.verify|verify} messages.
             * @function encode
             * @memberof google.protobuf.MethodOptions
             * @static
             * @param {google.protobuf.IMethodOptions} m MethodOptions message or plain object to encode
             * @param {$protobuf.Writer} [w] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            MethodOptions.encode = function encode(m, w) {
                if (!w)
                    w = $Writer.create();
                if (m.deprecated != null && Object.hasOwnProperty.call(m, "deprecated"))
                    w.uint32(264).bool(m.deprecated);
                if (m.uninterpretedOption != null && m.uninterpretedOption.length) {
                    for (var i = 0; i < m.uninterpretedOption.length; ++i)
                        $root.google.protobuf.UninterpretedOption.encode(m.uninterpretedOption[i], w.uint32(7994).fork()).ldelim();
                }
                if (m[".common.allowJson"] != null && Object.hasOwnProperty.call(m, ".common.allowJson"))
                    w.uint32(400000).bool(m[".common.allowJson"]);
                if (m[".common.methodCalls"] != null && Object.hasOwnProperty.call(m, ".common.methodCalls"))
                    w.uint32(400018).string(m[".common.methodCalls"]);
                if (m[".common.httpMethod"] != null && Object.hasOwnProperty.call(m, ".common.httpMethod"))
                    w.uint32(400026).string(m[".common.httpMethod"]);
                if (m[".common.methodURI"] != null && Object.hasOwnProperty.call(m, ".common.methodURI"))
                    w.uint32(400042).string(m[".common.methodURI"]);
                return w;
            };

            /**
             * Decodes a MethodOptions message from the specified reader or buffer.
             * @function decode
             * @memberof google.protobuf.MethodOptions
             * @static
             * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
             * @param {number} [l] Message length if known beforehand
             * @returns {google.protobuf.MethodOptions} MethodOptions
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            MethodOptions.decode = function decode(r, l) {
                if (!(r instanceof $Reader))
                    r = $Reader.create(r);
                var c = l === undefined ? r.len : r.pos + l, m = new $root.google.protobuf.MethodOptions();
                while (r.pos < c) {
                    var t = r.uint32();
                    switch (t >>> 3) {
                    case 33:
                        m.deprecated = r.bool();
                        break;
                    case 999:
                        if (!(m.uninterpretedOption && m.uninterpretedOption.length))
                            m.uninterpretedOption = [];
                        m.uninterpretedOption.push($root.google.protobuf.UninterpretedOption.decode(r, r.uint32()));
                        break;
                    case 50000:
                        m[".common.allowJson"] = r.bool();
                        break;
                    case 50002:
                        m[".common.methodCalls"] = r.string();
                        break;
                    case 50003:
                        m[".common.httpMethod"] = r.string();
                        break;
                    case 50005:
                        m[".common.methodURI"] = r.string();
                        break;
                    default:
                        r.skipType(t & 7);
                        break;
                    }
                }
                return m;
            };

            return MethodOptions;
        })();

        protobuf.UninterpretedOption = (function() {

            /**
             * Properties of an UninterpretedOption.
             * @memberof google.protobuf
             * @interface IUninterpretedOption
             * @property {Array.<google.protobuf.UninterpretedOption.INamePart>|null} [name] UninterpretedOption name
             * @property {string|null} [identifierValue] UninterpretedOption identifierValue
             * @property {number|Long|null} [positiveIntValue] UninterpretedOption positiveIntValue
             * @property {number|Long|null} [negativeIntValue] UninterpretedOption negativeIntValue
             * @property {number|null} [doubleValue] UninterpretedOption doubleValue
             * @property {Uint8Array|null} [stringValue] UninterpretedOption stringValue
             * @property {string|null} [aggregateValue] UninterpretedOption aggregateValue
             */

            /**
             * Constructs a new UninterpretedOption.
             * @memberof google.protobuf
             * @classdesc Represents an UninterpretedOption.
             * @implements IUninterpretedOption
             * @constructor
             * @param {google.protobuf.IUninterpretedOption=} [p] Properties to set
             */
            function UninterpretedOption(p) {
                this.name = [];
                if (p)
                    for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                        if (p[ks[i]] != null)
                            this[ks[i]] = p[ks[i]];
            }

            /**
             * UninterpretedOption name.
             * @member {Array.<google.protobuf.UninterpretedOption.INamePart>} name
             * @memberof google.protobuf.UninterpretedOption
             * @instance
             */
            UninterpretedOption.prototype.name = $util.emptyArray;

            /**
             * UninterpretedOption identifierValue.
             * @member {string} identifierValue
             * @memberof google.protobuf.UninterpretedOption
             * @instance
             */
            UninterpretedOption.prototype.identifierValue = "";

            /**
             * UninterpretedOption positiveIntValue.
             * @member {number|Long} positiveIntValue
             * @memberof google.protobuf.UninterpretedOption
             * @instance
             */
            UninterpretedOption.prototype.positiveIntValue = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

            /**
             * UninterpretedOption negativeIntValue.
             * @member {number|Long} negativeIntValue
             * @memberof google.protobuf.UninterpretedOption
             * @instance
             */
            UninterpretedOption.prototype.negativeIntValue = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

            /**
             * UninterpretedOption doubleValue.
             * @member {number} doubleValue
             * @memberof google.protobuf.UninterpretedOption
             * @instance
             */
            UninterpretedOption.prototype.doubleValue = 0;

            /**
             * UninterpretedOption stringValue.
             * @member {Uint8Array} stringValue
             * @memberof google.protobuf.UninterpretedOption
             * @instance
             */
            UninterpretedOption.prototype.stringValue = $util.newBuffer([]);

            /**
             * UninterpretedOption aggregateValue.
             * @member {string} aggregateValue
             * @memberof google.protobuf.UninterpretedOption
             * @instance
             */
            UninterpretedOption.prototype.aggregateValue = "";

            /**
             * Creates a new UninterpretedOption instance using the specified properties.
             * @function create
             * @memberof google.protobuf.UninterpretedOption
             * @static
             * @param {google.protobuf.IUninterpretedOption=} [properties] Properties to set
             * @returns {google.protobuf.UninterpretedOption} UninterpretedOption instance
             */
            UninterpretedOption.create = function create(properties) {
                return new UninterpretedOption(properties);
            };

            /**
             * Encodes the specified UninterpretedOption message. Does not implicitly {@link google.protobuf.UninterpretedOption.verify|verify} messages.
             * @function encode
             * @memberof google.protobuf.UninterpretedOption
             * @static
             * @param {google.protobuf.IUninterpretedOption} m UninterpretedOption message or plain object to encode
             * @param {$protobuf.Writer} [w] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            UninterpretedOption.encode = function encode(m, w) {
                if (!w)
                    w = $Writer.create();
                if (m.name != null && m.name.length) {
                    for (var i = 0; i < m.name.length; ++i)
                        $root.google.protobuf.UninterpretedOption.NamePart.encode(m.name[i], w.uint32(18).fork()).ldelim();
                }
                if (m.identifierValue != null && Object.hasOwnProperty.call(m, "identifierValue"))
                    w.uint32(26).string(m.identifierValue);
                if (m.positiveIntValue != null && Object.hasOwnProperty.call(m, "positiveIntValue"))
                    w.uint32(32).uint64(m.positiveIntValue);
                if (m.negativeIntValue != null && Object.hasOwnProperty.call(m, "negativeIntValue"))
                    w.uint32(40).int64(m.negativeIntValue);
                if (m.doubleValue != null && Object.hasOwnProperty.call(m, "doubleValue"))
                    w.uint32(49).double(m.doubleValue);
                if (m.stringValue != null && Object.hasOwnProperty.call(m, "stringValue"))
                    w.uint32(58).bytes(m.stringValue);
                if (m.aggregateValue != null && Object.hasOwnProperty.call(m, "aggregateValue"))
                    w.uint32(66).string(m.aggregateValue);
                return w;
            };

            /**
             * Decodes an UninterpretedOption message from the specified reader or buffer.
             * @function decode
             * @memberof google.protobuf.UninterpretedOption
             * @static
             * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
             * @param {number} [l] Message length if known beforehand
             * @returns {google.protobuf.UninterpretedOption} UninterpretedOption
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            UninterpretedOption.decode = function decode(r, l) {
                if (!(r instanceof $Reader))
                    r = $Reader.create(r);
                var c = l === undefined ? r.len : r.pos + l, m = new $root.google.protobuf.UninterpretedOption();
                while (r.pos < c) {
                    var t = r.uint32();
                    switch (t >>> 3) {
                    case 2:
                        if (!(m.name && m.name.length))
                            m.name = [];
                        m.name.push($root.google.protobuf.UninterpretedOption.NamePart.decode(r, r.uint32()));
                        break;
                    case 3:
                        m.identifierValue = r.string();
                        break;
                    case 4:
                        m.positiveIntValue = r.uint64();
                        break;
                    case 5:
                        m.negativeIntValue = r.int64();
                        break;
                    case 6:
                        m.doubleValue = r.double();
                        break;
                    case 7:
                        m.stringValue = r.bytes();
                        break;
                    case 8:
                        m.aggregateValue = r.string();
                        break;
                    default:
                        r.skipType(t & 7);
                        break;
                    }
                }
                return m;
            };

            UninterpretedOption.NamePart = (function() {

                /**
                 * Properties of a NamePart.
                 * @memberof google.protobuf.UninterpretedOption
                 * @interface INamePart
                 * @property {string} namePart NamePart namePart
                 * @property {boolean} isExtension NamePart isExtension
                 */

                /**
                 * Constructs a new NamePart.
                 * @memberof google.protobuf.UninterpretedOption
                 * @classdesc Represents a NamePart.
                 * @implements INamePart
                 * @constructor
                 * @param {google.protobuf.UninterpretedOption.INamePart=} [p] Properties to set
                 */
                function NamePart(p) {
                    if (p)
                        for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                            if (p[ks[i]] != null)
                                this[ks[i]] = p[ks[i]];
                }

                /**
                 * NamePart namePart.
                 * @member {string} namePart
                 * @memberof google.protobuf.UninterpretedOption.NamePart
                 * @instance
                 */
                NamePart.prototype.namePart = "";

                /**
                 * NamePart isExtension.
                 * @member {boolean} isExtension
                 * @memberof google.protobuf.UninterpretedOption.NamePart
                 * @instance
                 */
                NamePart.prototype.isExtension = false;

                /**
                 * Creates a new NamePart instance using the specified properties.
                 * @function create
                 * @memberof google.protobuf.UninterpretedOption.NamePart
                 * @static
                 * @param {google.protobuf.UninterpretedOption.INamePart=} [properties] Properties to set
                 * @returns {google.protobuf.UninterpretedOption.NamePart} NamePart instance
                 */
                NamePart.create = function create(properties) {
                    return new NamePart(properties);
                };

                /**
                 * Encodes the specified NamePart message. Does not implicitly {@link google.protobuf.UninterpretedOption.NamePart.verify|verify} messages.
                 * @function encode
                 * @memberof google.protobuf.UninterpretedOption.NamePart
                 * @static
                 * @param {google.protobuf.UninterpretedOption.INamePart} m NamePart message or plain object to encode
                 * @param {$protobuf.Writer} [w] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                NamePart.encode = function encode(m, w) {
                    if (!w)
                        w = $Writer.create();
                    w.uint32(10).string(m.namePart);
                    w.uint32(16).bool(m.isExtension);
                    return w;
                };

                /**
                 * Decodes a NamePart message from the specified reader or buffer.
                 * @function decode
                 * @memberof google.protobuf.UninterpretedOption.NamePart
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
                 * @param {number} [l] Message length if known beforehand
                 * @returns {google.protobuf.UninterpretedOption.NamePart} NamePart
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                NamePart.decode = function decode(r, l) {
                    if (!(r instanceof $Reader))
                        r = $Reader.create(r);
                    var c = l === undefined ? r.len : r.pos + l, m = new $root.google.protobuf.UninterpretedOption.NamePart();
                    while (r.pos < c) {
                        var t = r.uint32();
                        switch (t >>> 3) {
                        case 1:
                            m.namePart = r.string();
                            break;
                        case 2:
                            m.isExtension = r.bool();
                            break;
                        default:
                            r.skipType(t & 7);
                            break;
                        }
                    }
                    if (!m.hasOwnProperty("namePart"))
                        throw $util.ProtocolError("missing required 'namePart'", { instance: m });
                    if (!m.hasOwnProperty("isExtension"))
                        throw $util.ProtocolError("missing required 'isExtension'", { instance: m });
                    return m;
                };

                return NamePart;
            })();

            return UninterpretedOption;
        })();

        protobuf.SourceCodeInfo = (function() {

            /**
             * Properties of a SourceCodeInfo.
             * @memberof google.protobuf
             * @interface ISourceCodeInfo
             * @property {Array.<google.protobuf.SourceCodeInfo.ILocation>|null} [location] SourceCodeInfo location
             */

            /**
             * Constructs a new SourceCodeInfo.
             * @memberof google.protobuf
             * @classdesc Represents a SourceCodeInfo.
             * @implements ISourceCodeInfo
             * @constructor
             * @param {google.protobuf.ISourceCodeInfo=} [p] Properties to set
             */
            function SourceCodeInfo(p) {
                this.location = [];
                if (p)
                    for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                        if (p[ks[i]] != null)
                            this[ks[i]] = p[ks[i]];
            }

            /**
             * SourceCodeInfo location.
             * @member {Array.<google.protobuf.SourceCodeInfo.ILocation>} location
             * @memberof google.protobuf.SourceCodeInfo
             * @instance
             */
            SourceCodeInfo.prototype.location = $util.emptyArray;

            /**
             * Creates a new SourceCodeInfo instance using the specified properties.
             * @function create
             * @memberof google.protobuf.SourceCodeInfo
             * @static
             * @param {google.protobuf.ISourceCodeInfo=} [properties] Properties to set
             * @returns {google.protobuf.SourceCodeInfo} SourceCodeInfo instance
             */
            SourceCodeInfo.create = function create(properties) {
                return new SourceCodeInfo(properties);
            };

            /**
             * Encodes the specified SourceCodeInfo message. Does not implicitly {@link google.protobuf.SourceCodeInfo.verify|verify} messages.
             * @function encode
             * @memberof google.protobuf.SourceCodeInfo
             * @static
             * @param {google.protobuf.ISourceCodeInfo} m SourceCodeInfo message or plain object to encode
             * @param {$protobuf.Writer} [w] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            SourceCodeInfo.encode = function encode(m, w) {
                if (!w)
                    w = $Writer.create();
                if (m.location != null && m.location.length) {
                    for (var i = 0; i < m.location.length; ++i)
                        $root.google.protobuf.SourceCodeInfo.Location.encode(m.location[i], w.uint32(10).fork()).ldelim();
                }
                return w;
            };

            /**
             * Decodes a SourceCodeInfo message from the specified reader or buffer.
             * @function decode
             * @memberof google.protobuf.SourceCodeInfo
             * @static
             * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
             * @param {number} [l] Message length if known beforehand
             * @returns {google.protobuf.SourceCodeInfo} SourceCodeInfo
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            SourceCodeInfo.decode = function decode(r, l) {
                if (!(r instanceof $Reader))
                    r = $Reader.create(r);
                var c = l === undefined ? r.len : r.pos + l, m = new $root.google.protobuf.SourceCodeInfo();
                while (r.pos < c) {
                    var t = r.uint32();
                    switch (t >>> 3) {
                    case 1:
                        if (!(m.location && m.location.length))
                            m.location = [];
                        m.location.push($root.google.protobuf.SourceCodeInfo.Location.decode(r, r.uint32()));
                        break;
                    default:
                        r.skipType(t & 7);
                        break;
                    }
                }
                return m;
            };

            SourceCodeInfo.Location = (function() {

                /**
                 * Properties of a Location.
                 * @memberof google.protobuf.SourceCodeInfo
                 * @interface ILocation
                 * @property {Array.<number>|null} [path] Location path
                 * @property {Array.<number>|null} [span] Location span
                 * @property {string|null} [leadingComments] Location leadingComments
                 * @property {string|null} [trailingComments] Location trailingComments
                 * @property {Array.<string>|null} [leadingDetachedComments] Location leadingDetachedComments
                 */

                /**
                 * Constructs a new Location.
                 * @memberof google.protobuf.SourceCodeInfo
                 * @classdesc Represents a Location.
                 * @implements ILocation
                 * @constructor
                 * @param {google.protobuf.SourceCodeInfo.ILocation=} [p] Properties to set
                 */
                function Location(p) {
                    this.path = [];
                    this.span = [];
                    this.leadingDetachedComments = [];
                    if (p)
                        for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                            if (p[ks[i]] != null)
                                this[ks[i]] = p[ks[i]];
                }

                /**
                 * Location path.
                 * @member {Array.<number>} path
                 * @memberof google.protobuf.SourceCodeInfo.Location
                 * @instance
                 */
                Location.prototype.path = $util.emptyArray;

                /**
                 * Location span.
                 * @member {Array.<number>} span
                 * @memberof google.protobuf.SourceCodeInfo.Location
                 * @instance
                 */
                Location.prototype.span = $util.emptyArray;

                /**
                 * Location leadingComments.
                 * @member {string} leadingComments
                 * @memberof google.protobuf.SourceCodeInfo.Location
                 * @instance
                 */
                Location.prototype.leadingComments = "";

                /**
                 * Location trailingComments.
                 * @member {string} trailingComments
                 * @memberof google.protobuf.SourceCodeInfo.Location
                 * @instance
                 */
                Location.prototype.trailingComments = "";

                /**
                 * Location leadingDetachedComments.
                 * @member {Array.<string>} leadingDetachedComments
                 * @memberof google.protobuf.SourceCodeInfo.Location
                 * @instance
                 */
                Location.prototype.leadingDetachedComments = $util.emptyArray;

                /**
                 * Creates a new Location instance using the specified properties.
                 * @function create
                 * @memberof google.protobuf.SourceCodeInfo.Location
                 * @static
                 * @param {google.protobuf.SourceCodeInfo.ILocation=} [properties] Properties to set
                 * @returns {google.protobuf.SourceCodeInfo.Location} Location instance
                 */
                Location.create = function create(properties) {
                    return new Location(properties);
                };

                /**
                 * Encodes the specified Location message. Does not implicitly {@link google.protobuf.SourceCodeInfo.Location.verify|verify} messages.
                 * @function encode
                 * @memberof google.protobuf.SourceCodeInfo.Location
                 * @static
                 * @param {google.protobuf.SourceCodeInfo.ILocation} m Location message or plain object to encode
                 * @param {$protobuf.Writer} [w] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Location.encode = function encode(m, w) {
                    if (!w)
                        w = $Writer.create();
                    if (m.path != null && m.path.length) {
                        w.uint32(10).fork();
                        for (var i = 0; i < m.path.length; ++i)
                            w.int32(m.path[i]);
                        w.ldelim();
                    }
                    if (m.span != null && m.span.length) {
                        w.uint32(18).fork();
                        for (var i = 0; i < m.span.length; ++i)
                            w.int32(m.span[i]);
                        w.ldelim();
                    }
                    if (m.leadingComments != null && Object.hasOwnProperty.call(m, "leadingComments"))
                        w.uint32(26).string(m.leadingComments);
                    if (m.trailingComments != null && Object.hasOwnProperty.call(m, "trailingComments"))
                        w.uint32(34).string(m.trailingComments);
                    if (m.leadingDetachedComments != null && m.leadingDetachedComments.length) {
                        for (var i = 0; i < m.leadingDetachedComments.length; ++i)
                            w.uint32(50).string(m.leadingDetachedComments[i]);
                    }
                    return w;
                };

                /**
                 * Decodes a Location message from the specified reader or buffer.
                 * @function decode
                 * @memberof google.protobuf.SourceCodeInfo.Location
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
                 * @param {number} [l] Message length if known beforehand
                 * @returns {google.protobuf.SourceCodeInfo.Location} Location
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Location.decode = function decode(r, l) {
                    if (!(r instanceof $Reader))
                        r = $Reader.create(r);
                    var c = l === undefined ? r.len : r.pos + l, m = new $root.google.protobuf.SourceCodeInfo.Location();
                    while (r.pos < c) {
                        var t = r.uint32();
                        switch (t >>> 3) {
                        case 1:
                            if (!(m.path && m.path.length))
                                m.path = [];
                            if ((t & 7) === 2) {
                                var c2 = r.uint32() + r.pos;
                                while (r.pos < c2)
                                    m.path.push(r.int32());
                            } else
                                m.path.push(r.int32());
                            break;
                        case 2:
                            if (!(m.span && m.span.length))
                                m.span = [];
                            if ((t & 7) === 2) {
                                var c2 = r.uint32() + r.pos;
                                while (r.pos < c2)
                                    m.span.push(r.int32());
                            } else
                                m.span.push(r.int32());
                            break;
                        case 3:
                            m.leadingComments = r.string();
                            break;
                        case 4:
                            m.trailingComments = r.string();
                            break;
                        case 6:
                            if (!(m.leadingDetachedComments && m.leadingDetachedComments.length))
                                m.leadingDetachedComments = [];
                            m.leadingDetachedComments.push(r.string());
                            break;
                        default:
                            r.skipType(t & 7);
                            break;
                        }
                    }
                    return m;
                };

                return Location;
            })();

            return SourceCodeInfo;
        })();

        protobuf.GeneratedCodeInfo = (function() {

            /**
             * Properties of a GeneratedCodeInfo.
             * @memberof google.protobuf
             * @interface IGeneratedCodeInfo
             * @property {Array.<google.protobuf.GeneratedCodeInfo.IAnnotation>|null} [annotation] GeneratedCodeInfo annotation
             */

            /**
             * Constructs a new GeneratedCodeInfo.
             * @memberof google.protobuf
             * @classdesc Represents a GeneratedCodeInfo.
             * @implements IGeneratedCodeInfo
             * @constructor
             * @param {google.protobuf.IGeneratedCodeInfo=} [p] Properties to set
             */
            function GeneratedCodeInfo(p) {
                this.annotation = [];
                if (p)
                    for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                        if (p[ks[i]] != null)
                            this[ks[i]] = p[ks[i]];
            }

            /**
             * GeneratedCodeInfo annotation.
             * @member {Array.<google.protobuf.GeneratedCodeInfo.IAnnotation>} annotation
             * @memberof google.protobuf.GeneratedCodeInfo
             * @instance
             */
            GeneratedCodeInfo.prototype.annotation = $util.emptyArray;

            /**
             * Creates a new GeneratedCodeInfo instance using the specified properties.
             * @function create
             * @memberof google.protobuf.GeneratedCodeInfo
             * @static
             * @param {google.protobuf.IGeneratedCodeInfo=} [properties] Properties to set
             * @returns {google.protobuf.GeneratedCodeInfo} GeneratedCodeInfo instance
             */
            GeneratedCodeInfo.create = function create(properties) {
                return new GeneratedCodeInfo(properties);
            };

            /**
             * Encodes the specified GeneratedCodeInfo message. Does not implicitly {@link google.protobuf.GeneratedCodeInfo.verify|verify} messages.
             * @function encode
             * @memberof google.protobuf.GeneratedCodeInfo
             * @static
             * @param {google.protobuf.IGeneratedCodeInfo} m GeneratedCodeInfo message or plain object to encode
             * @param {$protobuf.Writer} [w] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            GeneratedCodeInfo.encode = function encode(m, w) {
                if (!w)
                    w = $Writer.create();
                if (m.annotation != null && m.annotation.length) {
                    for (var i = 0; i < m.annotation.length; ++i)
                        $root.google.protobuf.GeneratedCodeInfo.Annotation.encode(m.annotation[i], w.uint32(10).fork()).ldelim();
                }
                return w;
            };

            /**
             * Decodes a GeneratedCodeInfo message from the specified reader or buffer.
             * @function decode
             * @memberof google.protobuf.GeneratedCodeInfo
             * @static
             * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
             * @param {number} [l] Message length if known beforehand
             * @returns {google.protobuf.GeneratedCodeInfo} GeneratedCodeInfo
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            GeneratedCodeInfo.decode = function decode(r, l) {
                if (!(r instanceof $Reader))
                    r = $Reader.create(r);
                var c = l === undefined ? r.len : r.pos + l, m = new $root.google.protobuf.GeneratedCodeInfo();
                while (r.pos < c) {
                    var t = r.uint32();
                    switch (t >>> 3) {
                    case 1:
                        if (!(m.annotation && m.annotation.length))
                            m.annotation = [];
                        m.annotation.push($root.google.protobuf.GeneratedCodeInfo.Annotation.decode(r, r.uint32()));
                        break;
                    default:
                        r.skipType(t & 7);
                        break;
                    }
                }
                return m;
            };

            GeneratedCodeInfo.Annotation = (function() {

                /**
                 * Properties of an Annotation.
                 * @memberof google.protobuf.GeneratedCodeInfo
                 * @interface IAnnotation
                 * @property {Array.<number>|null} [path] Annotation path
                 * @property {string|null} [sourceFile] Annotation sourceFile
                 * @property {number|null} [begin] Annotation begin
                 * @property {number|null} [end] Annotation end
                 */

                /**
                 * Constructs a new Annotation.
                 * @memberof google.protobuf.GeneratedCodeInfo
                 * @classdesc Represents an Annotation.
                 * @implements IAnnotation
                 * @constructor
                 * @param {google.protobuf.GeneratedCodeInfo.IAnnotation=} [p] Properties to set
                 */
                function Annotation(p) {
                    this.path = [];
                    if (p)
                        for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                            if (p[ks[i]] != null)
                                this[ks[i]] = p[ks[i]];
                }

                /**
                 * Annotation path.
                 * @member {Array.<number>} path
                 * @memberof google.protobuf.GeneratedCodeInfo.Annotation
                 * @instance
                 */
                Annotation.prototype.path = $util.emptyArray;

                /**
                 * Annotation sourceFile.
                 * @member {string} sourceFile
                 * @memberof google.protobuf.GeneratedCodeInfo.Annotation
                 * @instance
                 */
                Annotation.prototype.sourceFile = "";

                /**
                 * Annotation begin.
                 * @member {number} begin
                 * @memberof google.protobuf.GeneratedCodeInfo.Annotation
                 * @instance
                 */
                Annotation.prototype.begin = 0;

                /**
                 * Annotation end.
                 * @member {number} end
                 * @memberof google.protobuf.GeneratedCodeInfo.Annotation
                 * @instance
                 */
                Annotation.prototype.end = 0;

                /**
                 * Creates a new Annotation instance using the specified properties.
                 * @function create
                 * @memberof google.protobuf.GeneratedCodeInfo.Annotation
                 * @static
                 * @param {google.protobuf.GeneratedCodeInfo.IAnnotation=} [properties] Properties to set
                 * @returns {google.protobuf.GeneratedCodeInfo.Annotation} Annotation instance
                 */
                Annotation.create = function create(properties) {
                    return new Annotation(properties);
                };

                /**
                 * Encodes the specified Annotation message. Does not implicitly {@link google.protobuf.GeneratedCodeInfo.Annotation.verify|verify} messages.
                 * @function encode
                 * @memberof google.protobuf.GeneratedCodeInfo.Annotation
                 * @static
                 * @param {google.protobuf.GeneratedCodeInfo.IAnnotation} m Annotation message or plain object to encode
                 * @param {$protobuf.Writer} [w] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Annotation.encode = function encode(m, w) {
                    if (!w)
                        w = $Writer.create();
                    if (m.path != null && m.path.length) {
                        w.uint32(10).fork();
                        for (var i = 0; i < m.path.length; ++i)
                            w.int32(m.path[i]);
                        w.ldelim();
                    }
                    if (m.sourceFile != null && Object.hasOwnProperty.call(m, "sourceFile"))
                        w.uint32(18).string(m.sourceFile);
                    if (m.begin != null && Object.hasOwnProperty.call(m, "begin"))
                        w.uint32(24).int32(m.begin);
                    if (m.end != null && Object.hasOwnProperty.call(m, "end"))
                        w.uint32(32).int32(m.end);
                    return w;
                };

                /**
                 * Decodes an Annotation message from the specified reader or buffer.
                 * @function decode
                 * @memberof google.protobuf.GeneratedCodeInfo.Annotation
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
                 * @param {number} [l] Message length if known beforehand
                 * @returns {google.protobuf.GeneratedCodeInfo.Annotation} Annotation
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Annotation.decode = function decode(r, l) {
                    if (!(r instanceof $Reader))
                        r = $Reader.create(r);
                    var c = l === undefined ? r.len : r.pos + l, m = new $root.google.protobuf.GeneratedCodeInfo.Annotation();
                    while (r.pos < c) {
                        var t = r.uint32();
                        switch (t >>> 3) {
                        case 1:
                            if (!(m.path && m.path.length))
                                m.path = [];
                            if ((t & 7) === 2) {
                                var c2 = r.uint32() + r.pos;
                                while (r.pos < c2)
                                    m.path.push(r.int32());
                            } else
                                m.path.push(r.int32());
                            break;
                        case 2:
                            m.sourceFile = r.string();
                            break;
                        case 3:
                            m.begin = r.int32();
                            break;
                        case 4:
                            m.end = r.int32();
                            break;
                        default:
                            r.skipType(t & 7);
                            break;
                        }
                    }
                    return m;
                };

                return Annotation;
            })();

            return GeneratedCodeInfo;
        })();

        protobuf.Timestamp = (function() {

            /**
             * Properties of a Timestamp.
             * @memberof google.protobuf
             * @interface ITimestamp
             * @property {number|Long|null} [seconds] Timestamp seconds
             * @property {number|null} [nanos] Timestamp nanos
             */

            /**
             * Constructs a new Timestamp.
             * @memberof google.protobuf
             * @classdesc Represents a Timestamp.
             * @implements ITimestamp
             * @constructor
             * @param {google.protobuf.ITimestamp=} [p] Properties to set
             */
            function Timestamp(p) {
                if (p)
                    for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                        if (p[ks[i]] != null)
                            this[ks[i]] = p[ks[i]];
            }

            /**
             * Timestamp seconds.
             * @member {number|Long} seconds
             * @memberof google.protobuf.Timestamp
             * @instance
             */
            Timestamp.prototype.seconds = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

            /**
             * Timestamp nanos.
             * @member {number} nanos
             * @memberof google.protobuf.Timestamp
             * @instance
             */
            Timestamp.prototype.nanos = 0;

            /**
             * Creates a new Timestamp instance using the specified properties.
             * @function create
             * @memberof google.protobuf.Timestamp
             * @static
             * @param {google.protobuf.ITimestamp=} [properties] Properties to set
             * @returns {google.protobuf.Timestamp} Timestamp instance
             */
            Timestamp.create = function create(properties) {
                return new Timestamp(properties);
            };

            /**
             * Encodes the specified Timestamp message. Does not implicitly {@link google.protobuf.Timestamp.verify|verify} messages.
             * @function encode
             * @memberof google.protobuf.Timestamp
             * @static
             * @param {google.protobuf.ITimestamp} m Timestamp message or plain object to encode
             * @param {$protobuf.Writer} [w] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Timestamp.encode = function encode(m, w) {
                if (!w)
                    w = $Writer.create();
                if (m.seconds != null && Object.hasOwnProperty.call(m, "seconds"))
                    w.uint32(8).int64(m.seconds);
                if (m.nanos != null && Object.hasOwnProperty.call(m, "nanos"))
                    w.uint32(16).int32(m.nanos);
                return w;
            };

            /**
             * Decodes a Timestamp message from the specified reader or buffer.
             * @function decode
             * @memberof google.protobuf.Timestamp
             * @static
             * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
             * @param {number} [l] Message length if known beforehand
             * @returns {google.protobuf.Timestamp} Timestamp
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Timestamp.decode = function decode(r, l) {
                if (!(r instanceof $Reader))
                    r = $Reader.create(r);
                var c = l === undefined ? r.len : r.pos + l, m = new $root.google.protobuf.Timestamp();
                while (r.pos < c) {
                    var t = r.uint32();
                    switch (t >>> 3) {
                    case 1:
                        m.seconds = r.int64();
                        break;
                    case 2:
                        m.nanos = r.int32();
                        break;
                    default:
                        r.skipType(t & 7);
                        break;
                    }
                }
                return m;
            };

            return Timestamp;
        })();

        protobuf.Empty = (function() {

            /**
             * Properties of an Empty.
             * @memberof google.protobuf
             * @interface IEmpty
             */

            /**
             * Constructs a new Empty.
             * @memberof google.protobuf
             * @classdesc Represents an Empty.
             * @implements IEmpty
             * @constructor
             * @param {google.protobuf.IEmpty=} [p] Properties to set
             */
            function Empty(p) {
                if (p)
                    for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                        if (p[ks[i]] != null)
                            this[ks[i]] = p[ks[i]];
            }

            /**
             * Creates a new Empty instance using the specified properties.
             * @function create
             * @memberof google.protobuf.Empty
             * @static
             * @param {google.protobuf.IEmpty=} [properties] Properties to set
             * @returns {google.protobuf.Empty} Empty instance
             */
            Empty.create = function create(properties) {
                return new Empty(properties);
            };

            /**
             * Encodes the specified Empty message. Does not implicitly {@link google.protobuf.Empty.verify|verify} messages.
             * @function encode
             * @memberof google.protobuf.Empty
             * @static
             * @param {google.protobuf.IEmpty} m Empty message or plain object to encode
             * @param {$protobuf.Writer} [w] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Empty.encode = function encode(m, w) {
                if (!w)
                    w = $Writer.create();
                return w;
            };

            /**
             * Decodes an Empty message from the specified reader or buffer.
             * @function decode
             * @memberof google.protobuf.Empty
             * @static
             * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
             * @param {number} [l] Message length if known beforehand
             * @returns {google.protobuf.Empty} Empty
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Empty.decode = function decode(r, l) {
                if (!(r instanceof $Reader))
                    r = $Reader.create(r);
                var c = l === undefined ? r.len : r.pos + l, m = new $root.google.protobuf.Empty();
                while (r.pos < c) {
                    var t = r.uint32();
                    switch (t >>> 3) {
                    default:
                        r.skipType(t & 7);
                        break;
                    }
                }
                return m;
            };

            return Empty;
        })();

        return protobuf;
    })();

    return google;
})();

export { $root as default };
